import { reinitialiserCamera } from '../scene-manager.js';
import * as THREE from 'three';
import { Visualizer } from '../visualizer.js';
import { getCandidate, OFFERTES_A_LA_MAIN } from '../visualizer-registry.js';
import { stageRig } from '../lighting/stage-light-rig.js';
import { DustLayer } from '../particle-layers/dust-layer.js';
import { StormLayer } from '../particle-layers/storm-layer.js';
import { SpotWallVisualizer } from './spot-wall.js';
import { NeonGridVisualizer } from './neon-grid.js';
import { DiscoSquaresVisualizer } from './disco-squares.js';
import { NeonParticlesVisualizer } from './neon-particles.js';
import { DaftPyramidVisualizer } from './daft-pyramid.js';
import { PulseCoreVisualizer } from './pulse-core.js';
import { KineticRigVisualizer } from './kinetic-rig.js';
import { LaserCathedralVisualizer } from './laser-cathedral.js';
import { LaserGridVisualizer } from './laser-grid.js';
import { MainStageVisualizer } from './main-stage.js';
import { KaleidoDriftVisualizer } from './kaleido-drift.js';
import { TypeSlamVisualizer } from './type-slam.js';
import { VinylGrooveVisualizer } from './vinyl-groove.js';
import { ChromeFluxVisualizer } from './chrome-flux.js';
import { PhosphorScopeVisualizer } from './phosphor-scope.js';
import { ConstellationVisualizer } from './constellation.js';
import { DrosteDiveVisualizer } from './droste-dive.js';
import { TunnelVisualizer } from './tunnel.js';
import { NeonPulseVisualizer } from './neon-pulse.js';
import { ResonanceVisualizer } from './resonance.js';
import { SumiVisualizer } from './sumi.js';
import { LoomVisualizer } from './loom.js';
import { HalftoneVisualizer } from './halftone.js';
import { CausticsVisualizer } from './caustics.js';
import { AuroraVisualizer } from './aurora.js';
import { FrostVisualizer } from './frost.js';
import { ReedVisualizer } from './reed.js';
import { AnamorphVisualizer } from './anamorph.js';
import { PortalVisualizer } from './portal.js';
import { EchoVisualizer } from './echo.js';
import { PresetVisualizer } from './preset.js';
import { SilkVisualizer } from './silk.js';
import { ShatterVisualizer } from './shatter.js';
import { InfinityVisualizer } from './infinity.js';
import { EmberVisualizer } from './ember.js';
import { LichtenbergVisualizer } from './lichtenberg.js';
import { OrigamiVisualizer } from './origami.js';
import { SwarmVisualizer } from './swarm.js';
import { NebulaVisualizer } from './nebula.js';
import { OceanVisualizer } from './ocean.js';
import { TuringVisualizer } from './turing.js';
import { PyroVisualizer } from './pyro.js';
import { CascadeVisualizer } from './cascade.js';
import { MoshVisualizer } from './mosh.js';
import { StrobeWallVisualizer } from './strobewall.js';
import { BeamWallVisualizer } from './beamwall.js';
import { KelpVisualizer } from './kelp.js';
import { PosterVisualizer } from './poster.js';
import { CountdownVisualizer } from './countdown.js';
import { FirefliesVisualizer } from './fireflies.js';
import { PolytopeVisualizer } from './polytope.js';
import { CycleVisualizer } from './cycle.js';
import { ThermalVisualizer } from './thermal.js';
import { WarehouseVisualizer } from './warehouse.js';
import { SunroomVisualizer } from './sunroom.js';
import { MatrixVisualizer } from './matrix.js';
import { FairgroundVisualizer } from './fairground.js';
import { HaloVisualizer } from './halo.js';
import { PinscreenVisualizer } from './pinscreen.js';
import { MoonlakeVisualizer } from './moonlake.js';
import { BalloonsVisualizer } from './balloons.js';
import { DandelionVisualizer } from './dandelion.js';
import { TruchetVisualizer } from './truchet.js';
import { MurmurationVisualizer } from './murmuration.js';
import { Neonsign2Visualizer } from './neonsign2.js';
import { BokehVisualizer } from './bokeh.js';
import { HourglassVisualizer } from './hourglass.js';
import { ChladniVisualizer } from './chladni.js';
import { FerroVisualizer } from './ferro.js';
import { FractalVisualizer } from './fractal.js';
import { PoolsideVisualizer } from './poolside.js';
import { MagnetoVisualizer } from './magneto.js';
import { AcidVisualizer } from './acid.js';
import { CyberflightVisualizer } from './cyberflight.js';
import { MazeVisualizer } from './maze.js';
import { SunburstVisualizer } from './sunburst.js';
import { WavefieldVisualizer } from './wavefield.js';
import { ContoursVisualizer } from './contours.js';
import { SeasonsVisualizer } from './seasons.js';
import { IsocubesVisualizer } from './isocubes.js';
import { DatamoshVisualizer } from './datamosh.js';
import { TvwallVisualizer } from './tvwall.js';
import { ComicVisualizer } from './comic.js';
import { BlacklightVisualizer } from './blacklight.js';
import { CellsVisualizer } from './cells.js';
import { PixelsortVisualizer } from './pixelsort.js';
import { VideoloopVisualizer } from './videoloop.js';
import { GalaxyVisualizer } from './galaxy.js';
import { MoireVisualizer } from './moire.js';
import { FormationVisualizer } from './formation.js';
import { FacetsVisualizer } from './facets.js';
import { PyromusicalVisualizer } from './pyromusical.js';
import { ThunderheadVisualizer } from './thunderhead.js';
import { CloudseaVisualizer } from './cloudsea.js';
import { ShapesVisualizer } from './shapes.js';
import { StadiumVisualizer } from './stadium.js';
import { RainwindowVisualizer } from './rainwindow.js';
import { HifiVisualizer } from './hifi.js';
import { WooferVisualizer } from './woofer.js';
import { LiquidLightVisualizer } from './liquidlight.js';
import { KineticRig2Visualizer } from './kinetic-rig2.js';
import { SteamVisualizer } from './steam.js';
import { MaelstromVisualizer } from './maelstrom.js';
import { NightdriveVisualizer } from './nightdrive.js';
import { KaleidoVisualizer } from './kaleido.js';
import { TesselVisualizer } from './tessel.js';
import { FocusVisualizer } from './focus.js';
import { SplitflapVisualizer } from './splitflap.js';
import { GalleryVisualizer } from './gallery.js';
import { ShojiVisualizer } from './shoji.js';
import { SandVisualizer } from './sand.js';
import { PrismVisualizer } from './prism.js';
import { PortalsVisualizer } from './portals.js';
import { AdvectVisualizer } from './advect.js';
import { RaveSignVisualizer } from './ravesign.js';
import { AirframeVisualizer } from './airframe.js';
import { VertigoVisualizer } from './vertigo.js';
import { LanternVisualizer } from './lantern.js';
import { BayfrontVisualizer } from './bayfront.js';
import { SignalVisualizer } from './signal.js';
import { LighthouseVisualizer } from './lighthouse.js';
import { JellyfishVisualizer } from './jellyfish.js';
import { PendulaVisualizer } from './pendula.js';
import { TexerVisualizer } from './texer.js';
import { OutrunVisualizer } from './outrun.js';
import { PanelsVisualizer } from './panels.js';
import { BubbleVisualizer } from './bubble.js';
import { BallroomVisualizer } from './ballroom.js';
import { FlowmapVisualizer } from './flowmap.js';
import { TotemVisualizer } from './totem.js';
import { RibbonsVisualizer } from './ribbons.js';
import { ShockwaveVisualizer } from './shockwave.js';
import { InkVisualizer } from './ink.js';
import { DronesVisualizer } from './drones.js';
import { AspenVisualizer } from './aspen.js';
import { MirrorArrayVisualizer } from './mirrorarray.js';
import { NeonAlleyVisualizer } from './neonalley.js';
import { UndergroundVisualizer } from './underground.js';
import { FramesVisualizer } from './frames.js';
import { FlameVisualizer } from './flame.js';
import { KoiVisualizer } from './koi.js';
import { TeslaVisualizer } from './tesla.js';
import { PulsarVisualizer } from './pulsar.js';
import { SkylineVisualizer } from './skyline.js';
import { ArcadeVisualizer } from './arcade.js';
import { BloomVisualizer } from './bloom.js';
import { LightpaintVisualizer } from './lightpaint.js';
import { KintsugiVisualizer } from './kintsugi.js';
import { HarpVisualizer } from './harp.js';
import { FountainVisualizer } from './fountain.js';
import { StartrailsVisualizer } from './startrails.js';
import { GlowtideVisualizer } from './glowtide.js';
import { PinballVisualizer } from './pinball.js';
import { LightcyclesVisualizer } from './lightcycles.js';
import { HyperloopVisualizer } from './hyperloop.js';
import { MandalaVisualizer } from './mandala.js';
import { EclipseVisualizer } from './eclipse.js';
import { PaneVisualizer } from './pane.js';
import { Splitflap2Visualizer } from './splitflap2.js';
import { HeadlinerVisualizer } from './headliner.js';
import { HangarVisualizer } from './hangar.js';
import { GoldenhourVisualizer } from './goldenhour.js';
import { HyperspaceVisualizer } from './hyperspace.js';
import { DancefloorVisualizer } from './dancefloor.js';
import { MixdeckVisualizer } from './mixdeck.js';
import { TypeclashVisualizer } from './typeclash.js';
import { DominoVisualizer } from './domino.js';
import { TwistVisualizer } from './twist.js';
import { JukeboxVisualizer } from './jukebox.js';
import { PipesVisualizer } from './pipes.js';
import { GyroVisualizer } from './gyro.js';
import { SlitscanVisualizer } from './slitscan.js';
import { JuliaVisualizer } from './julia.js';
import { BlackholeVisualizer } from './blackhole.js';
import { MyceliumVisualizer } from './mycelium.js';
import { PenroseVisualizer } from './penrose.js';
import { ChromeflowVisualizer } from './chromeflow.js';
import { DissolveVisualizer } from './dissolve.js';
import { GlassVisualizer } from './glass.js';
import { GlyphsVisualizer } from './glyphs.js';
import { BubblesVisualizer } from './bubbles.js';
import { BauhausVisualizer } from './bauhaus.js';
import { MetroVisualizer } from './metro.js';
import { ZoetropeVisualizer } from './zoetrope.js';
import { MorphVisualizer } from './morph.js';
import { BranchesVisualizer } from './branches.js';
import { MobiusVisualizer } from './mobius.js';
import { DoorwaysVisualizer } from './doorways.js';
import { CymaticsVisualizer } from './cymatics.js';
import { LeviathanVisualizer } from './leviathan.js';
import { RingsVisualizer } from './rings.js';
import { PoincareVisualizer } from './poincare.js';
import { OilshowVisualizer } from './oilshow.js';
import { KineticVisualizer } from './kinetic.js';
import { HazeVisualizer } from './haze.js';
import { BorealisVisualizer } from './borealis.js';
import { LedcubeVisualizer } from './ledcube.js';
import { Scope3DVisualizer } from './scope3d.js';
import { HexVisualizer } from './hex.js';
import { MetronomeVisualizer } from './metronome.js';
import { RosaceVisualizer } from './rosace.js';
import { IncenseVisualizer } from './incense.js';
import { LoxodromeVisualizer } from './loxodrome.js';
import { HyperbolicVisualizer } from './hyperbolic.js';
import { TesseraVisualizer } from './tessera.js';
import { BlueprintVisualizer } from './blueprint.js';
import { noterExposition } from '../diversite.js';
import { selectVisualizations, computeCompositionDuration, computeDanceabilityDwellSeconds, selectDanceabilityPool, libraryForTier, libraryForTrack, requirementFailure, LIBRARY as BIBLIOTHEQUE, planIntensite } from '../orchestrator.js';
import { dropsAhead, porteDepuisProfil, MIN_VISUEL_MS, COUNTDOWN_MAX_BEATS } from '../track-analysis.js';
import { BEATS_PER_PHRASE } from '../beat-grid.js';
import { resolveDanceabilityIndex } from '../sonos-visual-profile.js';

// radiopi's danceability index for this track, 0..1, or null when nothing has
// arrived yet. The precedence between the payload's fields lives in
// sonos-visual-profile.js and is imported rather than repeated: the debug
// panel resolves the same number to paint its pool, and two copies of this
// rule would eventually disagree about which visualizers are eligible.
// LE RÉGLAGE DE L'UTILISATEUR (console, zone « Configuration ») entre ICI et
// nulle part ailleurs. Tous les points où l'orchestration consulte la
// dansabilité passent par danceIndex — le vivier, la décision, les flèches, la
// grille VDJ — donc un mode forcé ou un décalage d'énergie posé ici vaut
// partout d'un coup, sans qu'on ait à retrouver chaque appel.
//
// Module-level, pas sur l'instance : AdaptiveParty est recréé à chaque
// setVisualizer, et le réglage doit survivre à ça.
const REGLAGE = { indiceForce: null, decalage: 0 };

export function reglerDansabilite(r) {
  REGLAGE.indiceForce = r && Number.isFinite(r.indiceForce) ? r.indiceForce : null;
  REGLAGE.decalage = r && Number.isFinite(r.decalage) ? r.decalage : 0;
}

// Exporté pour le panneau de debug de l'écran (marquerVivier dans play-boot),
// qui peignait son vivier depuis resolveDanceabilityIndex : avec un mode forcé
// il aurait marqué douze cases que l'orchestration ne joue plus.
export function indiceDansabiliteReglee(profile) { return danceIndex(profile); }

function danceIndex(profile) {
  const base = REGLAGE.indiceForce != null ? REGLAGE.indiceForce : resolveDanceabilityIndex(profile);
  if (base == null) return base;
  return Math.max(0, Math.min(1, base + REGLAGE.decalage));
}

// The seed the pool's tie-break draws on. trackChangedAt - the instant this
// PLAY started - not the track id: seeded on the id, a track you come back to
// draws the same seven every single time, and on a coarse danceability scale
// (fourteen entries share 0.3) that is half its tier locked out for that
// track for good. Keyed to the play instead, every listen re-draws.
//
// It must not be a fresh random per CALL, though: the pool is recomputed every
// few seconds while a track runs, and a pool that churned under the rotation
// would make the hysteresis and recency rules meaningless. trackChangedAt is
// constant for exactly one play, which is the interval wanted.
function danceSeed(profile) {
  if (!profile) return '';
  return String(profile.trackId) + '|' + String(profile.trackChangedAt);
}

// Shared-rig contract (see the framing addendum): this visualizer's
// declared relationship to the one shared StageLightRig instance, and the
// beam intensity it asks for. Most restrictive wins across owners.
const RIG = 'required';
const RIG_OWNER = 'adaptiveparty-particles';
const RIG_INTENSITY_SCALE = 1;
const RIG_ZONES = 'default';
// Same lit-floor treatment as neon-pulse.js/kinetic-rig.js: relaxes the rig's
// spot falloff (decay 2.4 -> 1.1) so beams actually reach the ground and draw
// pools on it instead of arriving divided by ~170.
const RIG_FLOOR_LIGHT_BOOST = 3;
export { RIG };

// AdaptivePartyVisualizer: the real "Party Mode" experience - consumes
// orchestrator.js's decisions to pick, combine, and time transitions
// between the approved visuals (rig + dust/storm/spotwall/neongrid/
// discosquares/neonparticles) instead of NeonPulse's own fixed random
// cycling. This class only composes/disposes each visual's existing
// public init/update/dispose surface into the shared scene, exactly like
// neon-pulse.js already does for its own dust/storm/streak layer-cycling
// - the one exception is SpotWallVisualizer, which gained a small opt-in
// constructor flag (includeRig, defaults true/unchanged) so this class
// can ask for it without its own internal rig - see spot-wall.js.
//
// Composition rules (see orchestrator.js's LIBRARY/selectVisualizations
// for the actual scoring; this file only acts on its output):
//  - insufficient/missing track data -> delegate wholesale to a plain,
//    unmodified NeonPulseVisualizer instance (its own existing random
//    dust/storm/streak cycling IS "le comportement aleatoire actuel").
//  - 'spotwall' chosen -> SpotWallVisualizer with includeRig:false - a
//    full rig on top of its own full-screen spot grid read as "trop".
//  - 'neongrid'/'discosquares' chosen -> as-is, no rig (same reason -
//    neither ever had one).
//  - 'pulsecore' chosen -> as-is, WITH its own rig. Its rewrite had
//    dropped an earlier version's rig deliberately; it was asked back in
//    ("Pulscore: ajoute les RIGS") and PulseCore now acquires it itself,
//    at a reduced intensityScale so the beams and the rings share one
//    brightness budget rather than adding up to white - see pulse-core.js.
//  - 'neonparticles' chosen -> as-is, WITH its
//    own rig - unlike neongrid/discosquares, it manages a
//    StageLightRig internally (same plain setup as NeonPulse's), so
//    getLightRig() below reaches into it rather than returning null.
//  - 'dust'/'storm'/both chosen -> this class's own persistent rig+floor+
//    camera (NeonPulse's exact framing) with DustLayer and/or StormLayer
//    layered on top - the only case where genuine 2-layer superposition
//    happens, since these two layers were already designed to coexist,
//    and the one mode where the rig stays present.
//
// DaftPyramid is a plain LIBRARY entry like every other visual here (see
// orchestrator.js) - scored the same way on bpm/energy/movement/tonality
// fit, reachable for any track, not gated to a specific artist. An
// earlier version restricted it to only ever appear on tracks by "Daft
// Punk" specifically - reverted per explicit follow-up ("rotation pour
// tous, pas que les titres de daft punk").
//
// Transitions: a hard cut, no black hold in between - the old composition
// is disposed and the new one built in the same synchronous call, so
// nothing ever renders an empty scene. An earlier version held on black
// for a moment first (its length driven by orchestrator.js's fadeSeconds)
// to read as more of a deliberate dissolve than a jarring pop, but that
// read as an unwanted blackout rather than a transition - fadeSeconds is
// no longer used here (see orchestrator.js, which still returns it, just
// unconsumed on this end).

const PARTICLES_CAMERA_POSITION = [0, 2.6, 7];
const PARTICLES_LOOK_AT = [0, 2, 0];
const FALLBACK_RECHECK_S = 12; // how often 'fallback' mode checks whether real track data has since arrived
// CHANTIER 5 - how far back selectVisualizations' own recency penalty
// looks (its two tiers are "last 4" / "last 8" - nothing past that matters,
// so nothing past that needs to be kept either).
const HISTORY_LENGTH = 8;

// CHANTIER 6 - music-locked transitions. armSwap() decides WHAT/HOW without
// applying it; the actual swap fires on the next PHRASE downbeat.
// If that downbeat is further away than this, or bpm is unknown, apply
// immediately instead (a swap that waits a genuinely long time reads as
// "stuck", not "musical").
const MAX_WAIT_FOR_DOWNBEAT_S = 6;
// Pre-roll window, in beats before the downbeat - director.intensity is
// boosted through this window so the outgoing composition visibly "winds
// up" into the cut rather than the transition arriving cold.
const PREROLL_BEATS = 2;
const PREROLL_INTENSITY_BOOST = 0.25;
const BLACK_HOLD_FRAMES = 2;
const PUSH_DISTANCE = 0.6; // world units
const PUSH_BEATS = 2;
const PUSH_FALLBACK_DURATION_S = 0.6; // used when bpm is unknown (PUSH is only ever armed with a known bpm in practice, but stay safe)

// radiopi mark taxonomy (see track-analysis.js's selectMarks) - score
// thresholds and family constraints for each response tier. A mark is one
// of {type: 'drop'|'phrase'|'rise'|'fall'|'mix_in'|'mix_out', score}, and
// since engine 1.1.1 may carry the LEVEL of the phrase it opens
// ('low'|'mid'|'high', plus energy 0-100) - see MARK_BANDS.
// LA BANDE D'ÉNERGIE DE LA PHRASE. Quand le mark dit le niveau de la phrase
// qui commence, le choix se fait DANS le vivier, mais parmi les visuels de
// la bande : ≤ 0,4 d'énergie pour une phrase low, ≥ 0,65 pour high, entre
// les deux pour mid (l'énergie d'un visuel est le champ « Énergie » du
// catalogue). Le tirage pondéré reste pour la variété ; si la bande est
// vide dans le vivier, l'orchestrateur reprend tout le vivier (sa garde).
const MARK_BANDS = { low: { max: 0.4 }, mid: { min: 0.4, max: 0.65 }, high: { min: 0.65 } };
const MARK_DROP_STRONG_SCORE = 0.85;
const MARK_MEDIUM_SCORE = 0.6;
const MARK_STRONG_ENERGY_MIN = 0.75; // pool constraint for a strong drop
const MARK_CALM_ENERGY_MAX = 0.5;    // pool constraint for a fall/breakdown
// "Montée faible" push response - no swap, just a temporary intensity
// lift, same idea as PREROLL_INTENSITY_BOOST above but triggered by a real
// (if modest) moment in the track rather than proximity to an armed swap.
const MARK_PUSH_INTENSITY_BOOST = 0.30;
const MARK_PUSH_BEATS = 2;
const MARK_PUSH_FALLBACK_DURATION_S = 0.6;
// Phase 4 anticipation - how many beats ahead of a KNOWN strong drop/fall
// to start ramping preRollIntensity. Distinct from PREROLL_BEATS/
// PREROLL_INTENSITY_BOOST above (that one only ever covers the last couple
// beats before ANY armed swap fires); this one is a longer, deliberate
// windup toward a drop the timeline already knows is coming.
const MARK_DROP_PREROLL_BEATS = 4;
const MARK_DROP_PREROLL_PEAK = 1.35;
const MARK_FALL_PREROLL_BEATS = 2;
const MARK_FALL_PREROLL_TROUGH = 0.7;
// Filler transitions - analysisOnlyMode swaps ONLY at marks by design
// (chantier 6, revision), but real marks can be sparse: gaps of 30-45s
// between consecutive marks were common on a real track (Wiseguys),
// leaving long stretches with no visual change at all. When the next
// known mark is further out than FILLER_MIN_S allows, a plain transition
// (hysteresis/family fully relaxed, so it's guaranteed to actually
// differ from the incumbent, not just attempt to) fills the gap instead -
// same general cadence as a real mark, just not tied to a specific
// musical instant, so it uses the normal phrase-lock wait rather than
// beat-alignment.
const FILLER_MIN_S = 20;
// Orchestration priority rule: radiopi's own sequencing (marks) stays the
// priority for rotation timing whenever it exists. Both cases where it
// cannot drive timing - no analysisTimeline at all (see the no-analysis
// fallback below), or a mark gap wide enough that a filler has to cover it
// (this file) - fall back to computeDanceabilityDwellSeconds instead of a
// flat window: the less danceable the track, the longer the same
// composition is left up, up to this ceiling. Also doubles as the filler's
// hard-ceiling safety net (see hardCeilingDue below) - the gap between two
// real swaps must never exceed this regardless of how the soft,
// danceability-driven target lands.
const DANCEABILITY_DWELL_MAX_S = 60;
// Hard-ceiling fallback's own, much tighter disqualifier - "the next mark
// is basically about to fire itself" vs the soft check's "the next mark
// is coming up on a similar timescale, let it handle this". Without this
// distinction the hard ceiling could keep deferring to a mark that's
// still 10-15s out, letting the gap run past DANCEABILITY_DWELL_MAX_S anyway.
// 10 s, pas 3 (29/09/2026) : un filler parti 3 s avant un point ne laissait
// vivre son visuel que 3 s. Aucun visuel ne tient moins de MIN_VISUEL_MS.
const FILLER_MARK_IMMINENT_MS = MIN_VISUEL_MS;

// Weighted by director.mode at the moment a swap is ARMED (not re-rolled
// later) - CUT is the brief's own explicit default, favored everywhere;
// the other three lean into whichever mode they read as best matching
// (FLASH/PUSH for build/drop's own energy, BLACK for breakdown's pause).
const TRANSITION_WEIGHTS = {
  intro: { CUT: 0.85, FLASH: 0.05, BLACK: 0.05, PUSH: 0.05 },
  build: { CUT: 0.55, FLASH: 0.20, BLACK: 0.05, PUSH: 0.20 },
  drop: { CUT: 0.45, FLASH: 0.30, BLACK: 0.05, PUSH: 0.20 },
  breakdown: { CUT: 0.60, FLASH: 0.05, BLACK: 0.30, PUSH: 0.05 },
  sustain: { CUT: 0.70, FLASH: 0.10, BLACK: 0.05, PUSH: 0.15 },
  outro: { CUT: 0.70, FLASH: 0.05, BLACK: 0.20, PUSH: 0.05 }
};
const DEFAULT_TRANSITION_WEIGHTS = { CUT: 0.75, FLASH: 0.10, BLACK: 0.05, PUSH: 0.10 };

// LE FONDU DES TITRES CALMES (27/09/2026). Every transition type above ends
// in a hard cut, which the beat hides on a dance track and nothing hides on
// a calm one. Below FADE_MID_MAX of danceability, every swap - mark,
// filler, danceability recheck, whatever type it was armed with - becomes
// a real crossfade instead (see crossfade-pass.js): the outgoing
// composition's last frame is kept and faded out over the new one, which
// is already running underneath.
//   calm (< FADE_CALM_MAX): over FADE_CALM_BEATS, held to 4-8 s
//   middle (< FADE_MID_MAX): over FADE_MID_BEATS
//   dance (>= FADE_MID_MAX): the transitions above, unchanged
// Exceptions that stay instant: a strong measured drop (a known drop must be
// seen - FLASH), an eviction, a tier rebuild, the first composition. A
// "fall" armed as BLACK fades WITH a dip (a real trough, not a two-frame
// blink), and the incoming composition's intensity rises from half over a
// bar so it settles in rather than arriving at full energy.
const FADE_CALM_MAX = 0.45;
const FADE_MID_MAX = 0.70;
const FADE_CALM_BEATS = 8;
const FADE_CALM_S = [4, 8];
const FADE_MID_BEATS = 2;
const FADE_MID_S = [0.6, 1.6];
const FADE_INTRO_FROM = 0.5;
const FADE_INTRO_BEATS = 4;

// COUNTDOWN : UNE FOIS PAR MORCEAU, SUR LE DROP LE PLUS INTENSE, 12 TEMPS AU
// PLUS (27/09/2026, demande utilisateur ; en temps et non en secondes depuis le
// 29/09/2026 - le nombre du panneau est un nombre de temps). Il n'est jamais tiré dans le vivier (sa
// porte, requires.dropTrigger, le refuse au tirage ordinaire). Le morceau a un
// seul drop visé, profile.analysisTimeline.countdownTarget (track-analysis.js :
// le plus intense parmi ceux de score >= 0,85). On le lance vers lui, soit par
// son point de mix (drop très sûr), soit par la fenêtre : au plus
// COUNTDOWN_MAX_BEATS temps (3 mesures entières) avant le drop, jamais moins
// de 8 (countdown.js, minBeatsUntilNextDrop). Une fois lancé, il TIENT jusqu'au
// drop, dont le FLASH le remplace - le compte tombe à zéro sur la coupe. S'il
// est encore à l'écran une demi-seconde après l'heure de son drop (drop
// manqué, recalé), un remplissage le remplace aussitôt. Une seule fois par
// morceau : _countdownJoue, remis à zéro au changement de titre.
const COUNTDOWN_ID = 'countdown';
// VISUALS WHOSE GESTURE IS THE DROP (29/09/2026). Shatter vibrates, cracks on
// the last beat, and explodes ON the drop - and a strong drop used to change
// the composition on that very frame, so the pane was seen cracking and never
// seen breaking. While one of these is on screen, a drop is left to it: no
// swap at the drop, and nothing replaces it for DROP_GESTURE_HOLD_S after it
// (the burst and the flight; the return has begun). Then the next mark or a
// filler takes over as usual.
// Panels too: four beats of noise, scatter, and the cover whole ON the drop.
// Bubble: the film bursts on the drop and a new one is tensioned.
const DROP_GESTURE_IDS = new Set(['shatter', 'pane', 'splitflap2', 'headliner', 'hangar', 'goldenhour', 'hyperspace', 'dancefloor', 'panels', 'bubble', 'preset']);
const DROP_GESTURE_HOLD_S = 6;
// Beats between now and a drop msUntil away, on the track's tempo - what
// countdown.js's beat-based gate reads. null without a tempo.
function beatsUntil(profile, msUntil) {
  const bpm = profile && profile.trackFeatures && profile.trackFeatures.bpm;
  return bpm && msUntil != null ? msUntil * bpm / 60000 : null;
}

// The mix point skips the pool check, but not the register: under this
// danceability a track does not get a countdown, however certain its drop.
const COUNTDOWN_MIN_DANCE = 0.6;

// CHANTIER 7 - which _mode keys were built with a qualityTier option at
// all (see _buildComposition) - only these get rebuilt when the governor
// changes tier (see _tickQualityTier). Everything else has no notion of
// tiers and has nothing to rebuild.
// Deliberately NOT here: 'gallery'. Rebuilding a composition on a tier change
// is right for everything that pays its cost per pixel, but gallery.js's whole
// premise is one photograph per track that does not change while the track
// plays - and a rebuild picks a new one. Measured on a Pi, a tier drop from 1
// to 0 did exactly that mid-track. It also buys almost nothing there: gallery
// is one quad and two texture reads, so its frame time is the composer's, not
// its own. It picks up the new tier on the next track, which is soon enough.
const QUALITY_TIER_AWARE_MODES = new Set([
  'mainstage', 'vinylgroove', 'kaleidodrift', 'chromeflux',
  'phosphorscope', 'constellation', 'drostedive', 'lasercathedral', 'lasergrid', 'kineticrig', 'resonance', 'sumi', 'halftone',
  'loom', 'caustics', 'aurora', 'shoji', 'sand', 'prism', 'frost', 'reed', 'anamorph', 'portal', 'echo', 'preset', 'silk', 'swarm', 'nebula', 'ocean', 'turing', 'pyro', 'cascade', 'mosh', 'strobewall', 'beamwall', 'kelp', 'poster', 'countdown', 'fireflies', 'polytope', 'cycle', 'thermal', 'warehouse', 'chladni', 'liquidlight', 'kineticrig2', 'steam', 'focus', 'shatter',
  'infinity', 'ember', 'lichtenberg', 'origami', 'portals', 'advect', 'ravesign', 'airframe', 'maelstrom', 'vertigo', 'nightdrive', 'kaleido', 'tessel', 'lantern', 'scope3d', 'hex', 'metronome', 'rosace', 'incense', 'loxodrome', 'hyperbolic', 'tessera', 'blueprint', 'bayfront', 'signal', 'lighthouse', 'jellyfish', 'pendula', 'texer', 'outrun', 'aspen', 'mirrorarray', 'neonalley', 'underground', 'frames', 'flame', 'koi', 'tesla', 'glowtide', 'pinball', 'lightcycles', 'hyperloop', 'mandala', 'eclipse', 'pane', 'splitflap2', 'headliner', 'hangar', 'goldenhour', 'hyperspace', 'dancefloor', 'mixdeck', 'typeclash', 'pulsar', 'skyline', 'arcade', 'bloom', 'lightpaint', 'kintsugi', 'harp', 'fountain', 'startrails', 'domino', 'twist', 'jukebox', 'pipes', 'gyro', 'slitscan', 'julia', 'blackhole', 'mycelium', 'penrose', 'chromeflow', 'dissolve', 'glass', 'glyphs', 'bubbles', 'bauhaus', 'metro', 'zoetrope', 'morph', 'branches', 'mobius', 'doorways', 'cymatics', 'leviathan', 'rings', 'poincare', 'oilshow', 'kinetic', 'haze', 'borealis', 'ledcube', 'ferro', 'fractal', 'poolside', 'magneto', 'acid', 'cyberflight', 'maze', 'sunburst', 'wavefield', 'contours', 'seasons', 'isocubes', 'datamosh', 'tvwall', 'comic', 'blacklight', 'cells', 'pixelsort', 'videoloop', 'galaxy', 'moire', 'formation', 'facets', 'pyromusical', 'thunderhead', 'cloudsea', 'shapes', 'stadium', 'rainwindow', 'hifi', 'woofer', 'panels', 'bubble', 'ballroom', 'flowmap', 'totem', 'ribbons', 'shockwave', 'ink', 'drones',
  'sunroom',
  'matrix',
  'fairground',
  'halo',
  'pinscreen',
  'moonlake',
  'balloons',
  'dandelion',
  'hourglass',
  'neonsign',
  'bokeh',
  'splitflap'
]);

// CHANTIER 6 (revision) - composition display duration.
// No analysisTimeline at all for this track (radiopi hasn't returned a
// sequencing) - see the orchestration-priority comment on
// DANCEABILITY_DWELL_MAX_S above. Floor for computeDanceabilityDwellSeconds
// in that case; a highly danceable track still gets at least this long
// per composition, same floor computeCompositionDuration's own
// DURATION_MIN_S used to enforce before this rule replaced it here.
const NO_ANALYSIS_DWELL_MIN_S = 15;
// A drop interrupt only fires once the CURRENT composition has run at
// least one full phrase - a drop that lands one beat after a swap
// shouldn't immediately re-swap on top of it.
const DROP_INTERRUPT_MIN_BEATS = BEATS_PER_PHRASE;
// ?swap=1's own recheck cadence, once the normal duration-based one is
// bypassed - short enough to feel "immediate" for iteration, not so short
// it spams rebuilds.
const DEBUG_IMMEDIATE_RECHECK_S = 1;
// See _scheduleNext's own comment - how soon to retry after a recheck that
// hysteresis held rather than switched, BEFORE the active composition has
// reached its own desired duration (once it has, update() checks every
// single frame instead - see AC1's own tight tolerance and
// _currentHysteresisFactor/_currentExcludeId below). Short on purpose: a
// hold that happens to land just before the desired-duration boundary
// must not sit on a multi-second cadence and miss crossing into
// "overrun -> check every frame" for that long.
const HYSTERESIS_HOLD_RETRY_S = 0.25;
const COMPOSITION_LOG_LIMIT = 200;
// Hysteresis (chantier 5) compares only CURRENT scores - with a real
// track's trackData fixed for its whole duration, the incumbent's own raw
// score barely moves and nothing else ever makes it let go on its own, and
// merely REDUCING its protection doesn't force pickWeighted to draw
// something else if the incumbent is still a genuinely dominant scorer.
// The moment the active composition reaches its OWN desired duration
// (chantier 6, revision), it is hard-EXCLUDED from the very next decision
// outright - guaranteeing an actual rotation, armed at exactly the
// intended moment rather than some delay later. The armSwap phrase-lock
// wait that follows (see _armSwap) is exactly what
// computeCompositionDuration's own "-8 beats" already budgets for -
// arming late here would double-count that delay.
const PACE_STORAGE_KEY = 'partyModePace';
const PACE_DEFAULT = 1.0;

// ?pace=<n> overrides and persists to localStorage (survives a reload with
// no URL param, per the brief); absent both, defaults to 1.0. A global
// multiplier on every computed composition duration (chantier 6, revision)
// - not touched by orchestrator.js itself, which stays a pure/testable
// scoring module with no notion of a debug speed dial.
function readPace() {
  let pace = PACE_DEFAULT;
  try {
    const params = new URLSearchParams(typeof location !== 'undefined' ? location.search : '');
    const fromUrl = parseFloat(params.get('pace'));
    if (!isNaN(fromUrl) && fromUrl > 0) {
      pace = fromUrl;
      localStorage.setItem(PACE_STORAGE_KEY, String(pace));
      return pace;
    }
    const stored = parseFloat(localStorage.getItem(PACE_STORAGE_KEY));
    if (!isNaN(stored) && stored > 0) pace = stored;
  } catch (e) {
    // localStorage unavailable (private mode, non-browser test context) -
    // the default is a perfectly fine fallback, not worth surfacing.
  }
  return pace;
}

function clamp01(x) {
  return Math.max(0, Math.min(1, x));
}

function pickTransitionType(mode) {
  const weights = (mode && TRANSITION_WEIGHTS[mode]) || DEFAULT_TRANSITION_WEIGHTS;
  const total = weights.CUT + weights.FLASH + weights.BLACK + weights.PUSH;
  let r = Math.random() * total;
  const keys = ['CUT', 'FLASH', 'BLACK', 'PUSH'];
  for (let i = 0; i < keys.length; i++) {
    r -= weights[keys[i]];
    if (r <= 0) return keys[i];
  }
  return 'CUT';
}

export class AdaptivePartyVisualizer extends Visualizer {
  init(scene, camera) {
    this._scene = scene;
    this._camera = camera;
    this._time = 0;
    this._mode = null; // 'fallback' | 'particles' | 'spotwall' | 'neongrid' | 'discosquares' | 'neonparticles' | 'daftpyramid' | 'pulsecore' | 'kineticrig' | 'lasercathedral' | 'mainstage'
    this._currentKey = null;
    // LES REFUS DE L'UTILISATEUR, pour CE morceau seulement (console VDJ).
    // La croix d'une vignette dit « pas celle-là, pas maintenant » : elle vaut
    // le temps du titre et disparaît au suivant. Rien n'est écrit nulle part —
    // c'est l'état d'un onglet, donc forcément propre à cette personne.
    this._exclus = new Set();
    this._exclusPour = null;
    this._nextCheckAt = 0;
    this._lastDecision = null;
    this._lastSeenTrackFeatures = null;
    // radiopi /analyze - typed marks (see track-analysis.js's selectMarks,
    // and profile.analysisTimeline built once in sonos-visual-profile.js)
    // consumed via a monotonic pointer as playback position passes them -
    // see update()'s mark dispatch and _handleMark.
    this._lastSeenTrackAnalysis = null;
    this._marks = [];
    this._nextMarkIndex = 0;
    // Filler transitions (see FILLER_MIN_S/DANCEABILITY_DWELL_MAX_S) -
    // reset to a fresh danceability-driven window after every real swap,
    // in _swapTo.
    this._nextFillerCheckAt = 0;
    // "Montée faible" push response state - this._time value the push
    // boost stays active until, and a one-frame flag for the discrete
    // internalCue signal (see _handleMark).
    this._pushIntensityUntil = 0;
    this._pushJustTriggered = false;
    // Beat-aligned arming (drop moyen/montée forte - see _armSwap) needs
    // its own wrap-detection baseline, same reasoning as _lastPhrasePhase.
    this._lastBeatPhase = null;
    // [{id, family}, ...] most-recent-first - fed to selectVisualizations'
    // own recency/family penalties (chantier 5). Recorded on every ACTUAL
    // swap (_swapTo), not every decision - a decision that hysteresis kept
    // on the incumbent isn't a new play.
    this._history = [];
    // LES COMPOSITIONS DÉJÀ JOUÉES SUR CE MORCEAU, et le morceau dont il
    // s'agit. Une visualisation ne repasse pas deux fois dans le même titre
    // tant que tout le vivier n'y est pas passé ; au changement de morceau,
    // on repart de rien.
    this._jouees = new Set();
    this._jouees_piste = null;

    // CHANTIER 6 state. _armed: {targetKey, decision, type} once armSwap()
    // has decided something but before it's applied. _transition: the
    // in-flight BLACK hold or PUSH camera animation between "armed fired"
    // and the actual _swapTo. Both null most of the time (CUT/FLASH apply
    // synchronously, no lingering state needed).
    this._armed = null;
    this._transition = null;
    // The crossfade in flight and the incoming composition's intensity ramp
    // (see _fadePlan) - both null outside a calm/middle-track swap.
    this._fade = null;
    this._fadeIntro = null;
    // Countdown: the drop it was launched for (one launch per drop), and the
    // instant until which it holds the screen (see COUNTDOWN_ID).
    this._countdownFor = null;
    this._countdownHoldUntilMs = null;
    this._countdownLaunchedAt = -1e9;
    this._countdownJoue = false;      // already played in this track
    // Danceability-identification watch: signature of the last
    // profile.danceability payload seen, plus a due-flag raised whenever it
    // changes (null -> llm within a second, llm -> signal at 60-100s). The
    // flag survives an in-flight arm/transition and is consumed by the
    // else-branch of update()'s cascade, where an out-of-pool incumbent is
    // swapped out on the next beat.
    this._lastDanceSig = null;
    this._danceRecheckDue = false;
    // Reset to null every time a new swap is armed (see _armSwap) - only
    // ever compared against while THIS SAME arm cycle is waiting, so a
    // stale value from a just-completed cycle can never be mistaken for a
    // fresh phrase wrap.
    this._lastPhrasePhase = null;
    // CHANTIER 7 - set by _swapTo, compared against every frame by
    // _tickQualityTier.
    this._lastAppliedQualityTier = null;

    // ?force=<id> - bypasses scoring entirely, always decides on one fixed
    // id. ?swap=1 - disables the phrase-downbeat wait, every swap applies
    // immediately (CUT) - a debug convenience for iterating quickly
    // without waiting on musical timing.
    const params = new URLSearchParams(typeof location !== 'undefined' ? location.search : '');
    this._forcedId = params.get('force') || null;
    // LE VERROU D'ADMINISTRATION (console, menu du nom du visuel) : une
    // composition imposée par-dessus tout — vivier, catalogue, exclusions,
    // changement de titre — jusqu'au retour en automatique. Voir
    // forcerComposition. Distinct de _forcedId, que le réglage du vivier ou
    // une exclusion peuvent lever : le verrou, lui, ne se lève qu'à la main.
    this._verrou = null;
    // La composition choisie à la main dans la console VDJ, quand elle est
    // hors de sa propre porte d'éligibilité. Voir pickComposition.
    this._choisiAMain = null;
    this._debugImmediateSwap = params.get('swap') === '1';

    // CHANTIER 6 (revision) - composition display duration.
    this._pace = readPace();
    // Bookkeeping for the CURRENTLY active composition's own duration -
    // set by _swapTo, read by both _swapTo itself (to log the OUTGOING
    // composition once the next one arrives) and getScheduleDebugInfo.
    this._activeCompositionStartedAt = null;
    this._activeCompositionDesiredSeconds = null;
    this._activeCompositionMode = null;
    this._activeCompositionBpm = null;
    // {key, mode, bpm, desiredSeconds, observedSeconds} per completed
    // composition - see _swapTo. Capped, not persisted - a debug/
    // verification aid (see check-composition-duration-style scripts),
    // not part of the real app's own behavior.
    this._compositionLog = [];
    // Edge-detection for the 'drop' interrupt (see update()) - only the
    // TRANSITION into drop matters, not merely being in it.
    this._lastSeenDirectorMode = null;
    // Set by onTrackChange (fires at poll time, outside the RAF loop),
    // consumed by the very next update() - a new track always forces an
    // immediate re-check regardless of the current composition's elapsed
    // duration.
    this._forceRecheck = false;

    camera.position.set(PARTICLES_CAMERA_POSITION[0], PARTICLES_CAMERA_POSITION[1], PARTICLES_CAMERA_POSITION[2]);
    camera.lookAt(PARTICLES_LOOK_AT[0], PARTICLES_LOOK_AT[1], PARTICLES_LOOK_AT[2]);
  }

  // CHANTIER 6 (revision) - see the brief's own interruption rule 2: "un
  // nouveau trackId arme toujours un swap, quelle que soit la durée
  // écoulée". Only forces an immediate RE-CHECK (bypassing the duration
  // timer) - the normal decision/hysteresis/armSwap pipeline still runs as
  // usual from there, so a track change that genuinely scores best on the
  // SAME visualizer doesn't force a pointless rebuild.
  onTrackChange(profile) {
    this._forceRecheck = true;
    this._countdownJoue = false;
    this._countdownFor = null;
    this._countdownHoldUntilMs = null;
  }

  // Le titulaire remplit-il encore sa porte d'éligibilité ? Rend la raison du
  // refus, ou null. Une MÉTHODE et non du code en ligne, pour la même raison
  // que _changeQualityTier en est une : test-scene-leak.mjs force chaque
  // composition sur un profil de démonstration sans analyse, et countdown -
  // qui refuse par construction d'y rester - y était évincé entre le swap et
  // la mesure. Le test lisait donc les compteurs d'une AUTRE composition et
  // annonçait une fuite de 31 géométries. Il neutralise cette vérification
  // comme il neutralise déjà le gouverneur.
  _verifierEligibilite(trackDataInput) {
    if (!this._currentKey || this._currentKey === 'fallback' || this._forcedId) return null;
    // Choisie à la main dans la console VDJ : voir pickComposition.
    if (this._choisiAMain && this._currentKey === this._choisiAMain) return null;
    const ids = this._currentKey.split('+');
    for (let i = 0; i < ids.length; i++) {
      const cand = getCandidate(ids[i]);
      if (!cand) continue;
      // EN ROTATION : seules les conditions permanentes. Voir
      // CONDITIONS_ENTREE dans orchestrator.js - revérifier « il reste un
      // drop devant » évincerait countdown à la seconde où il vient de
      // compter jusqu'au dernier, et son comportement de fin de morceau ne
      // serait jamais visible.
      const r = requirementFailure(cand, trackDataInput, { enRotation: true });
      if (r) return ids[i] + ' : ' + r;
    }
    return null;
  }

  _decisionToKey(decision) {
    if (decision.mode === 'fallback') {
      // NeonPulse is the COLD-START picture and nothing else: what plays
      // before any track data has ever arrived, when there is genuinely
      // nothing to orchestrate on. It is not a rotation candidate - the
      // registry excludes it outright, it has no PROFILE and no score.
      //
      // But 'fallback' is returned whenever trackFeatures is null, and that
      // field is reset to null on EVERY track change and stays null for good
      // on any track Deezer/TheAudioDB cannot match. So a visualizer that was
      // never selected was displacing real orchestrated picks - briefly at
      // every track change, and for the whole of any unmatched track.
      //
      // Once a real composition is on screen it therefore stays: holding the
      // incumbent is strictly better than dropping to a picture nothing chose.
      // Returning the current key reads as "no change" at every call site,
      // which all compare against it before arming a swap.
      return (this._currentKey !== null && this._currentKey !== 'fallback')
        ? this._currentKey
        : 'fallback';
    }
    return decision.layers.slice().sort().join('+');
  }

  // ?force=<id> - bypasses scoring entirely but still runs the same real
  // duration math (director.mode/bpm/danceability/energy) as a normal
  // decision would, so forcing an id for debug purposes still exercises
  // the actual scheduling behavior instead of a fake fixed number.
  _buildForcedDecision(directorMode, profile) {
    const features = profile.trackFeatures;
    const duration = computeCompositionDuration(
      directorMode,
      features && features.bpm,
      danceIndex(profile) * 100,
      features && features.energy
    );
    return {
      mode: 'orchestrated',
      layers: [this._forcedId],
      primary: this._forcedId,
      changed: true,
      scored: [],
      desiredDurationSeconds: duration.desiredSeconds,
      scheduledDurationSeconds: duration.scheduledSeconds
    };
  }

  // CHANTIER 7 - every qualityTier-aware composition below is built at
  // the GOVERNOR's current tier (profile.director.qualityTier), not a
  // fixed value - see _tickQualityTier for what rebuilds them when that
  // tier changes mid-composition.
  // LA BIBLIOTHÈQUE DE CE MORCEAU : ce que le tier autorise, moins ce que la
  // porte refuse. Tous les viviers de ce fichier passent par là - celui qu'on
  // affiche, celui que les flèches parcourent, celui où un clic va chercher sa
  // composition. Sans ça, un visualiseur à porte figure dans le vivier de sa
  // bande de dansabilité sur des morceaux où il ne peut jamais être choisi.
  _libEligible(profile) {
    return libraryForTrack(this._lastTrackData || porteDepuisProfil(profile), this._currentQualityTier(profile));
  }

  _currentQualityTier(profile) {
    return profile.director && profile.director.qualityTier != null ? profile.director.qualityTier : 1;
  }

  _buildComposition(key, profile) {
    // Chaque composition part de la caméra de référence, comme un visualiseur
    // de premier niveau (scene-manager.setVisualizer) : un changement INTERNE
    // ne la remettait pas, et le champ de Beamwall (34°) ou la poussée d'une
    // transition PUSH restaient aux visuels suivants.
    reinitialiserCamera(this._camera);
    if (key === 'fallback') {
      this._fallback = new NeonPulseVisualizer();
      this._fallback.init(this._scene, this._camera);
      this._mode = 'fallback';
      return;
    }
    if (key === 'spotwall') {
      // includeRig:false - a full rig on top of a full-screen spot grid
      // read as "trop" (too much) once seen together; SpotWall's own
      // grid carries the look on its own here. The standalone/debug-
      // switcher SpotWall entry is unaffected (keeps its default rig).
      this._spotwall = new SpotWallVisualizer({ includeRig: false });
      this._spotwall.init(this._scene, this._camera);
      this._mode = 'spotwall';
      return;
    }
    if (key === 'neongrid') {
      this._neongrid = new NeonGridVisualizer();
      this._neongrid.init(this._scene, this._camera);
      this._mode = 'neongrid';
      return;
    }
    if (key === 'discosquares') {
      this._discosquares = new DiscoSquaresVisualizer();
      this._discosquares.init(this._scene, this._camera);
      this._mode = 'discosquares';
      return;
    }
    if (key === 'neonparticles') {
      this._neonparticles = new NeonParticlesVisualizer();
      this._neonparticles.init(this._scene, this._camera);
      this._mode = 'neonparticles';
      return;
    }
    if (key === 'daftpyramid') {
      this._daftpyramid = new DaftPyramidVisualizer();
      this._daftpyramid.init(this._scene, this._camera);
      this._mode = 'daftpyramid';
      return;
    }
    if (key === 'pulsecore') {
      this._pulsecore = new PulseCoreVisualizer();
      this._pulsecore.init(this._scene, this._camera);
      this._mode = 'pulsecore';
      return;
    }
    if (key === 'mainstage') {
      this._mainstage = new MainStageVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._mainstage.init(this._scene, this._camera);
      this._mode = 'mainstage';
      return;
    }
    if (key === 'vinylgroove') {
      this._vinylgroove = new VinylGrooveVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._vinylgroove.init(this._scene, this._camera);
      this._mode = 'vinylgroove';
      return;
    }
    if (key === 'typeslam') {
      this._typeslam = new TypeSlamVisualizer();
      this._typeslam.init(this._scene, this._camera);
      this._mode = 'typeslam';
      return;
    }
    if (key === 'kaleidodrift') {
      this._kaleidodrift = new KaleidoDriftVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._kaleidodrift.init(this._scene, this._camera);
      this._mode = 'kaleidodrift';
      return;
    }
    if (key === 'chromeflux') {
      this._chromeflux = new ChromeFluxVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._chromeflux.init(this._scene, this._camera);
      this._mode = 'chromeflux';
      return;
    }
    if (key === 'constellation') {
      this._constellation = new ConstellationVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._constellation.init(this._scene, this._camera);
      this._mode = 'constellation';
      return;
    }
    if (key === 'phosphorscope') {
      this._phosphorscope = new PhosphorScopeVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._phosphorscope.init(this._scene, this._camera);
      this._mode = 'phosphorscope';
      return;
    }
    if (key === 'drostedive') {
      this._drostedive = new DrosteDiveVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._drostedive.init(this._scene, this._camera);
      this._mode = 'drostedive';
      return;
    }
    if (key === 'tunnel') {
      this._tunnel = new TunnelVisualizer();
      this._tunnel.init(this._scene, this._camera);
      this._mode = 'tunnel';
      return;
    }
    if (key === 'lasergrid') {
      this._lasergrid = new LaserGridVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._lasergrid.init(this._scene, this._camera);
      this._mode = 'lasergrid';
      return;
    }
    if (key === 'lasercathedral') {
      this._lasercathedral = new LaserCathedralVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._lasercathedral.init(this._scene, this._camera);
      this._mode = 'lasercathedral';
      return;
    }
    if (key === 'kineticrig') {
      // Governor-driven now (chantier 7) - was a fixed tier 2 (the only
      // variant kept in the debug switcher, since the floor reflection is
      // what fills the lower half of the frame there), but a composition
      // AdaptiveParty is actually running in production has to be able to
      // step down like everything else here.
      this._kineticrig = new KineticRigVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._kineticrig.init(this._scene, this._camera);
      this._mode = 'kineticrig';
      return;
    }
    if (key === 'resonance') {
      // soundboardTexture left unset - ResonanceVisualizer self-serves via
      // getSoundboardTexture() (see resonance.js's constructor), same
      // fallback pattern MainStageVisualizer already uses for crowdAtlas
      // above (getCrowdAtlas() is never threaded through here either).
      this._resonance = new ResonanceVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._resonance.init(this._scene, this._camera);
      this._mode = 'resonance';
      return;
    }
    if (key === 'halftone') {
      this._halftone = new HalftoneVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._halftone.init(this._scene, this._camera);
      this._mode = 'halftone';
      return;
    }
    if (key === 'sumi') {
      // paperTexture left unset - SumiVisualizer self-serves via
      // getPaperTexture(), same self-serving fallback pattern as above.
      this._sumi = new SumiVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._sumi.init(this._scene, this._camera);
      this._mode = 'sumi';
      return;
    }
    if (key === 'caustics') {
      this._caustics = new CausticsVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._caustics.init(this._scene, this._camera);
      this._mode = 'caustics';
      return;
    }
    if (key === 'aurora') {
      this._aurora = new AuroraVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._aurora.init(this._scene, this._camera);
      this._mode = 'aurora';
      return;
    }
    if (key === 'reed') {
      this._reed = new ReedVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._reed.init(this._scene, this._camera);
      this._mode = 'reed';
      return;
    }
    if (key === 'anamorph') {
      this._anamorph = new AnamorphVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._anamorph.init(this._scene, this._camera);
      this._mode = 'anamorph';
      return;
    }
    if (key === 'portal') {
      this._portal = new PortalVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._portal.init(this._scene, this._camera);
      this._mode = 'portal';
      return;
    }
    if (key === 'echo') {
      this._echo = new EchoVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._echo.init(this._scene, this._camera);
      this._mode = 'echo';
      return;
    }
    if (key === 'preset') {
      this._preset = new PresetVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._preset.init(this._scene, this._camera);
      this._mode = 'preset';
      return;
    }
    if (key === 'shatter') {
      this._shatter = new ShatterVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._shatter.init(this._scene, this._camera);
      this._mode = 'shatter';
      return;
    }
    if (key === 'infinity') {
      this._infinity = new InfinityVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._infinity.init(this._scene, this._camera);
      this._mode = 'infinity';
      return;
    }
    if (key === 'ember') {
      this._ember = new EmberVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._ember.init(this._scene, this._camera);
      this._mode = 'ember';
      return;
    }
    if (key === 'lichtenberg') {
      this._lichtenberg = new LichtenbergVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._lichtenberg.init(this._scene, this._camera);
      this._mode = 'lichtenberg';
      return;
    }
    if (key === 'origami') {
      this._origami = new OrigamiVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._origami.init(this._scene, this._camera);
      this._mode = 'origami';
      return;
    }
    if (key === 'portals') {
      this._portals = new PortalsVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._portals.init(this._scene, this._camera);
      this._mode = 'portals';
      return;
    }
    if (key === 'advect') {
      this._advect = new AdvectVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._advect.init(this._scene, this._camera);
      this._mode = 'advect';
      return;
    }
    if (key === 'ravesign') {
      this._ravesign = new RaveSignVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._ravesign.init(this._scene, this._camera);
      this._mode = 'ravesign';
      return;
    }
    if (key === 'airframe') {
      this._airframe = new AirframeVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._airframe.init(this._scene, this._camera);
      this._mode = 'airframe';
      return;
    }
    if (key === 'vertigo') {
      this._vertigo = new VertigoVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._vertigo.init(this._scene, this._camera);
      this._mode = 'vertigo';
      return;
    }
    if (key === 'lantern') {
      this._lantern = new LanternVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._lantern.init(this._scene, this._camera);
      this._mode = 'lantern';
      return;
    }
    if (key === 'bayfront') {
      this._bayfront = new BayfrontVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._bayfront.init(this._scene, this._camera);
      this._mode = 'bayfront';
      return;
    }
    if (key === 'signal') {
      this._signal = new SignalVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._signal.init(this._scene, this._camera);
      this._mode = 'signal';
      return;
    }
    if (key === 'lighthouse') {
      this._lighthouse = new LighthouseVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._lighthouse.init(this._scene, this._camera);
      this._mode = 'lighthouse';
      return;
    }
    if (key === 'jellyfish') {
      this._jellyfish = new JellyfishVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._jellyfish.init(this._scene, this._camera);
      this._mode = 'jellyfish';
      return;
    }
    if (key === 'pendula') {
      this._pendula = new PendulaVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._pendula.init(this._scene, this._camera);
      this._mode = 'pendula';
      return;
    }
    if (key === 'texer') {
      this._texer = new TexerVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._texer.init(this._scene, this._camera);
      this._mode = 'texer';
      return;
    }
    if (key === 'outrun') {
      this._outrun = new OutrunVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._outrun.init(this._scene, this._camera);
      this._mode = 'outrun';
      return;
    }
    if (key === 'panels') {
      this._panels = new PanelsVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._panels.init(this._scene, this._camera);
      this._mode = 'panels';
      return;
    }
    if (key === 'bubble') {
      this._bubble = new BubbleVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._bubble.init(this._scene, this._camera);
      this._mode = 'bubble';
      return;
    }
    if (key === 'ballroom') {
      this._ballroom = new BallroomVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._ballroom.init(this._scene, this._camera);
      this._mode = 'ballroom';
      return;
    }
    if (key === 'flowmap') {
      this._flowmap = new FlowmapVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._flowmap.init(this._scene, this._camera);
      this._mode = 'flowmap';
      return;
    }
    if (key === 'totem') {
      this._totem = new TotemVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._totem.init(this._scene, this._camera);
      this._mode = 'totem';
      return;
    }
    if (key === 'ribbons') {
      this._ribbons = new RibbonsVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._ribbons.init(this._scene, this._camera);
      this._mode = 'ribbons';
      return;
    }
    if (key === 'shockwave') {
      this._shockwave = new ShockwaveVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._shockwave.init(this._scene, this._camera);
      this._mode = 'shockwave';
      return;
    }
    if (key === 'ink') {
      this._ink = new InkVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._ink.init(this._scene, this._camera);
      this._mode = 'ink';
      return;
    }
    if (key === 'drones') {
      this._drones = new DronesVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._drones.init(this._scene, this._camera);
      this._mode = 'drones';
      return;
    }
    if (key === 'aspen') {
      this._aspen = new AspenVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._aspen.init(this._scene, this._camera);
      this._mode = 'aspen';
      return;
    }
    if (key === 'mirrorarray') {
      this._mirrorarray = new MirrorArrayVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._mirrorarray.init(this._scene, this._camera);
      this._mode = 'mirrorarray';
      return;
    }
    if (key === 'neonalley') {
      this._neonalley = new NeonAlleyVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._neonalley.init(this._scene, this._camera);
      this._mode = 'neonalley';
      return;
    }
    if (key === 'underground') {
      this._underground = new UndergroundVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._underground.init(this._scene, this._camera);
      this._mode = 'underground';
      return;
    }
    if (key === 'frames') {
      this._frames = new FramesVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._frames.init(this._scene, this._camera);
      this._mode = 'frames';
      return;
    }
    if (key === 'flame') {
      this._flame = new FlameVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._flame.init(this._scene, this._camera);
      this._mode = 'flame';
      return;
    }
    if (key === 'eclipse') {
      this._eclipse = new EclipseVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._eclipse.init(this._scene, this._camera);
      this._mode = 'eclipse';
      return;
    }
    if (key === 'pane') {
      this._pane = new PaneVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._pane.init(this._scene, this._camera);
      this._mode = 'pane';
      return;
    }
    if (key === 'splitflap2') {
      this._splitflap2 = new Splitflap2Visualizer({ qualityTier: this._currentQualityTier(profile) });
      this._splitflap2.init(this._scene, this._camera);
      this._mode = 'splitflap2';
      return;
    }
    if (key === 'headliner') {
      this._headliner = new HeadlinerVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._headliner.init(this._scene, this._camera);
      this._mode = 'headliner';
      return;
    }
    if (key === 'hangar') {
      this._hangar = new HangarVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._hangar.init(this._scene, this._camera);
      this._mode = 'hangar';
      return;
    }
    if (key === 'goldenhour') {
      this._goldenhour = new GoldenhourVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._goldenhour.init(this._scene, this._camera);
      this._mode = 'goldenhour';
      return;
    }
    if (key === 'hyperspace') {
      this._hyperspace = new HyperspaceVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._hyperspace.init(this._scene, this._camera);
      this._mode = 'hyperspace';
      return;
    }
    if (key === 'dancefloor') {
      this._dancefloor = new DancefloorVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._dancefloor.init(this._scene, this._camera);
      this._mode = 'dancefloor';
      return;
    }
    if (key === 'mixdeck') {
      this._mixdeck = new MixdeckVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._mixdeck.init(this._scene, this._camera);
      this._mode = 'mixdeck';
      return;
    }
    if (key === 'typeclash') {
      this._typeclash = new TypeclashVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._typeclash.init(this._scene, this._camera);
      this._mode = 'typeclash';
      return;
    }
    if (key === 'mandala') {
      this._mandala = new MandalaVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._mandala.init(this._scene, this._camera);
      this._mode = 'mandala';
      return;
    }
    if (key === 'hyperloop') {
      this._hyperloop = new HyperloopVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._hyperloop.init(this._scene, this._camera);
      this._mode = 'hyperloop';
      return;
    }
    if (key === 'lightcycles') {
      this._lightcycles = new LightcyclesVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._lightcycles.init(this._scene, this._camera);
      this._mode = 'lightcycles';
      return;
    }
    if (key === 'pinball') {
      this._pinball = new PinballVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._pinball.init(this._scene, this._camera);
      this._mode = 'pinball';
      return;
    }
    if (key === 'glowtide') {
      this._glowtide = new GlowtideVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._glowtide.init(this._scene, this._camera);
      this._mode = 'glowtide';
      return;
    }
    if (key === 'tesla') {
      this._tesla = new TeslaVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._tesla.init(this._scene, this._camera);
      this._mode = 'tesla';
      return;
    }
    if (key === 'koi') {
      this._koi = new KoiVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._koi.init(this._scene, this._camera);
      this._mode = 'koi';
      return;
    }
    if (key === 'pulsar') {
      this._pulsar = new PulsarVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._pulsar.init(this._scene, this._camera);
      this._mode = 'pulsar';
      return;
    }
    if (key === 'skyline') {
      this._skyline = new SkylineVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._skyline.init(this._scene, this._camera);
      this._mode = 'skyline';
      return;
    }
    if (key === 'arcade') {
      this._arcade = new ArcadeVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._arcade.init(this._scene, this._camera);
      this._mode = 'arcade';
      return;
    }
    if (key === 'bloom') {
      this._bloom = new BloomVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._bloom.init(this._scene, this._camera);
      this._mode = 'bloom';
      return;
    }
    if (key === 'fountain') {
      this._fountain = new FountainVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._fountain.init(this._scene, this._camera);
      this._mode = 'fountain';
      return;
    }
    if (key === 'harp') {
      this._harp = new HarpVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._harp.init(this._scene, this._camera);
      this._mode = 'harp';
      return;
    }
    if (key === 'kintsugi') {
      this._kintsugi = new KintsugiVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._kintsugi.init(this._scene, this._camera);
      this._mode = 'kintsugi';
      return;
    }
    if (key === 'lightpaint') {
      this._lightpaint = new LightpaintVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._lightpaint.init(this._scene, this._camera);
      this._mode = 'lightpaint';
      return;
    }
    if (key === 'startrails') {
      this._startrails = new StartrailsVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._startrails.init(this._scene, this._camera);
      this._mode = 'startrails';
      return;
    }
    if (key === 'bauhaus') {
      this._bauhaus = new BauhausVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._bauhaus.init(this._scene, this._camera);
      this._mode = 'bauhaus';
      return;
    }
    if (key === 'dissolve') {
      this._dissolve = new DissolveVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._dissolve.init(this._scene, this._camera);
      this._mode = 'dissolve';
      return;
    }
    if (key === 'glass') {
      this._glass = new GlassVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._glass.init(this._scene, this._camera);
      this._mode = 'glass';
      return;
    }
    if (key === 'glyphs') {
      this._glyphs = new GlyphsVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._glyphs.init(this._scene, this._camera);
      this._mode = 'glyphs';
      return;
    }
    if (key === 'bubbles') {
      this._bubbles = new BubblesVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._bubbles.init(this._scene, this._camera);
      this._mode = 'bubbles';
      return;
    }
    if (key === 'chromeflow') {
      this._chromeflow = new ChromeflowVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._chromeflow.init(this._scene, this._camera);
      this._mode = 'chromeflow';
      return;
    }
    if (key === 'penrose') {
      this._penrose = new PenroseVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._penrose.init(this._scene, this._camera);
      this._mode = 'penrose';
      return;
    }
    if (key === 'mycelium') {
      this._mycelium = new MyceliumVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._mycelium.init(this._scene, this._camera);
      this._mode = 'mycelium';
      return;
    }
    if (key === 'blackhole') {
      this._blackhole = new BlackholeVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._blackhole.init(this._scene, this._camera);
      this._mode = 'blackhole';
      return;
    }
    if (key === 'julia') {
      this._julia = new JuliaVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._julia.init(this._scene, this._camera);
      this._mode = 'julia';
      return;
    }
    if (key === 'slitscan') {
      this._slitscan = new SlitscanVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._slitscan.init(this._scene, this._camera);
      this._mode = 'slitscan';
      return;
    }
    if (key === 'gyro') {
      this._gyro = new GyroVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._gyro.init(this._scene, this._camera);
      this._mode = 'gyro';
      return;
    }
    if (key === 'pipes') {
      this._pipes = new PipesVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._pipes.init(this._scene, this._camera);
      this._mode = 'pipes';
      return;
    }
    if (key === 'jukebox') {
      this._jukebox = new JukeboxVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._jukebox.init(this._scene, this._camera);
      this._mode = 'jukebox';
      return;
    }
    if (key === 'twist') {
      this._twist = new TwistVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._twist.init(this._scene, this._camera);
      this._mode = 'twist';
      return;
    }
    if (key === 'domino') {
      this._domino = new DominoVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._domino.init(this._scene, this._camera);
      this._mode = 'domino';
      return;
    }
    if (key === 'metro') {
      this._metro = new MetroVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._metro.init(this._scene, this._camera);
      this._mode = 'metro';
      return;
    }
    if (key === 'zoetrope') {
      this._zoetrope = new ZoetropeVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._zoetrope.init(this._scene, this._camera);
      this._mode = 'zoetrope';
      return;
    }
    if (key === 'morph') {
      this._morph = new MorphVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._morph.init(this._scene, this._camera);
      this._mode = 'morph';
      return;
    }
    if (key === 'branches') {
      this._branches = new BranchesVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._branches.init(this._scene, this._camera);
      this._mode = 'branches';
      return;
    }
    if (key === 'mobius') {
      this._mobius = new MobiusVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._mobius.init(this._scene, this._camera);
      this._mode = 'mobius';
      return;
    }
    if (key === 'doorways') {
      this._doorways = new DoorwaysVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._doorways.init(this._scene, this._camera);
      this._mode = 'doorways';
      return;
    }
    if (key === 'cymatics') {
      this._cymatics = new CymaticsVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._cymatics.init(this._scene, this._camera);
      this._mode = 'cymatics';
      return;
    }
    if (key === 'leviathan') {
      this._leviathan = new LeviathanVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._leviathan.init(this._scene, this._camera);
      this._mode = 'leviathan';
      return;
    }
    if (key === 'rings') {
      this._rings = new RingsVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._rings.init(this._scene, this._camera);
      this._mode = 'rings';
      return;
    }
    if (key === 'poincare') {
      this._poincare = new PoincareVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._poincare.init(this._scene, this._camera);
      this._mode = 'poincare';
      return;
    }
    if (key === 'oilshow') {
      this._oilshow = new OilshowVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._oilshow.init(this._scene, this._camera);
      this._mode = 'oilshow';
      return;
    }
    if (key === 'kinetic') {
      this._kinetic = new KineticVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._kinetic.init(this._scene, this._camera);
      this._mode = 'kinetic';
      return;
    }
    if (key === 'haze') {
      this._haze = new HazeVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._haze.init(this._scene, this._camera);
      this._mode = 'haze';
      return;
    }
    if (key === 'borealis') {
      this._borealis = new BorealisVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._borealis.init(this._scene, this._camera);
      this._mode = 'borealis';
      return;
    }
    if (key === 'ledcube') {
      this._ledcube = new LedcubeVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._ledcube.init(this._scene, this._camera);
      this._mode = 'ledcube';
      return;
    }
    if (key === 'scope3d') {
      this._scope3d = new Scope3DVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._scope3d.init(this._scene, this._camera);
      this._mode = 'scope3d';
      return;
    }
    if (key === 'hex') {
      this._hex = new HexVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._hex.init(this._scene, this._camera);
      this._mode = 'hex';
      return;
    }
    if (key === 'metronome') {
      this._metronome = new MetronomeVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._metronome.init(this._scene, this._camera);
      this._mode = 'metronome';
      return;
    }
    if (key === 'rosace') {
      this._rosace = new RosaceVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._rosace.init(this._scene, this._camera);
      this._mode = 'rosace';
      return;
    }
    if (key === 'incense') {
      this._incense = new IncenseVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._incense.init(this._scene, this._camera);
      this._mode = 'incense';
      return;
    }
    if (key === 'loxodrome') {
      this._loxodrome = new LoxodromeVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._loxodrome.init(this._scene, this._camera);
      this._mode = 'loxodrome';
      return;
    }
    if (key === 'hyperbolic') {
      this._hyperbolic = new HyperbolicVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._hyperbolic.init(this._scene, this._camera);
      this._mode = 'hyperbolic';
      return;
    }
    if (key === 'tessera') {
      this._tessera = new TesseraVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._tessera.init(this._scene, this._camera);
      this._mode = 'tessera';
      return;
    }
    if (key === 'blueprint') {
      this._blueprint = new BlueprintVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._blueprint.init(this._scene, this._camera);
      this._mode = 'blueprint';
      return;
    }
    if (key === 'silk') {
      this._silk = new SilkVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._silk.init(this._scene, this._camera);
      this._mode = 'silk';
      return;
    }
    if (key === 'swarm') {
      this._swarm = new SwarmVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._swarm.init(this._scene, this._camera);
      this._mode = 'swarm';
      return;
    }
    if (key === 'focus') {
      this._focus = new FocusVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._focus.init(this._scene, this._camera);
      this._mode = 'focus';
      return;
    }
    if (key === 'ocean') {
      this._ocean = new OceanVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._ocean.init(this._scene, this._camera);
      this._mode = 'ocean';
      return;
    }
    if (key === 'turing') {
      this._turing = new TuringVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._turing.init(this._scene, this._camera);
      this._mode = 'turing';
      return;
    }
    if (key === 'pyro') {
      this._pyro = new PyroVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._pyro.init(this._scene, this._camera);
      this._mode = 'pyro';
      return;
    }
    if (key === 'cascade') {
      this._cascade = new CascadeVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._cascade.init(this._scene, this._camera);
      this._mode = 'cascade';
      return;
    }
    if (key === 'mosh') {
      this._mosh = new MoshVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._mosh.init(this._scene, this._camera);
      this._mode = 'mosh';
      return;
    }
    if (key === 'strobewall') {
      this._strobewall = new StrobeWallVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._strobewall.init(this._scene, this._camera);
      this._mode = 'strobewall';
      return;
    }
    if (key === 'fireflies') {
      this._fireflies = new FirefliesVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._fireflies.init(this._scene, this._camera);
      this._mode = 'fireflies';
      return;
    }
    if (key === 'polytope') {
      this._polytope = new PolytopeVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._polytope.init(this._scene, this._camera);
      this._mode = 'polytope';
      return;
    }
    if (key === 'cycle') {
      this._cycle = new CycleVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._cycle.init(this._scene, this._camera);
      this._mode = 'cycle';
      return;
    }
    if (key === 'thermal') {
      this._thermal = new ThermalVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._thermal.init(this._scene, this._camera);
      this._mode = 'thermal';
      return;
    }
    if (key === 'warehouse') {
      this._warehouse = new WarehouseVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._warehouse.init(this._scene, this._camera);
      this._mode = 'warehouse';
      return;
    }
    if (key === 'sunroom') {
      this._sunroom = new SunroomVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._sunroom.init(this._scene, this._camera);
      this._mode = 'sunroom';
      return;
    }
    if (key === 'matrix') {
      this._matrix = new MatrixVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._matrix.init(this._scene, this._camera);
      this._mode = 'matrix';
      return;
    }
    if (key === 'fairground') {
      this._fairground = new FairgroundVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._fairground.init(this._scene, this._camera);
      this._mode = 'fairground';
      return;
    }
    if (key === 'halo') {
      this._halo = new HaloVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._halo.init(this._scene, this._camera);
      this._mode = 'halo';
      return;
    }
    if (key === 'pinscreen') {
      this._pinscreen = new PinscreenVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._pinscreen.init(this._scene, this._camera);
      this._mode = 'pinscreen';
      return;
    }
    if (key === 'moonlake') {
      this._moonlake = new MoonlakeVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._moonlake.init(this._scene, this._camera);
      this._mode = 'moonlake';
      return;
    }
    if (key === 'balloons') {
      this._balloons = new BalloonsVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._balloons.init(this._scene, this._camera);
      this._mode = 'balloons';
      return;
    }
    if (key === 'dandelion') {
      this._dandelion = new DandelionVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._dandelion.init(this._scene, this._camera);
      this._mode = 'dandelion';
      return;
    }
    if (key === 'truchet') {
      this._truchet = new TruchetVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._truchet.init(this._scene, this._camera);
      this._mode = 'truchet';
      return;
    }
    if (key === 'murmuration') {
      this._murmuration = new MurmurationVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._murmuration.init(this._scene, this._camera);
      this._mode = 'murmuration';
      return;
    }
    if (key === 'neonsign') {
      this._neonsign = new Neonsign2Visualizer({ qualityTier: this._currentQualityTier(profile) });
      this._neonsign.init(this._scene, this._camera);
      this._mode = 'neonsign';
      return;
    }
    if (key === 'bokeh') {
      this._bokeh = new BokehVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._bokeh.init(this._scene, this._camera);
      this._mode = 'bokeh';
      return;
    }
    if (key === 'hourglass') {
      this._hourglass = new HourglassVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._hourglass.init(this._scene, this._camera);
      this._mode = 'hourglass';
      return;
    }
    if (key === 'chladni') {
      this._chladni = new ChladniVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._chladni.init(this._scene, this._camera);
      this._mode = 'chladni';
      return;
    }
    if (key === 'ferro') {
      this._ferro = new FerroVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._ferro.init(this._scene, this._camera);
      this._mode = 'ferro';
      return;
    }
    if (key === 'fractal') {
      this._fractal = new FractalVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._fractal.init(this._scene, this._camera);
      this._mode = 'fractal';
      return;
    }
    if (key === 'poolside') {
      this._poolside = new PoolsideVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._poolside.init(this._scene, this._camera);
      this._mode = 'poolside';
      return;
    }
    if (key === 'magneto') {
      this._magneto = new MagnetoVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._magneto.init(this._scene, this._camera);
      this._mode = 'magneto';
      return;
    }
    if (key === 'videoloop') {
      this._videoloop = new VideoloopVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._videoloop.init(this._scene, this._camera);
      this._mode = 'videoloop';
      return;
    }
    if (key === 'galaxy') {
      this._galaxy = new GalaxyVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._galaxy.init(this._scene, this._camera);
      this._mode = 'galaxy';
      return;
    }
    if (key === 'moire') {
      this._moire = new MoireVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._moire.init(this._scene, this._camera);
      this._mode = 'moire';
      return;
    }
    if (key === 'formation') {
      this._formation = new FormationVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._formation.init(this._scene, this._camera);
      this._mode = 'formation';
      return;
    }
    if (key === 'facets') {
      this._facets = new FacetsVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._facets.init(this._scene, this._camera);
      this._mode = 'facets';
      return;
    }
    if (key === 'pyromusical') {
      this._pyromusical = new PyromusicalVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._pyromusical.init(this._scene, this._camera);
      this._mode = 'pyromusical';
      return;
    }
    if (key === 'thunderhead') {
      this._thunderhead = new ThunderheadVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._thunderhead.init(this._scene, this._camera);
      this._mode = 'thunderhead';
      return;
    }
    if (key === 'cloudsea') {
      this._cloudsea = new CloudseaVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._cloudsea.init(this._scene, this._camera);
      this._mode = 'cloudsea';
      return;
    }
    if (key === 'pixelsort') {
      this._pixelsort = new PixelsortVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._pixelsort.init(this._scene, this._camera);
      this._mode = 'pixelsort';
      return;
    }
    if (key === 'cells') {
      this._cells = new CellsVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._cells.init(this._scene, this._camera);
      this._mode = 'cells';
      return;
    }
    if (key === 'cyberflight') {
      this._cyberflight = new CyberflightVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._cyberflight.init(this._scene, this._camera);
      this._mode = 'cyberflight';
      return;
    }
    if (key === 'maze') {
      this._maze = new MazeVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._maze.init(this._scene, this._camera);
      this._mode = 'maze';
      return;
    }
    if (key === 'sunburst') {
      this._sunburst = new SunburstVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._sunburst.init(this._scene, this._camera);
      this._mode = 'sunburst';
      return;
    }
    if (key === 'wavefield') {
      this._wavefield = new WavefieldVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._wavefield.init(this._scene, this._camera);
      this._mode = 'wavefield';
      return;
    }
    if (key === 'contours') {
      this._contours = new ContoursVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._contours.init(this._scene, this._camera);
      this._mode = 'contours';
      return;
    }
    if (key === 'seasons') {
      this._seasons = new SeasonsVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._seasons.init(this._scene, this._camera);
      this._mode = 'seasons';
      return;
    }
    if (key === 'isocubes') {
      this._isocubes = new IsocubesVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._isocubes.init(this._scene, this._camera);
      this._mode = 'isocubes';
      return;
    }
    if (key === 'datamosh') {
      this._datamosh = new DatamoshVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._datamosh.init(this._scene, this._camera);
      this._mode = 'datamosh';
      return;
    }
    if (key === 'tvwall') {
      this._tvwall = new TvwallVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._tvwall.init(this._scene, this._camera);
      this._mode = 'tvwall';
      return;
    }
    if (key === 'comic') {
      this._comic = new ComicVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._comic.init(this._scene, this._camera);
      this._mode = 'comic';
      return;
    }
    if (key === 'blacklight') {
      this._blacklight = new BlacklightVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._blacklight.init(this._scene, this._camera);
      this._mode = 'blacklight';
      return;
    }
    if (key === 'acid') {
      this._acid = new AcidVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._acid.init(this._scene, this._camera);
      this._mode = 'acid';
      return;
    }
    if (key === 'shapes') {
      this._shapes = new ShapesVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._shapes.init(this._scene, this._camera);
      this._mode = 'shapes';
      return;
    }
    if (key === 'stadium') {
      this._stadium = new StadiumVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._stadium.init(this._scene, this._camera);
      this._mode = 'stadium';
      return;
    }
    if (key === 'rainwindow') {
      this._rainwindow = new RainwindowVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._rainwindow.init(this._scene, this._camera);
      this._mode = 'rainwindow';
      return;
    }
    if (key === 'hifi') {
      this._hifi = new HifiVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._hifi.init(this._scene, this._camera);
      this._mode = 'hifi';
      return;
    }
    if (key === 'woofer') {
      this._woofer = new WooferVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._woofer.init(this._scene, this._camera);
      this._mode = 'woofer';
      return;
    }
    if (key === 'countdown') {
      this._countdown = new CountdownVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._countdown.init(this._scene, this._camera);
      this._mode = 'countdown';
      return;
    }
    if (key === 'poster') {
      this._poster = new PosterVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._poster.init(this._scene, this._camera);
      this._mode = 'poster';
      return;
    }
    if (key === 'kelp') {
      this._kelp = new KelpVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._kelp.init(this._scene, this._camera);
      this._mode = 'kelp';
      return;
    }
    if (key === 'beamwall') {
      this._beamwall = new BeamWallVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._beamwall.init(this._scene, this._camera);
      this._mode = 'beamwall';
      return;
    }
    if (key === 'liquidlight') {
      this._liquidlight = new LiquidLightVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._liquidlight.init(this._scene, this._camera);
      this._mode = 'liquidlight';
      return;
    }
    if (key === 'steam') {
      this._steam = new SteamVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._steam.init(this._scene, this._camera);
      this._mode = 'steam';
      return;
    }
    if (key === 'kineticrig2') {
      this._kineticrig2 = new KineticRig2Visualizer({ qualityTier: this._currentQualityTier(profile) });
      this._kineticrig2.init(this._scene, this._camera);
      this._mode = 'kineticrig2';
      return;
    }
    if (key === 'maelstrom') {
      this._maelstrom = new MaelstromVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._maelstrom.init(this._scene, this._camera);
      this._mode = 'maelstrom';
      return;
    }
    if (key === 'nightdrive') {
      this._nightdrive = new NightdriveVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._nightdrive.init(this._scene, this._camera);
      this._mode = 'nightdrive';
      return;
    }
    if (key === 'kaleido') {
      this._kaleido = new KaleidoVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._kaleido.init(this._scene, this._camera);
      this._mode = 'kaleido';
      return;
    }
    if (key === 'tessel') {
      this._tessel = new TesselVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._tessel.init(this._scene, this._camera);
      this._mode = 'tessel';
      return;
    }
    if (key === 'nebula') {
      this._nebula = new NebulaVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._nebula.init(this._scene, this._camera);
      this._mode = 'nebula';
      return;
    }
    if (key === 'frost') {
      this._frost = new FrostVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._frost.init(this._scene, this._camera);
      this._mode = 'frost';
      return;
    }
    if (key === 'gallery') {
      this._gallery = new GalleryVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._gallery.init(this._scene, this._camera);
      this._mode = 'gallery';
      return;
    }
    if (key === 'splitflap') {
      // flapFont left unset - SplitflapVisualizer self-serves via
      // getFlapFont(), the same self-serving fallback pattern as loom/shoji
      // below, and it renders its whole mechanism with no atlas at all.
      this._splitflap = new SplitflapVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._splitflap.init(this._scene, this._camera);
      this._mode = 'splitflap';
      return;
    }
    if (key === 'prism') {
      this._prism = new PrismVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._prism.init(this._scene, this._camera);
      this._mode = 'prism';
      return;
    }
    if (key === 'shoji') {
      // paperTexture left unset - ShojiVisualizer self-serves via
      // getPaperTexture(), the same self-serving fallback pattern as loom
      // above.
      this._shoji = new ShojiVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._shoji.init(this._scene, this._camera);
      this._mode = 'shoji';
      return;
    }
    if (key === 'sand') {
      this._sand = new SandVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._sand.init(this._scene, this._camera);
      this._mode = 'sand';
      return;
    }
    if (key === 'loom') {
      // paperTexture left unset - LoomVisualizer self-serves via
      // getPaperTexture(), the same self-serving fallback pattern as above.
      this._loom = new LoomVisualizer({ qualityTier: this._currentQualityTier(profile) });
      this._loom.init(this._scene, this._camera);
      this._mode = 'loom';
      return;
    }

    // particles: 'dust', 'storm', or 'dust+storm' - same rig/floor/camera
    // shape as neon-pulse.js's own setup.
    this._camera.position.set(PARTICLES_CAMERA_POSITION[0], PARTICLES_CAMERA_POSITION[1], PARTICLES_CAMERA_POSITION[2]);
    this._camera.lookAt(PARTICLES_LOOK_AT[0], PARTICLES_LOOK_AT[1], PARTICLES_LOOK_AT[2]);
    this._rig = stageRig.acquire(RIG_OWNER, {
      scene: this._scene,
      intensityScale: RIG_INTENSITY_SCALE,
      zones: RIG_ZONES,
      floorLightBoost: RIG_FLOOR_LIGHT_BOOST
    });
    const floorGeometry = new THREE.PlaneGeometry(60, 60);
    const floorMaterial = new THREE.MeshStandardMaterial({ color: 0x16161c, roughness: 0.78, metalness: 0.0 });
    this._floor = new THREE.Mesh(floorGeometry, floorMaterial);
    this._floor.rotation.x = -Math.PI / 2;
    this._scene.add(this._floor);
    this._dust = null;
    this._storm = null;
    if (key.indexOf('dust') !== -1) {
      this._dust = new DustLayer();
      this._dust.init(this._scene);
    }
    if (key.indexOf('storm') !== -1) {
      this._storm = new StormLayer();
      this._storm.init(this._scene, this._camera);
    }
    this._mode = 'particles';
  }

  _disposeActive() {
    if (this._mode === 'fallback' && this._fallback) {
      this._fallback.dispose();
      this._fallback = null;
    } else if (this._mode === 'spotwall' && this._spotwall) {
      this._spotwall.dispose();
      this._spotwall = null;
    } else if (this._mode === 'neongrid') {
      if (this._neongrid) {
        this._neongrid.dispose();
        this._neongrid = null;
      }
    } else if (this._mode === 'discosquares') {
      if (this._discosquares) {
        this._discosquares.dispose();
        this._discosquares = null;
      }
    } else if (this._mode === 'neonparticles') {
      if (this._neonparticles) {
        this._neonparticles.dispose();
        this._neonparticles = null;
      }
    } else if (this._mode === 'daftpyramid') {
      if (this._daftpyramid) {
        this._daftpyramid.dispose();
        this._daftpyramid = null;
      }
    } else if (this._mode === 'pulsecore') {
      if (this._pulsecore) {
        this._pulsecore.dispose();
        this._pulsecore = null;
      }
    } else if (this._mode === 'mainstage') {
      if (this._mainstage) {
        this._mainstage.dispose();
        this._mainstage = null;
      }
    } else if (this._mode === 'vinylgroove') {
      if (this._vinylgroove) {
        this._vinylgroove.dispose();
        this._vinylgroove = null;
      }
    } else if (this._mode === 'typeslam') {
      if (this._typeslam) {
        this._typeslam.dispose();
        this._typeslam = null;
      }
    } else if (this._mode === 'kaleidodrift') {
      if (this._kaleidodrift) {
        this._kaleidodrift.dispose();
        this._kaleidodrift = null;
      }
    } else if (this._mode === 'chromeflux') {
      if (this._chromeflux) {
        this._chromeflux.dispose();
        this._chromeflux = null;
      }
    } else if (this._mode === 'constellation') {
      if (this._constellation) {
        this._constellation.dispose();
        this._constellation = null;
      }
    } else if (this._mode === 'phosphorscope') {
      if (this._phosphorscope) {
        this._phosphorscope.dispose();
        this._phosphorscope = null;
      }
    } else if (this._mode === 'drostedive') {
      if (this._drostedive) {
        this._drostedive.dispose();
        this._drostedive = null;
      }
    } else if (this._mode === 'tunnel') {
      if (this._tunnel) {
        this._tunnel.dispose();
        this._tunnel = null;
      }
    } else if (this._mode === 'lasergrid') {
      if (this._lasergrid) {
        this._lasergrid.dispose();
        this._lasergrid = null;
      }
    } else if (this._mode === 'lasercathedral') {
      if (this._lasercathedral) {
        this._lasercathedral.dispose();
        this._lasercathedral = null;
      }
    } else if (this._mode === 'kineticrig') {
      if (this._kineticrig) {
        this._kineticrig.dispose();
        this._kineticrig = null;
      }
    } else if (this._mode === 'resonance') {
      if (this._resonance) {
        this._resonance.dispose();
        this._resonance = null;
      }
    } else if (this._mode === 'halftone') {
      if (this._halftone) {
        this._halftone.dispose();
        this._halftone = null;
      }
    } else if (this._mode === 'sumi') {
      if (this._sumi) {
        this._sumi.dispose();
        this._sumi = null;
      }
    } else if (this._mode === 'caustics') {
      if (this._caustics) {
        this._caustics.dispose();
        this._caustics = null;
      }
    } else if (this._mode === 'aurora') {
      if (this._aurora) {
        this._aurora.dispose();
        this._aurora = null;
      }
    } else if (this._mode === 'reed') {
      if (this._reed) {
        this._reed.dispose();
        this._reed = null;
      }
    } else if (this._mode === 'anamorph') {
      if (this._anamorph) {
        this._anamorph.dispose();
        this._anamorph = null;
      }
    } else if (this._mode === 'portal') {
      if (this._portal) {
        this._portal.dispose();
        this._portal = null;
      }
    } else if (this._mode === 'echo') {
      if (this._echo) {
        this._echo.dispose();
        this._echo = null;
      }
    } else if (this._mode === 'preset') {
      if (this._preset) {
        this._preset.dispose();
        this._preset = null;
      }
    } else if (this._mode === 'shatter') {
      if (this._shatter) {
        this._shatter.dispose();
        this._shatter = null;
      }
    } else if (this._mode === 'infinity') {
      if (this._infinity) {
        this._infinity.dispose();
        this._infinity = null;
      }
    } else if (this._mode === 'ember') {
      if (this._ember) {
        this._ember.dispose();
        this._ember = null;
      }
    } else if (this._mode === 'lichtenberg') {
      if (this._lichtenberg) {
        this._lichtenberg.dispose();
        this._lichtenberg = null;
      }
    } else if (this._mode === 'origami') {
      if (this._origami) {
        this._origami.dispose();
        this._origami = null;
      }
    } else if (this._mode === 'portals') {
      if (this._portals) {
        this._portals.dispose();
        this._portals = null;
      }
    } else if (this._mode === 'advect') {
      if (this._advect) {
        this._advect.dispose();
        this._advect = null;
      }
    } else if (this._mode === 'ravesign') {
      if (this._ravesign) {
        this._ravesign.dispose();
        this._ravesign = null;
      }
    } else if (this._mode === 'airframe') {
      if (this._airframe) {
        this._airframe.dispose();
        this._airframe = null;
      }
    } else if (this._mode === 'vertigo') {
      if (this._vertigo) {
        this._vertigo.dispose();
        this._vertigo = null;
      }
    } else if (this._mode === 'lantern') {
      if (this._lantern) {
        this._lantern.dispose();
        this._lantern = null;
      }
    } else if (this._mode === 'bayfront') {
      if (this._bayfront) {
        this._bayfront.dispose();
        this._bayfront = null;
      }
    } else if (this._mode === 'signal') {
      if (this._signal) {
        this._signal.dispose();
        this._signal = null;
      }
    } else if (this._mode === 'lighthouse') {
      if (this._lighthouse) {
        this._lighthouse.dispose();
        this._lighthouse = null;
      }
    } else if (this._mode === 'jellyfish') {
      if (this._jellyfish) {
        this._jellyfish.dispose();
        this._jellyfish = null;
      }
    } else if (this._mode === 'pendula') {
      if (this._pendula) {
        this._pendula.dispose();
        this._pendula = null;
      }
    } else if (this._mode === 'texer') {
      if (this._texer) {
        this._texer.dispose();
        this._texer = null;
      }
    } else if (this._mode === 'outrun') {
      if (this._outrun) {
        this._outrun.dispose();
        this._outrun = null;
      }
    } else if (this._mode === 'panels') {
      if (this._panels) {
        this._panels.dispose();
        this._panels = null;
      }
    } else if (this._mode === 'bubble') {
      if (this._bubble) {
        this._bubble.dispose();
        this._bubble = null;
      }
    } else if (this._mode === 'ballroom') {
      if (this._ballroom) {
        this._ballroom.dispose();
        this._ballroom = null;
      }
    } else if (this._mode === 'flowmap') {
      if (this._flowmap) {
        this._flowmap.dispose();
        this._flowmap = null;
      }
    } else if (this._mode === 'totem') {
      if (this._totem) {
        this._totem.dispose();
        this._totem = null;
      }
    } else if (this._mode === 'ribbons') {
      if (this._ribbons) {
        this._ribbons.dispose();
        this._ribbons = null;
      }
    } else if (this._mode === 'shockwave') {
      if (this._shockwave) {
        this._shockwave.dispose();
        this._shockwave = null;
      }
    } else if (this._mode === 'ink') {
      if (this._ink) {
        this._ink.dispose();
        this._ink = null;
      }
    } else if (this._mode === 'drones') {
      if (this._drones) {
        this._drones.dispose();
        this._drones = null;
      }
    } else if (this._mode === 'aspen') {
      if (this._aspen) {
        this._aspen.dispose();
        this._aspen = null;
      }
    } else if (this._mode === 'mirrorarray') {
      if (this._mirrorarray) {
        this._mirrorarray.dispose();
        this._mirrorarray = null;
      }
    } else if (this._mode === 'neonalley') {
      if (this._neonalley) {
        this._neonalley.dispose();
        this._neonalley = null;
      }
    } else if (this._mode === 'underground') {
      if (this._underground) {
        this._underground.dispose();
        this._underground = null;
      }
    } else if (this._mode === 'frames') {
      if (this._frames) {
        this._frames.dispose();
        this._frames = null;
      }
    } else if (this._mode === 'flame') {
      if (this._flame) {
        this._flame.dispose();
        this._flame = null;
      }
    } else if (this._mode === 'eclipse') {
      if (this._eclipse) {
        this._eclipse.dispose();
        this._eclipse = null;
      }
    } else if (this._mode === 'pane') {
      if (this._pane) {
        this._pane.dispose();
        this._pane = null;
      }
    } else if (this._mode === 'splitflap2') {
      if (this._splitflap2) {
        this._splitflap2.dispose();
        this._splitflap2 = null;
      }
    } else if (this._mode === 'headliner') {
      if (this._headliner) {
        this._headliner.dispose();
        this._headliner = null;
      }
    } else if (this._mode === 'hangar') {
      if (this._hangar) {
        this._hangar.dispose();
        this._hangar = null;
      }
    } else if (this._mode === 'goldenhour') {
      if (this._goldenhour) {
        this._goldenhour.dispose();
        this._goldenhour = null;
      }
    } else if (this._mode === 'hyperspace') {
      if (this._hyperspace) {
        this._hyperspace.dispose();
        this._hyperspace = null;
      }
    } else if (this._mode === 'dancefloor') {
      if (this._dancefloor) {
        this._dancefloor.dispose();
        this._dancefloor = null;
      }
    } else if (this._mode === 'mixdeck') {
      if (this._mixdeck) {
        this._mixdeck.dispose();
        this._mixdeck = null;
      }
    } else if (this._mode === 'typeclash') {
      if (this._typeclash) {
        this._typeclash.dispose();
        this._typeclash = null;
      }
    } else if (this._mode === 'mandala') {
      if (this._mandala) {
        this._mandala.dispose();
        this._mandala = null;
      }
    } else if (this._mode === 'hyperloop') {
      if (this._hyperloop) {
        this._hyperloop.dispose();
        this._hyperloop = null;
      }
    } else if (this._mode === 'lightcycles') {
      if (this._lightcycles) {
        this._lightcycles.dispose();
        this._lightcycles = null;
      }
    } else if (this._mode === 'pinball') {
      if (this._pinball) {
        this._pinball.dispose();
        this._pinball = null;
      }
    } else if (this._mode === 'glowtide') {
      if (this._glowtide) {
        this._glowtide.dispose();
        this._glowtide = null;
      }
    } else if (this._mode === 'tesla') {
      if (this._tesla) {
        this._tesla.dispose();
        this._tesla = null;
      }
    } else if (this._mode === 'koi') {
      if (this._koi) {
        this._koi.dispose();
        this._koi = null;
      }
    } else if (this._mode === 'pulsar') {
      if (this._pulsar) {
        this._pulsar.dispose();
        this._pulsar = null;
      }
    } else if (this._mode === 'skyline') {
      if (this._skyline) {
        this._skyline.dispose();
        this._skyline = null;
      }
    } else if (this._mode === 'arcade') {
      if (this._arcade) {
        this._arcade.dispose();
        this._arcade = null;
      }
    } else if (this._mode === 'bloom') {
      if (this._bloom) {
        this._bloom.dispose();
        this._bloom = null;
      }
    } else if (this._mode === 'fountain') {
      if (this._fountain) {
        this._fountain.dispose();
        this._fountain = null;
      }
    } else if (this._mode === 'harp') {
      if (this._harp) {
        this._harp.dispose();
        this._harp = null;
      }
    } else if (this._mode === 'kintsugi') {
      if (this._kintsugi) {
        this._kintsugi.dispose();
        this._kintsugi = null;
      }
    } else if (this._mode === 'lightpaint') {
      if (this._lightpaint) {
        this._lightpaint.dispose();
        this._lightpaint = null;
      }
    } else if (this._mode === 'startrails') {
      if (this._startrails) {
        this._startrails.dispose();
        this._startrails = null;
      }
    } else if (this._mode === 'metro') {
      if (this._metro) {
        this._metro.dispose();
        this._metro = null;
      }
    } else if (this._mode === 'zoetrope') {
      if (this._zoetrope) {
        this._zoetrope.dispose();
        this._zoetrope = null;
      }
    } else if (this._mode === 'morph') {
      if (this._morph) {
        this._morph.dispose();
        this._morph = null;
      }
    } else if (this._mode === 'branches') {
      if (this._branches) {
        this._branches.dispose();
        this._branches = null;
      }
    } else if (this._mode === 'mobius') {
      if (this._mobius) {
        this._mobius.dispose();
        this._mobius = null;
      }
    } else if (this._mode === 'doorways') {
      if (this._doorways) {
        this._doorways.dispose();
        this._doorways = null;
      }
    } else if (this._mode === 'cymatics') {
      if (this._cymatics) {
        this._cymatics.dispose();
        this._cymatics = null;
      }
    } else if (this._mode === 'leviathan') {
      if (this._leviathan) {
        this._leviathan.dispose();
        this._leviathan = null;
      }
    } else if (this._mode === 'rings') {
      if (this._rings) {
        this._rings.dispose();
        this._rings = null;
      }
    } else if (this._mode === 'poincare') {
      if (this._poincare) {
        this._poincare.dispose();
        this._poincare = null;
      }
    } else if (this._mode === 'oilshow') {
      if (this._oilshow) {
        this._oilshow.dispose();
        this._oilshow = null;
      }
    } else if (this._mode === 'kinetic') {
      if (this._kinetic) {
        this._kinetic.dispose();
        this._kinetic = null;
      }
    } else if (this._mode === 'haze') {
      if (this._haze) {
        this._haze.dispose();
        this._haze = null;
      }
    } else if (this._mode === 'borealis') {
      if (this._borealis) {
        this._borealis.dispose();
        this._borealis = null;
      }
    } else if (this._mode === 'ledcube') {
      if (this._ledcube) {
        this._ledcube.dispose();
        this._ledcube = null;
      }
    } else if (this._mode === 'bauhaus') {
      if (this._bauhaus) {
        this._bauhaus.dispose();
        this._bauhaus = null;
      }
    } else if (this._mode === 'dissolve') {
      if (this._dissolve) {
        this._dissolve.dispose();
        this._dissolve = null;
      }
    } else if (this._mode === 'glass') {
      if (this._glass) {
        this._glass.dispose();
        this._glass = null;
      }
    } else if (this._mode === 'glyphs') {
      if (this._glyphs) {
        this._glyphs.dispose();
        this._glyphs = null;
      }
    } else if (this._mode === 'bubbles') {
      if (this._bubbles) {
        this._bubbles.dispose();
        this._bubbles = null;
      }
    } else if (this._mode === 'chromeflow') {
      if (this._chromeflow) {
        this._chromeflow.dispose();
        this._chromeflow = null;
      }
    } else if (this._mode === 'penrose') {
      if (this._penrose) {
        this._penrose.dispose();
        this._penrose = null;
      }
    } else if (this._mode === 'mycelium') {
      if (this._mycelium) {
        this._mycelium.dispose();
        this._mycelium = null;
      }
    } else if (this._mode === 'blackhole') {
      if (this._blackhole) {
        this._blackhole.dispose();
        this._blackhole = null;
      }
    } else if (this._mode === 'julia') {
      if (this._julia) {
        this._julia.dispose();
        this._julia = null;
      }
    } else if (this._mode === 'slitscan') {
      if (this._slitscan) {
        this._slitscan.dispose();
        this._slitscan = null;
      }
    } else if (this._mode === 'gyro') {
      if (this._gyro) {
        this._gyro.dispose();
        this._gyro = null;
      }
    } else if (this._mode === 'pipes') {
      if (this._pipes) {
        this._pipes.dispose();
        this._pipes = null;
      }
    } else if (this._mode === 'jukebox') {
      if (this._jukebox) {
        this._jukebox.dispose();
        this._jukebox = null;
      }
    } else if (this._mode === 'twist') {
      if (this._twist) {
        this._twist.dispose();
        this._twist = null;
      }
    } else if (this._mode === 'domino') {
      if (this._domino) {
        this._domino.dispose();
        this._domino = null;
      }
    } else if (this._mode === 'scope3d') {
      if (this._scope3d) {
        this._scope3d.dispose();
        this._scope3d = null;
      }
    } else if (this._mode === 'silk') {
      if (this._silk) {
        this._silk.dispose();
        this._silk = null;
      }
    } else if (this._mode === 'swarm') {
      if (this._swarm) {
        this._swarm.dispose();
        this._swarm = null;
      }
    } else if (this._mode === 'focus') {
      if (this._focus) {
        this._focus.dispose();
        this._focus = null;
      }
    } else if (this._mode === 'ocean') {
      if (this._ocean) {
        this._ocean.dispose();
        this._ocean = null;
      }
    } else if (this._mode === 'turing') {
      if (this._turing) {
        this._turing.dispose();
        this._turing = null;
      }
    } else if (this._mode === 'pyro') {
      if (this._pyro) {
        this._pyro.dispose();
        this._pyro = null;
      }
    } else if (this._mode === 'cascade') {
      if (this._cascade) {
        this._cascade.dispose();
        this._cascade = null;
      }
    } else if (this._mode === 'mosh') {
      if (this._mosh) {
        this._mosh.dispose();
        this._mosh = null;
      }
    } else if (this._mode === 'strobewall') {
      if (this._strobewall) {
        this._strobewall.dispose();
        this._strobewall = null;
      }
    } else if (this._mode === 'fireflies') {
      if (this._fireflies) {
        this._fireflies.dispose();
        this._fireflies = null;
      }
    } else if (this._mode === 'polytope') {
      if (this._polytope) {
        this._polytope.dispose();
        this._polytope = null;
      }
    } else if (this._mode === 'cycle') {
      if (this._cycle) {
        this._cycle.dispose();
        this._cycle = null;
      }
    } else if (this._mode === 'thermal') {
      if (this._thermal) {
        this._thermal.dispose();
        this._thermal = null;
      }
    } else if (this._mode === 'warehouse') {
      if (this._warehouse) {
        this._warehouse.dispose();
        this._warehouse = null;
      }
    } else if (this._mode === 'sunroom') {
      if (this._sunroom) {
        this._sunroom.dispose();
        this._sunroom = null;
      }
    } else if (this._mode === 'matrix') {
      if (this._matrix) {
        this._matrix.dispose();
        this._matrix = null;
      }
    } else if (this._mode === 'fairground') {
      if (this._fairground) {
        this._fairground.dispose();
        this._fairground = null;
      }
    } else if (this._mode === 'halo') {
      if (this._halo) {
        this._halo.dispose();
        this._halo = null;
      }
    } else if (this._mode === 'pinscreen') {
      if (this._pinscreen) {
        this._pinscreen.dispose();
        this._pinscreen = null;
      }
    } else if (this._mode === 'moonlake') {
      if (this._moonlake) {
        this._moonlake.dispose();
        this._moonlake = null;
      }
    } else if (this._mode === 'balloons') {
      if (this._balloons) {
        this._balloons.dispose();
        this._balloons = null;
      }
    } else if (this._mode === 'dandelion') {
      if (this._dandelion) {
        this._dandelion.dispose();
        this._dandelion = null;
      }
    } else if (this._mode === 'truchet') {
      if (this._truchet) {
        this._truchet.dispose();
        this._truchet = null;
      }
    } else if (this._mode === 'murmuration') {
      if (this._murmuration) {
        this._murmuration.dispose();
        this._murmuration = null;
      }
    } else if (this._mode === 'neonsign') {
      if (this._neonsign) {
        this._neonsign.dispose();
        this._neonsign = null;
      }
    } else if (this._mode === 'bokeh') {
      if (this._bokeh) {
        this._bokeh.dispose();
        this._bokeh = null;
      }
    } else if (this._mode === 'hourglass') {
      if (this._hourglass) {
        this._hourglass.dispose();
        this._hourglass = null;
      }
    } else if (this._mode === 'chladni') {
      if (this._chladni) {
        this._chladni.dispose();
        this._chladni = null;
      }
    } else if (this._mode === 'ferro') {
      if (this._ferro) {
        this._ferro.dispose();
        this._ferro = null;
      }
    } else if (this._mode === 'fractal') {
      if (this._fractal) {
        this._fractal.dispose();
        this._fractal = null;
      }
    } else if (this._mode === 'poolside') {
      if (this._poolside) {
        this._poolside.dispose();
        this._poolside = null;
      }
    } else if (this._mode === 'magneto') {
      if (this._magneto) {
        this._magneto.dispose();
        this._magneto = null;
      }
    } else if (this._mode === 'videoloop') {
      if (this._videoloop) {
        this._videoloop.dispose();
        this._videoloop = null;
      }
    } else if (this._mode === 'galaxy') {
      if (this._galaxy) {
        this._galaxy.dispose();
        this._galaxy = null;
      }
    } else if (this._mode === 'moire') {
      if (this._moire) {
        this._moire.dispose();
        this._moire = null;
      }
    } else if (this._mode === 'formation') {
      if (this._formation) {
        this._formation.dispose();
        this._formation = null;
      }
    } else if (this._mode === 'facets') {
      if (this._facets) {
        this._facets.dispose();
        this._facets = null;
      }
    } else if (this._mode === 'pyromusical') {
      if (this._pyromusical) {
        this._pyromusical.dispose();
        this._pyromusical = null;
      }
    } else if (this._mode === 'thunderhead') {
      if (this._thunderhead) {
        this._thunderhead.dispose();
        this._thunderhead = null;
      }
    } else if (this._mode === 'cloudsea') {
      if (this._cloudsea) {
        this._cloudsea.dispose();
        this._cloudsea = null;
      }
    } else if (this._mode === 'pixelsort') {
      if (this._pixelsort) {
        this._pixelsort.dispose();
        this._pixelsort = null;
      }
    } else if (this._mode === 'cells') {
      if (this._cells) {
        this._cells.dispose();
        this._cells = null;
      }
    } else if (this._mode === 'cyberflight') {
      if (this._cyberflight) {
        this._cyberflight.dispose();
        this._cyberflight = null;
      }
    } else if (this._mode === 'maze') {
      if (this._maze) {
        this._maze.dispose();
        this._maze = null;
      }
    } else if (this._mode === 'sunburst') {
      if (this._sunburst) {
        this._sunburst.dispose();
        this._sunburst = null;
      }
    } else if (this._mode === 'wavefield') {
      if (this._wavefield) {
        this._wavefield.dispose();
        this._wavefield = null;
      }
    } else if (this._mode === 'contours') {
      if (this._contours) {
        this._contours.dispose();
        this._contours = null;
      }
    } else if (this._mode === 'seasons') {
      if (this._seasons) {
        this._seasons.dispose();
        this._seasons = null;
      }
    } else if (this._mode === 'isocubes') {
      if (this._isocubes) {
        this._isocubes.dispose();
        this._isocubes = null;
      }
    } else if (this._mode === 'datamosh') {
      if (this._datamosh) {
        this._datamosh.dispose();
        this._datamosh = null;
      }
    } else if (this._mode === 'tvwall') {
      if (this._tvwall) {
        this._tvwall.dispose();
        this._tvwall = null;
      }
    } else if (this._mode === 'comic') {
      if (this._comic) {
        this._comic.dispose();
        this._comic = null;
      }
    } else if (this._mode === 'blacklight') {
      if (this._blacklight) {
        this._blacklight.dispose();
        this._blacklight = null;
      }
    } else if (this._mode === 'acid') {
      if (this._acid) {
        this._acid.dispose();
        this._acid = null;
      }
    } else if (this._mode === 'shapes') {
      if (this._shapes) {
        this._shapes.dispose();
        this._shapes = null;
      }
    } else if (this._mode === 'stadium') {
      if (this._stadium) {
        this._stadium.dispose();
        this._stadium = null;
      }
    } else if (this._mode === 'rainwindow') {
      if (this._rainwindow) {
        this._rainwindow.dispose();
        this._rainwindow = null;
      }
    } else if (this._mode === 'hifi') {
      if (this._hifi) {
        this._hifi.dispose();
        this._hifi = null;
      }
    } else if (this._mode === 'woofer') {
      if (this._woofer) {
        this._woofer.dispose();
        this._woofer = null;
      }
    } else if (this._mode === 'countdown') {
      if (this._countdown) {
        this._countdown.dispose();
        this._countdown = null;
      }
    } else if (this._mode === 'hex') {
      if (this._hex) {
        this._hex.dispose();
        this._hex = null;
      }
    } else if (this._mode === 'metronome') {
      if (this._metronome) {
        this._metronome.dispose();
        this._metronome = null;
      }
    } else if (this._mode === 'rosace') {
      if (this._rosace) {
        this._rosace.dispose();
        this._rosace = null;
      }
    } else if (this._mode === 'incense') {
      if (this._incense) {
        this._incense.dispose();
        this._incense = null;
      }
    } else if (this._mode === 'loxodrome') {
      if (this._loxodrome) {
        this._loxodrome.dispose();
        this._loxodrome = null;
      }
    } else if (this._mode === 'hyperbolic') {
      if (this._hyperbolic) {
        this._hyperbolic.dispose();
        this._hyperbolic = null;
      }
    } else if (this._mode === 'tessera') {
      if (this._tessera) {
        this._tessera.dispose();
        this._tessera = null;
      }
    } else if (this._mode === 'blueprint') {
      if (this._blueprint) {
        this._blueprint.dispose();
        this._blueprint = null;
      }
    } else if (this._mode === 'poster') {
      if (this._poster) {
        this._poster.dispose();
        this._poster = null;
      }
    } else if (this._mode === 'kelp') {
      if (this._kelp) {
        this._kelp.dispose();
        this._kelp = null;
      }
    } else if (this._mode === 'beamwall') {
      if (this._beamwall) {
        this._beamwall.dispose();
        this._beamwall = null;
      }
    } else if (this._mode === 'liquidlight') {
      if (this._liquidlight) {
        this._liquidlight.dispose();
        this._liquidlight = null;
      }
    } else if (this._mode === 'steam') {
      if (this._steam) {
        this._steam.dispose();
        this._steam = null;
      }
    } else if (this._mode === 'kineticrig2') {
      if (this._kineticrig2) {
        this._kineticrig2.dispose();
        this._kineticrig2 = null;
      }
    } else if (this._mode === 'maelstrom') {
      if (this._maelstrom) {
        this._maelstrom.dispose();
        this._maelstrom = null;
      }
    } else if (this._mode === 'nightdrive') {
      if (this._nightdrive) {
        this._nightdrive.dispose();
        this._nightdrive = null;
      }
    } else if (this._mode === 'kaleido') {
      if (this._kaleido) {
        this._kaleido.dispose();
        this._kaleido = null;
      }
    } else if (this._mode === 'tessel') {
      if (this._tessel) {
        this._tessel.dispose();
        this._tessel = null;
      }

    } else if (this._mode === 'nebula') {
      if (this._nebula) {
        this._nebula.dispose();
        this._nebula = null;
      }
    } else if (this._mode === 'frost') {
      if (this._frost) {
        this._frost.dispose();
        this._frost = null;
      }

    } else if (this._mode === 'gallery') {
      if (this._gallery) {
        this._gallery.dispose();
        this._gallery = null;
      }
    } else if (this._mode === 'splitflap') {
      if (this._splitflap) {
        this._splitflap.dispose();
        this._splitflap = null;
      }
    } else if (this._mode === 'prism') {
      if (this._prism) {
        this._prism.dispose();
        this._prism = null;
      }
    } else if (this._mode === 'shoji') {
      if (this._shoji) {
        this._shoji.dispose();
        this._shoji = null;
      }
    } else if (this._mode === 'sand') {
      if (this._sand) {
        this._sand.dispose();
        this._sand = null;
      }
    } else if (this._mode === 'loom') {
      if (this._loom) {
        this._loom.dispose();
        this._loom = null;
      }
    } else if (this._mode === 'particles') {
      if (this._rig) {
        stageRig.release(RIG_OWNER);
        this._rig = null;
      }
      if (this._floor) {
        this._scene.remove(this._floor);
        this._floor.geometry.dispose();
        this._floor.material.dispose();
        this._floor = null;
      }
      if (this._dust) {
        this._dust.dispose(this._scene);
        this._dust = null;
      }
      if (this._storm) {
        this._storm.dispose(this._scene);
        this._storm = null;
      }
    }
    this._mode = null;
  }

  _updateActive(deltaTime, profile) {
    if (this._mode === 'fallback') {
      this._fallback.update(deltaTime, profile);
    } else if (this._mode === 'spotwall') {
      this._spotwall.update(deltaTime, profile);
    } else if (this._mode === 'neongrid') {
      this._neongrid.update(deltaTime, profile);
    } else if (this._mode === 'discosquares') {
      this._discosquares.update(deltaTime, profile);
    } else if (this._mode === 'neonparticles') {
      this._neonparticles.update(deltaTime, profile);
    } else if (this._mode === 'daftpyramid') {
      this._daftpyramid.update(deltaTime, profile);
    } else if (this._mode === 'pulsecore') {
      this._pulsecore.update(deltaTime, profile);
    } else if (this._mode === 'mainstage') {
      this._mainstage.update(deltaTime, profile);
    } else if (this._mode === 'vinylgroove') {
      this._vinylgroove.update(deltaTime, profile);
    } else if (this._mode === 'typeslam') {
      this._typeslam.update(deltaTime, profile);
    } else if (this._mode === 'kaleidodrift') {
      this._kaleidodrift.update(deltaTime, profile);
    } else if (this._mode === 'chromeflux') {
      this._chromeflux.update(deltaTime, profile);
    } else if (this._mode === 'constellation') {
      this._constellation.update(deltaTime, profile);
    } else if (this._mode === 'phosphorscope') {
      this._phosphorscope.update(deltaTime, profile);
    } else if (this._mode === 'drostedive') {
      this._drostedive.update(deltaTime, profile);
    } else if (this._mode === 'tunnel') {
      this._tunnel.update(deltaTime, profile);
    } else if (this._mode === 'lasergrid') {
      this._lasergrid.update(deltaTime, profile);
    } else if (this._mode === 'lasercathedral') {
      this._lasercathedral.update(deltaTime, profile);
    } else if (this._mode === 'kineticrig') {
      this._kineticrig.update(deltaTime, profile);
    } else if (this._mode === 'resonance') {
      this._resonance.update(deltaTime, profile);
    } else if (this._mode === 'halftone') {
      this._halftone.update(deltaTime, profile);
    } else if (this._mode === 'sumi') {
      this._sumi.update(deltaTime, profile);
    } else if (this._mode === 'caustics') {
      this._caustics.update(deltaTime, profile);
    } else if (this._mode === 'aurora') {
      this._aurora.update(deltaTime, profile);
    } else if (this._mode === 'reed') {
      this._reed.update(deltaTime, profile);
    } else if (this._mode === 'anamorph') {
      this._anamorph.update(deltaTime, profile);
    } else if (this._mode === 'portal') {
      this._portal.update(deltaTime, profile);
    } else if (this._mode === 'echo') {
      this._echo.update(deltaTime, profile);
    } else if (this._mode === 'preset') {
      this._preset.update(deltaTime, profile);
    } else if (this._mode === 'shatter') {
      this._shatter.update(deltaTime, profile);
    } else if (this._mode === 'infinity') {
      this._infinity.update(deltaTime, profile);
    } else if (this._mode === 'ember') {
      this._ember.update(deltaTime, profile);
    } else if (this._mode === 'lichtenberg') {
      this._lichtenberg.update(deltaTime, profile);
    } else if (this._mode === 'origami') {
      this._origami.update(deltaTime, profile);
    } else if (this._mode === 'portals') {
      this._portals.update(deltaTime, profile);
    } else if (this._mode === 'advect') {
      this._advect.update(deltaTime, profile);
    } else if (this._mode === 'ravesign') {
      this._ravesign.update(deltaTime, profile);
    } else if (this._mode === 'airframe') {
      this._airframe.update(deltaTime, profile);
    } else if (this._mode === 'vertigo') {
      this._vertigo.update(deltaTime, profile);
    } else if (this._mode === 'lantern') {
      this._lantern.update(deltaTime, profile);
    } else if (this._mode === 'bayfront') {
      this._bayfront.update(deltaTime, profile);
    } else if (this._mode === 'signal') {
      this._signal.update(deltaTime, profile);
    } else if (this._mode === 'lighthouse') {
      this._lighthouse.update(deltaTime, profile);
    } else if (this._mode === 'jellyfish') {
      this._jellyfish.update(deltaTime, profile);
    } else if (this._mode === 'pendula') {
      this._pendula.update(deltaTime, profile);
    } else if (this._mode === 'texer') {
      this._texer.update(deltaTime, profile);
    } else if (this._mode === 'outrun') {
      this._outrun.update(deltaTime, profile);
    } else if (this._mode === 'panels') {
      this._panels.update(deltaTime, profile);
    } else if (this._mode === 'bubble') {
      this._bubble.update(deltaTime, profile);
    } else if (this._mode === 'ballroom') {
      this._ballroom.update(deltaTime, profile);
    } else if (this._mode === 'flowmap') {
      this._flowmap.update(deltaTime, profile);
    } else if (this._mode === 'totem') {
      this._totem.update(deltaTime, profile);
    } else if (this._mode === 'ribbons') {
      this._ribbons.update(deltaTime, profile);
    } else if (this._mode === 'shockwave') {
      this._shockwave.update(deltaTime, profile);
    } else if (this._mode === 'ink') {
      this._ink.update(deltaTime, profile);
    } else if (this._mode === 'drones') {
      this._drones.update(deltaTime, profile);
    } else if (this._mode === 'aspen') {
      this._aspen.update(deltaTime, profile);
    } else if (this._mode === 'mirrorarray') {
      this._mirrorarray.update(deltaTime, profile);
    } else if (this._mode === 'neonalley') {
      this._neonalley.update(deltaTime, profile);
    } else if (this._mode === 'underground') {
      this._underground.update(deltaTime, profile);
    } else if (this._mode === 'frames') {
      this._frames.update(deltaTime, profile);
    } else if (this._mode === 'flame') {
      this._flame.update(deltaTime, profile);
    } else if (this._mode === 'eclipse') {
      this._eclipse.update(deltaTime, profile);
    } else if (this._mode === 'pane') {
      this._pane.update(deltaTime, profile);
    } else if (this._mode === 'splitflap2') {
      this._splitflap2.update(deltaTime, profile);
    } else if (this._mode === 'headliner') {
      this._headliner.update(deltaTime, profile);
    } else if (this._mode === 'hangar') {
      this._hangar.update(deltaTime, profile);
    } else if (this._mode === 'goldenhour') {
      this._goldenhour.update(deltaTime, profile);
    } else if (this._mode === 'hyperspace') {
      this._hyperspace.update(deltaTime, profile);
    } else if (this._mode === 'dancefloor') {
      this._dancefloor.update(deltaTime, profile);
    } else if (this._mode === 'mixdeck') {
      this._mixdeck.update(deltaTime, profile);
    } else if (this._mode === 'typeclash') {
      this._typeclash.update(deltaTime, profile);
    } else if (this._mode === 'mandala') {
      this._mandala.update(deltaTime, profile);
    } else if (this._mode === 'hyperloop') {
      this._hyperloop.update(deltaTime, profile);
    } else if (this._mode === 'lightcycles') {
      this._lightcycles.update(deltaTime, profile);
    } else if (this._mode === 'pinball') {
      this._pinball.update(deltaTime, profile);
    } else if (this._mode === 'glowtide') {
      this._glowtide.update(deltaTime, profile);
    } else if (this._mode === 'tesla') {
      this._tesla.update(deltaTime, profile);
    } else if (this._mode === 'koi') {
      this._koi.update(deltaTime, profile);
    } else if (this._mode === 'pulsar') {
      this._pulsar.update(deltaTime, profile);
    } else if (this._mode === 'skyline') {
      this._skyline.update(deltaTime, profile);
    } else if (this._mode === 'arcade') {
      this._arcade.update(deltaTime, profile);
    } else if (this._mode === 'bloom') {
      this._bloom.update(deltaTime, profile);
    } else if (this._mode === 'fountain') {
      this._fountain.update(deltaTime, profile);
    } else if (this._mode === 'harp') {
      this._harp.update(deltaTime, profile);
    } else if (this._mode === 'kintsugi') {
      this._kintsugi.update(deltaTime, profile);
    } else if (this._mode === 'lightpaint') {
      this._lightpaint.update(deltaTime, profile);
    } else if (this._mode === 'startrails') {
      this._startrails.update(deltaTime, profile);
    } else if (this._mode === 'metro') {
      this._metro.update(deltaTime, profile);
    } else if (this._mode === 'zoetrope') {
      this._zoetrope.update(deltaTime, profile);
    } else if (this._mode === 'morph') {
      this._morph.update(deltaTime, profile);
    } else if (this._mode === 'branches') {
      this._branches.update(deltaTime, profile);
    } else if (this._mode === 'mobius') {
      this._mobius.update(deltaTime, profile);
    } else if (this._mode === 'doorways') {
      this._doorways.update(deltaTime, profile);
    } else if (this._mode === 'cymatics') {
      this._cymatics.update(deltaTime, profile);
    } else if (this._mode === 'leviathan') {
      this._leviathan.update(deltaTime, profile);
    } else if (this._mode === 'rings') {
      this._rings.update(deltaTime, profile);
    } else if (this._mode === 'poincare') {
      this._poincare.update(deltaTime, profile);
    } else if (this._mode === 'oilshow') {
      this._oilshow.update(deltaTime, profile);
    } else if (this._mode === 'kinetic') {
      this._kinetic.update(deltaTime, profile);
    } else if (this._mode === 'haze') {
      this._haze.update(deltaTime, profile);
    } else if (this._mode === 'borealis') {
      this._borealis.update(deltaTime, profile);
    } else if (this._mode === 'ledcube') {
      this._ledcube.update(deltaTime, profile);
    } else if (this._mode === 'bauhaus') {
      this._bauhaus.update(deltaTime, profile);
    } else if (this._mode === 'dissolve') {
      this._dissolve.update(deltaTime, profile);
    } else if (this._mode === 'glass') {
      this._glass.update(deltaTime, profile);
    } else if (this._mode === 'glyphs') {
      this._glyphs.update(deltaTime, profile);
    } else if (this._mode === 'bubbles') {
      this._bubbles.update(deltaTime, profile);
    } else if (this._mode === 'chromeflow') {
      this._chromeflow.update(deltaTime, profile);
    } else if (this._mode === 'penrose') {
      this._penrose.update(deltaTime, profile);
    } else if (this._mode === 'mycelium') {
      this._mycelium.update(deltaTime, profile);
    } else if (this._mode === 'blackhole') {
      this._blackhole.update(deltaTime, profile);
    } else if (this._mode === 'julia') {
      this._julia.update(deltaTime, profile);
    } else if (this._mode === 'slitscan') {
      this._slitscan.update(deltaTime, profile);
    } else if (this._mode === 'gyro') {
      this._gyro.update(deltaTime, profile);
    } else if (this._mode === 'pipes') {
      this._pipes.update(deltaTime, profile);
    } else if (this._mode === 'jukebox') {
      this._jukebox.update(deltaTime, profile);
    } else if (this._mode === 'twist') {
      this._twist.update(deltaTime, profile);
    } else if (this._mode === 'domino') {
      this._domino.update(deltaTime, profile);
    } else if (this._mode === 'scope3d') {
      this._scope3d.update(deltaTime, profile);
    } else if (this._mode === 'silk') {
      this._silk.update(deltaTime, profile);
    } else if (this._mode === 'swarm') {
      this._swarm.update(deltaTime, profile);
    } else if (this._mode === 'focus') {
      this._focus.update(deltaTime, profile);
    } else if (this._mode === 'ocean') {
      this._ocean.update(deltaTime, profile);
    } else if (this._mode === 'turing') {
      this._turing.update(deltaTime, profile);
    } else if (this._mode === 'pyro') {
      this._pyro.update(deltaTime, profile);
    } else if (this._mode === 'cascade') {
      this._cascade.update(deltaTime, profile);
    } else if (this._mode === 'mosh') {
      this._mosh.update(deltaTime, profile);
    } else if (this._mode === 'strobewall') {
      this._strobewall.update(deltaTime, profile);
    } else if (this._mode === 'fireflies') {
      this._fireflies.update(deltaTime, profile);
    } else if (this._mode === 'polytope') {
      this._polytope.update(deltaTime, profile);
    } else if (this._mode === 'cycle') {
      this._cycle.update(deltaTime, profile);
    } else if (this._mode === 'thermal') {
      this._thermal.update(deltaTime, profile);
    } else if (this._mode === 'warehouse') {
      this._warehouse.update(deltaTime, profile);
    } else if (this._mode === 'sunroom') {
      this._sunroom.update(deltaTime, profile);
    } else if (this._mode === 'matrix') {
      this._matrix.update(deltaTime, profile);
    } else if (this._mode === 'fairground') {
      this._fairground.update(deltaTime, profile);
    } else if (this._mode === 'halo') {
      this._halo.update(deltaTime, profile);
    } else if (this._mode === 'pinscreen') {
      this._pinscreen.update(deltaTime, profile);
    } else if (this._mode === 'moonlake') {
      this._moonlake.update(deltaTime, profile);
    } else if (this._mode === 'balloons') {
      this._balloons.update(deltaTime, profile);
    } else if (this._mode === 'dandelion') {
      this._dandelion.update(deltaTime, profile);
    } else if (this._mode === 'truchet') {
      this._truchet.update(deltaTime, profile);
    } else if (this._mode === 'murmuration') {
      this._murmuration.update(deltaTime, profile);
    } else if (this._mode === 'neonsign') {
      this._neonsign.update(deltaTime, profile);
    } else if (this._mode === 'bokeh') {
      this._bokeh.update(deltaTime, profile);
    } else if (this._mode === 'hourglass') {
      this._hourglass.update(deltaTime, profile);
    } else if (this._mode === 'chladni') {
      this._chladni.update(deltaTime, profile);
    } else if (this._mode === 'ferro') {
      this._ferro.update(deltaTime, profile);
    } else if (this._mode === 'fractal') {
      this._fractal.update(deltaTime, profile);
    } else if (this._mode === 'poolside') {
      this._poolside.update(deltaTime, profile);
    } else if (this._mode === 'magneto') {
      this._magneto.update(deltaTime, profile);
    } else if (this._mode === 'videoloop') {
      this._videoloop.update(deltaTime, profile);
    } else if (this._mode === 'galaxy') {
      this._galaxy.update(deltaTime, profile);
    } else if (this._mode === 'moire') {
      this._moire.update(deltaTime, profile);
    } else if (this._mode === 'formation') {
      this._formation.update(deltaTime, profile);
    } else if (this._mode === 'facets') {
      this._facets.update(deltaTime, profile);
    } else if (this._mode === 'pyromusical') {
      this._pyromusical.update(deltaTime, profile);
    } else if (this._mode === 'thunderhead') {
      this._thunderhead.update(deltaTime, profile);
    } else if (this._mode === 'cloudsea') {
      this._cloudsea.update(deltaTime, profile);
    } else if (this._mode === 'pixelsort') {
      this._pixelsort.update(deltaTime, profile);
    } else if (this._mode === 'cells') {
      this._cells.update(deltaTime, profile);
    } else if (this._mode === 'cyberflight') {
      this._cyberflight.update(deltaTime, profile);
    } else if (this._mode === 'maze') {
      this._maze.update(deltaTime, profile);
    } else if (this._mode === 'sunburst') {
      this._sunburst.update(deltaTime, profile);
    } else if (this._mode === 'wavefield') {
      this._wavefield.update(deltaTime, profile);
    } else if (this._mode === 'contours') {
      this._contours.update(deltaTime, profile);
    } else if (this._mode === 'seasons') {
      this._seasons.update(deltaTime, profile);
    } else if (this._mode === 'isocubes') {
      this._isocubes.update(deltaTime, profile);
    } else if (this._mode === 'datamosh') {
      this._datamosh.update(deltaTime, profile);
    } else if (this._mode === 'tvwall') {
      this._tvwall.update(deltaTime, profile);
    } else if (this._mode === 'comic') {
      this._comic.update(deltaTime, profile);
    } else if (this._mode === 'blacklight') {
      this._blacklight.update(deltaTime, profile);
    } else if (this._mode === 'acid') {
      this._acid.update(deltaTime, profile);
    } else if (this._mode === 'shapes') {
      this._shapes.update(deltaTime, profile);
    } else if (this._mode === 'stadium') {
      this._stadium.update(deltaTime, profile);
    } else if (this._mode === 'rainwindow') {
      this._rainwindow.update(deltaTime, profile);
    } else if (this._mode === 'hifi') {
      this._hifi.update(deltaTime, profile);
    } else if (this._mode === 'woofer') {
      this._woofer.update(deltaTime, profile);
    } else if (this._mode === 'countdown') {
      this._countdown.update(deltaTime, profile);
    } else if (this._mode === 'hex') {
      this._hex.update(deltaTime, profile);
    } else if (this._mode === 'metronome') {
      this._metronome.update(deltaTime, profile);
    } else if (this._mode === 'rosace') {
      this._rosace.update(deltaTime, profile);
    } else if (this._mode === 'incense') {
      this._incense.update(deltaTime, profile);
    } else if (this._mode === 'loxodrome') {
      this._loxodrome.update(deltaTime, profile);
    } else if (this._mode === 'hyperbolic') {
      this._hyperbolic.update(deltaTime, profile);
    } else if (this._mode === 'tessera') {
      this._tessera.update(deltaTime, profile);
    } else if (this._mode === 'blueprint') {
      this._blueprint.update(deltaTime, profile);
    } else if (this._mode === 'poster') {
      this._poster.update(deltaTime, profile);
    } else if (this._mode === 'kelp') {
      this._kelp.update(deltaTime, profile);
    } else if (this._mode === 'beamwall') {
      this._beamwall.update(deltaTime, profile);
    } else if (this._mode === 'liquidlight') {
      this._liquidlight.update(deltaTime, profile);
    } else if (this._mode === 'steam') {
      this._steam.update(deltaTime, profile);
    } else if (this._mode === 'kineticrig2') {
      this._kineticrig2.update(deltaTime, profile);
    } else if (this._mode === 'maelstrom') {
      this._maelstrom.update(deltaTime, profile);
    } else if (this._mode === 'nightdrive') {
      this._nightdrive.update(deltaTime, profile);
    } else if (this._mode === 'kaleido') {
      this._kaleido.update(deltaTime, profile);
    } else if (this._mode === 'tessel') {
      this._tessel.update(deltaTime, profile);

    } else if (this._mode === 'nebula') {
      this._nebula.update(deltaTime, profile);
    } else if (this._mode === 'frost') {
      this._frost.update(deltaTime, profile);

    } else if (this._mode === 'gallery') {
      this._gallery.update(deltaTime, profile);
    } else if (this._mode === 'splitflap') {
      this._splitflap.update(deltaTime, profile);
    } else if (this._mode === 'prism') {
      this._prism.update(deltaTime, profile);
    } else if (this._mode === 'shoji') {
      this._shoji.update(deltaTime, profile);
    } else if (this._mode === 'sand') {
      this._sand.update(deltaTime, profile);
    } else if (this._mode === 'loom') {
      this._loom.update(deltaTime, profile);
    } else if (this._mode === 'particles') {
      stageRig.update(deltaTime, profile, RIG_OWNER);
      if (this._dust) this._dust.update(deltaTime, profile);
      if (this._storm) this._storm.update(deltaTime, profile, this._rig);
    }
  }

  // CHANTIER 6 (revision) - scheduledDurationSeconds is already
  // compensated for the average phrase-rounding delay (see
  // computeCompositionDuration's own comment) - pace (the ?pace=/
  // localStorage debug dial) scales it on top of that, uniformly.
  // ?swap=1 overrides both with a short fixed cadence, so debug iteration
  // doesn't still wait out a real musical duration.
  _scheduleNext(decision) {
    let interval;
    if (this._debugImmediateSwap) {
      interval = DEBUG_IMMEDIATE_RECHECK_S;
    } else if (decision.mode === 'orchestrated' && decision.changed === false) {
      // Hysteresis (chantier 5) held the incumbent rather than switching -
      // the composition's OWN desired duration was already budgeted back
      // when it actually started (see _swapTo). Rescheduling with a fresh
      // FULL duration here would let a held composition keep running in
      // ever-compounding full-duration steps, silently defeating AC1's
      // "observed matches desired" guarantee (chantier 6, revision) -
      // retry again soon instead, so a composition that's already run its
      // course gets re-evaluated often until something finally clears the
      // hysteresis bar.
      interval = HYSTERESIS_HOLD_RETRY_S;
    } else if (decision.mode === 'orchestrated') {
      interval = decision.scheduledDurationSeconds * this._pace;
    } else {
      interval = FALLBACK_RECHECK_S;
    }
    this._nextCheckAt = this._time + interval;
  }

  // Hard cut: dispose the old composition and build the new one in the
  // same synchronous call, so no frame ever renders an empty scene.
  // decision is optional - null specifically means "not a real pick" (the
  // CHANTIER 7 tier-driven rebuild, which reconstructs the SAME
  // composition at a new tier and must not disturb its own duration
  // clock/history/log - see _tickQualityTier). A real decision, present
  // and orchestrated, does three things a null one skips entirely:
  // records primary id/family into _history (chantier 5's recency/family
  // penalties), starts this composition's own duration clock, and - if a
  // PREVIOUS composition's clock was running - logs how long that one
  // actually lasted against what it was supposed to (chantier 6, revision
  // - see getScheduleDebugInfo/_compositionLog).
  _swapTo(targetKey, profile, decision) {
    // La marque « choisie à la main » ne vaut que pour la composition qu'on a
    // cliquée : dès qu'on en joue une autre, elle tombe.
    if (this._choisiAMain && targetKey !== this._choisiAMain) this._choisiAMain = null;
    if (decision && this._activeCompositionStartedAt != null && this._activeCompositionDesiredSeconds != null) {
      this._compositionLog.push({
        key: this._currentKey,
        mode: this._activeCompositionMode,
        bpm: this._activeCompositionBpm,
        desiredSeconds: this._activeCompositionDesiredSeconds,
        observedSeconds: this._time - this._activeCompositionStartedAt
      });
      if (this._compositionLog.length > COMPOSITION_LOG_LIMIT) this._compositionLog.shift();
    }

    this._disposeActive();
    this._buildComposition(targetKey, profile);
    this._currentKey = targetKey;
    // CHANTIER 7 - whatever tier THIS build actually used, so
    // _tickQualityTier only rebuilds again once the governor moves past
    // this composition's own tier, not on every frame.
    this._lastAppliedQualityTier = this._currentQualityTier(profile);

    if (decision) {
      // Filler transitions (see FILLER_MIN_S/DANCEABILITY_DWELL_MAX_S) - a
      // fresh, danceability-driven window after EVERY real swap, whatever
      // triggered it (a mark, a filler itself, a track change), so fillers
      // never stack up back to back with something that just happened to
      // change the visual anyway.
      this._nextFillerCheckAt = this._time + computeDanceabilityDwellSeconds(
        profile.trackFeatures && profile.trackFeatures.bpm,
        danceIndex(profile), FILLER_MIN_S, DANCEABILITY_DWELL_MAX_S
      ).scheduledSeconds;
      this._activeCompositionStartedAt = this._time;
      if (decision.mode === 'orchestrated') {
        this._activeCompositionDesiredSeconds = decision.desiredDurationSeconds * this._pace;
        this._activeCompositionMode = profile.director ? profile.director.mode : null;
        this._activeCompositionBpm = profile.trackFeatures && profile.trackFeatures.bpm;
        const entry = decision.scored.find(function (s) { return s.id === decision.primary; });
        if (entry) {
          this._history.unshift({ id: entry.id, family: entry.viz.family });
          // La mémoire de l'écran (diversite.js) : ce qui passe pèse moins ensuite.
          noterExposition(entry.id);
          if (this._history.length > HISTORY_LENGTH) this._history.length = HISTORY_LENGTH;
        }
        // Le vivier entier a été joué : nouveau tour, qui commence par celle-ci.
        if (decision.poolExhausted) this._jouees.clear();
        this._jouees.add(decision.primary);
      } else {
        this._activeCompositionDesiredSeconds = null;
        this._activeCompositionMode = null;
        this._activeCompositionBpm = null;
      }
    }
  }

  // How far (seconds) the active composition has run past its OWN desired
  // duration - undefined before it's even started, or before it's reached
  // that duration at all (nothing overrun yet).
  _overrunSeconds() {
    if (this._activeCompositionDesiredSeconds == null || this._activeCompositionStartedAt == null) return undefined;
    const elapsed = this._time - this._activeCompositionStartedAt;
    const overrun = elapsed - this._activeCompositionDesiredSeconds;
    return overrun > 0 ? overrun : undefined;
  }

  // The incumbent is hard-excluded from the very next decision the INSTANT
  // it reaches its own desired duration - see the constants block above
  // for why (armSwap needs to fire at exactly the intended moment, not
  // some delay later, or the phrase-lock wait that follows double-counts
  // against the "-8 beats" compensation already baked into that duration).
  _currentExcludeId() {
    if (this._overrunSeconds() == null) return undefined;
    // _currentKey can be a compound "dust+storm"-style key (chantier 5's
    // compatible pairs) - orchestrator.js's own candidate ids never are,
    // so exclude the PRIMARY id specifically. history[0] is exactly that:
    // recorded by _swapTo from decision.primary when this composition
    // started.
    return this._history.length > 0 ? this._history[0].id : undefined;
  }

  // Belt-and-suspenders alongside _currentExcludeId above (which normally
  // makes this moot - an excluded incumbent is never found by the
  // hysteresis comparison at all): undefined (full protection) until the
  // active composition reaches its own desired duration, 1.0 (none) the
  // instant it does.
  _currentHysteresisFactor() {
    return this._overrunSeconds() == null ? undefined : 1.0;
  }

  // Overlay data (see party-mode-controller.js) - mode courant, duree
  // calculee en temps ET secondes, temps ecoule, swap arme ou non, pace.
  getScheduleDebugInfo() {
    const bpm = this._activeCompositionBpm;
    const desiredBeats = bpm && this._activeCompositionDesiredSeconds != null
      ? this._activeCompositionDesiredSeconds / (60 / bpm)
      : null;
    return {
      // La composition REELLEMENT a l'ecran, pas 'AdaptiveParty'. C'est la
      // seule reponse utile a "qu'est-ce que je regarde" quand le mode
      // orchestre tourne, et l'overlay de debug ne lit que ca.
      key: this._currentKey,
      mode: this._activeCompositionMode,
      desiredSeconds: this._activeCompositionDesiredSeconds,
      desiredBeats: desiredBeats,
      elapsedSeconds: this._activeCompositionStartedAt != null ? this._time - this._activeCompositionStartedAt : null,
      armed: !!this._armed,
      armedType: this._armed ? this._armed.type : null,
      pace: this._pace
    };
  }

  // Decides WHAT the next composition will be and HOW it will arrive,
  // without touching the scene yet - the actual _swapTo happens later,
  // from _tickArmed, on the next phrase downbeat (or immediately, if that
  // downbeat is too far away / bpm is unknown - see MAX_WAIT_FOR_DOWNBEAT_S).
  // options.forceImmediate: radiopi's own strong-drop response (see
  // _handleMark) only - those marks are a precise, known timestamp in the
  // actual audio, not a vibe-shift signal like dropInterrupt's synthetic
  // envelope, so waiting up to MAX_WAIT_FOR_DOWNBEAT_S for a musically-nice
  // downbeat defeats the entire point of reacting to a KNOWN moment - it
  // was landing the visible swap ~2-5s after the mark it was supposed to
  // line up with (diagnosed live against the predicted mark list). CUT (or
  // options.forceType), applied on the very next frame, same as the
  // no-bpm/debug-swap immediate path already does.
  // options.forceType: skip pickTransitionType's weighted draw and use
  // this transition type outright (radiopi mark responses each dictate
  // their own type, not a random pick against director.mode).
  // options.alignToBeat: wait for the next BEAT wrap instead of the next
  // PHRASE wrap (radiopi's "drop moyen/montée forte" response - the mark
  // is a precise instant, but firing between two beats still reads as
  // sloppy, so align to the nearest one rather than either the full
  // phrase-lock wait or a same-frame cut).
  _armSwap(targetKey, decision, profile, options) {
    const opts = options || {};
    const bpm = profile.trackFeatures && profile.trackFeatures.bpm;
    const mode = profile.director ? profile.director.mode : null;
    let immediate = opts.forceImmediate || this._debugImmediateSwap || !bpm || profile.phrasePhase == null;
    if (!immediate && !opts.alignToBeat) {
      const secondsPerBeat = 60 / bpm;
      const secondsUntilDownbeat = (1 - profile.phrasePhase) * secondsPerBeat * BEATS_PER_PHRASE;
      if (secondsUntilDownbeat > MAX_WAIT_FOR_DOWNBEAT_S) immediate = true;
    }
    this._armed = {
      targetKey: targetKey,
      decision: decision,
      type: opts.forceType || (immediate ? 'CUT' : pickTransitionType(mode)),
      // A strong measured drop keeps its instant FLASH even on a calm track.
      keepCut: opts.forceType === 'FLASH' && !!opts.forceImmediate,
      immediate: immediate,
      alignToBeat: !!opts.alignToBeat && !immediate
    };
    // Seeded with the CURRENT phrasePhase/beatPhase, not null: update()'s
    // own wrap check (profile.phrasePhase < this._lastPhrasePhase, or the
    // beat-phase equivalent for an alignToBeat arm) needs a real baseline
    // to compare the very first post-arm frame against. A null seed can't
    // detect a wrap that happens in the gap between arming and that first
    // check - and arming this close to a boundary is the common case
    // (armSwap fires the instant a composition reaches its own desired
    // duration - chantier 6, revision), not a rare edge case: a null seed
    // there missed the wrap for an entire extra phrase/beat, every time.
    this._lastPhrasePhase = profile.phrasePhase;
    this._lastBeatPhase = profile.beatPhase;
  }

  // Starts whichever transition _armed.type calls for. CUT/FLASH apply the
  // swap synchronously and clear _armed immediately; BLACK/PUSH instead
  // hand off to _transition, ticked every subsequent frame from update()
  // until THEY perform the actual _swapTo.
  // L'intensité de la phase, 0..1, RELATIVE AU TITRE (voir
  // orchestrator.js, intensityNeighbours). Pour un point : son énergie de
  // phase rapportée à l'étendue des énergies de phase de ce titre ; sans elle,
  // l'énergie du segment qui commence (lookupEnergy, déjà relative au titre).
  // null sans analyse : le tirage reste alors celui d'avant.
  _phaseIntensity(profile, atMs, mark) {
    const tl = profile.analysisTimeline;
    if (!tl) return null;
    if (mark && typeof mark.energy === 'number' && this._marks && this._marks.length) {
      let lo = Infinity, hi = -Infinity;
      for (const m of this._marks) if (typeof m.energy === 'number') { lo = Math.min(lo, m.energy); hi = Math.max(hi, m.energy); }
      if (hi - lo > 1e-6) return clamp01((mark.energy - lo) / (hi - lo));
    }
    const e = tl.lookupEnergy ? tl.lookupEnergy(atMs + 1500) : null;
    return e == null ? null : clamp01(e / 100);
  }

  // LE PLAN D'INTENSITÉ DU TITRE (01/10/2026, orchestrator.planIntensite) :
  // toutes ses phases — le début et chaque point de mix — avec leur énergie,
  // lissée sur les montées et ramenée à leur RANG dans le titre. Recalculé
  // quand les marks changent. La phase la plus forte vise le haut du vivier ;
  // une phase qui monte ne redescend pas sous le visuel à l'écran.
  _plan(profile) {
    if (this._planPour === this._marks && this._planProfil === profile.trackId) return this._planCache;
    const phases = [{ atMs: 0, raw: this._phaseIntensity(profile, 0, null) }];
    const tl = profile.analysisTimeline;
    const cible = tl && tl.countdownTarget ? tl.countdownTarget.atMs : null;
    for (const m of this._marks || []) {
      if (m.type === 'countdown') continue;
      phases.push({ atMs: m.atMs, raw: this._phaseIntensity(profile, m.atMs, m), principal: !!m.principal || (cible != null && m.type === 'drop' && m.atMs === cible) });
    }
    phases.sort(function (a, b) { return a.atMs - b.atMs; });
    this._planPour = this._marks; this._planProfil = profile.trackId;
    // Un plan d'UNE phase (l'analyse n'est pas encore là) la mettrait au
    // sommet : le premier visuel partait sur le plus haut du vivier.
    this._planCache = phases.length >= 2 && phases.some(function (p) { return p.raw != null; }) ? planIntensite(phases) : null;
    return this._planCache;
  }

  // { intensity, plancherDansabilite } pour un choix à l'instant atMs.
  _intensiteChoix(profile, atMs) {
    const plan = this._plan(profile);
    if (!plan) {
      const brut = this._phaseIntensity(profile, atMs, null);
      return { intensity: brut, plancherDansabilite: undefined };
    }
    let ph = plan[0];
    for (const p of plan) { if (p.atMs <= atMs + 50) ph = p; else break; }
    let plancher;
    if (ph.monte) {
      const courant = this._history && this._history.length ? this._history[0].id : null;
      const v = courant ? BIBLIOTHEQUE.find(function (x) { return x.id === courant; }) : null;
      if (v && v.danceability != null) plancher = v.danceability;
    }
    return { intensity: ph.rang, plancherDansabilite: plancher };
  }

  // Countdown holds the screen from its launch to the drop it counts to.
  _countdownHolds(nowMs) {
    return this._currentKey === COUNTDOWN_ID && this._countdownHoldUntilMs != null && nowMs < this._countdownHoldUntilMs;
  }

  // Arms Countdown towards the drop at targetMs and makes it hold until then.
  _lancerCountdown(profile, targetMs, nowMs, directorMode, pourquoi) {
    this._countdownJoue = true;
    this._countdownFor = targetMs;
    this._countdownHoldUntilMs = targetMs;
    this._countdownLaunchedAt = this._time;
    // How long it is meant to hold: exactly the count, drop to drop.
    this._countdownPlayS = Math.max(0, (targetMs - nowMs) / 1000);
    const features = profile.trackFeatures;
    const duration = computeCompositionDuration(directorMode, features && features.bpm, danceIndex(profile) * 100, features && features.energy);
    const decision = { mode: 'orchestrated', layers: [COUNTDOWN_ID], primary: COUNTDOWN_ID, changed: true, scored: [],
      desiredDurationSeconds: duration.desiredSeconds, scheduledDurationSeconds: duration.scheduledSeconds };
    // eslint-disable-next-line no-console
    console.log('[orchestration] countdown lancé (' + pourquoi + '), drop dans ' + ((targetMs - nowMs) / 1000).toFixed(1) + ' s');
    this._armSwap(COUNTDOWN_ID, decision, profile, { alignToBeat: true });
  }

  // THE COUNTDOWN MIX POINT (track-analysis.js, addCountdownMarks): a drop
  // identified with high certainty has its own point, a whole number of bars
  // before it. Launched without hesitating: no pool check and no gap rule,
  // only what makes the piece impossible (no analysis or grid, disabled, not
  // on this tier, drop under 8 beats away) and a register floor - a calm track
  // does not get a countdown. Returns true when handled.
  _pointCountdown(mark, profile, nowMs, trackDataInput, directorMode) {
    if (this._forcedId || this._countdownJoue || this._countdownFor === mark.targetMs) return true;
    const cible = profile.analysisTimeline && profile.analysisTimeline.countdownTarget;
    if (!cible || cible.atMs !== mark.targetMs) return true;
    const cand = getCandidate(COUNTDOWN_ID);
    if (!cand || cand.enabled === false) return true;
    if (!libraryForTier(this._currentQualityTier(profile)).some((v) => v.id === COUNTDOWN_ID)) return true;
    const d = danceIndex(profile);
    if (d != null && d < COUNTDOWN_MIN_DANCE) return true;
    const porte = Object.assign({}, trackDataInput, { dropTrigger: true, msUntilNextDrop: mark.targetMs - nowMs,
      beatsUntilNextDrop: beatsUntil(profile, mark.targetMs - nowMs) });
    const refus = requirementFailure(cand, porte);
    if (refus) {
      // eslint-disable-next-line no-console
      console.log('[orchestration] point countdown ignoré : ' + refus);
      return true;
    }
    this._lancerCountdown(profile, mark.targetMs, nowMs, directorMode, 'point de mix, ' + mark.bars + ' mesures');
    return true;
  }

  // Launch Countdown if a big drop is close enough - see COUNTDOWN_ID. Returns
  // true when a swap was armed.
  _tenterCountdown(profile, nowMs, trackDataInput, directorMode) {
    if (this._forcedId || this._countdownJoue || this._currentKey === COUNTDOWN_ID || !profile.analysisTimeline) return false;
    const cand = getCandidate(COUNTDOWN_ID);
    if (!cand || cand.enabled === false) return false;
    // Only towards the track's one target drop, still ahead.
    const cible = profile.analysisTimeline.countdownTarget;
    if (!cible || cible.atMs <= nowMs || this._countdownFor === cible.atMs) return false;
    // A target with its own mix point (a certain drop) is launched by it
    // alone: this window rule would otherwise start the count earlier.
    if ((profile.analysisTimeline.marks || []).some((m) => m.type === 'countdown' && m.targetMs === cible.atMs)) return false;
    const msUntil = cible.atMs - nowMs;
    const bpm = profile.trackFeatures && profile.trackFeatures.bpm;
    // Whole bars, the most that fit in COUNTDOWN_MAX_BEATS, as the mix point
    // does: the count is in beats with a bar indicator, so it starts on a
    // downbeat. No tempo, no count - the gate refuses it anyway.
    if (!bpm) return false;
    const barLen = 4 * 60000 / bpm;
    const windowMs = Math.floor(COUNTDOWN_MAX_BEATS / 4) * barLen;
    if (msUntil > windowMs) return false;
    // Not while the previous drop is still sounding: one bar after it at least.
    const barMs = bpm ? 4 * 60000 / bpm : 2000;
    for (const m of profile.analysisTimeline.marks || []) {
      if (m.type === 'drop' && m.atMs < cible.atMs && m.atMs <= nowMs && nowMs - m.atMs < barMs) return false;
    }
    // The gate says the rest: analysis, measured grid, 8 to 12 beats.
    const porte = Object.assign({}, trackDataInput, { dropTrigger: true, msUntilNextDrop: msUntil,
      beatsUntilNextDrop: beatsUntil(profile, msUntil) });
    const tier = this._currentQualityTier(profile);
    if (requirementFailure(cand, porte)) return false;
    if (!libraryForTier(tier).some((v) => v.id === COUNTDOWN_ID)) return false;
    // Only in the register it belongs to: it must be in this track's
    // danceability pool, counted with the gate opened.
    const pool = selectDanceabilityPool(libraryForTrack(porte, tier), danceIndex(profile), undefined, danceSeed(profile));
    if (!pool.some((v) => v.id === COUNTDOWN_ID)) return false;
    this._lancerCountdown(profile, cible.atMs, nowMs, directorMode, 'fenêtre du drop le plus intense');
    return true;
  }

  // The crossfade this swap should get, or null for the unchanged transition
  // types - see FADE_CALM_MAX.
  _fadePlan(profile, armed) {
    if (armed.keepCut || this._currentKey === null || this._mode === null) return null;
    const d = danceIndex(profile);
    if (d == null || d >= FADE_MID_MAX) return null;
    const bpm = profile.trackFeatures && profile.trackFeatures.bpm;
    const spb = bpm ? 60 / bpm : 0.5;
    const calm = d < FADE_CALM_MAX;
    const duration = calm
      ? Math.min(FADE_CALM_S[1], Math.max(FADE_CALM_S[0], FADE_CALM_BEATS * spb))
      : Math.min(FADE_MID_S[1], Math.max(FADE_MID_S[0], FADE_MID_BEATS * spb));
    return { duration: duration, dip: armed.type === 'BLACK' ? 1 : 0, introSeconds: FADE_INTRO_BEATS * spb };
  }

  _fireArmed(profile) {
    const armed = this._armed;
    this._armed = null;

    // Calm and middle tracks: capture THIS frame (the outgoing composition's
    // last, still on screen), swap on the next one and fade the capture out
    // over the new composition. _transition holds only that one frame; the
    // fade itself runs in _fade so marks keep being handled during it.
    const plan = this._fadePlan(profile, armed);
    if (plan) {
      this._transition = { type: 'FADE', targetKey: armed.targetKey, decision: armed.decision, plan: plan };
      if (profile.director) profile.director.fadeCapture = true;
      return;
    }

    if (armed.type === 'FLASH') {
      this._swapTo(armed.targetKey, profile, armed.decision);
      // One frame wide - consumed by scene-manager's own filmic pass
      // (uFlash) right after this update() call returns. See director.js.
      if (profile.director) profile.director.flash = 1;
      return;
    }
    if (armed.type === 'BLACK') {
      this._disposeActive();
      this._mode = null;
      this._transition = { type: 'BLACK', framesLeft: BLACK_HOLD_FRAMES, targetKey: armed.targetKey, decision: armed.decision };
      return;
    }
    if (armed.type === 'PUSH') {
      const bpm = profile.trackFeatures && profile.trackFeatures.bpm;
      const duration = bpm ? (60 / bpm) * PUSH_BEATS : PUSH_FALLBACK_DURATION_S;
      const dir = new THREE.Vector3();
      this._camera.getWorldDirection(dir); // camera's own local forward, in world space
      this._transition = {
        type: 'PUSH', elapsed: 0, duration: duration, dir: dir,
        startPos: this._camera.position.clone(),
        targetKey: armed.targetKey, decision: armed.decision
      };
      return;
    }
    // CUT - the default, and also what an out-of-range/no-bpm arm forces.
    this._swapTo(armed.targetKey, profile, armed.decision);
  }

  // Advances whichever transition is in flight (BLACK hold or PUSH camera
  // push), performing the real _swapTo once it completes. Frozen entirely
  // on pause, same as everything else driven by playbackState here - a
  // paused BLACK hold stays black, a paused PUSH stays wherever it had
  // gotten to, exactly where a musical transition should stop when the
  // music itself stops.
  _tickTransition(deltaTime, profile) {
    const t = this._transition;
    if (t.type === 'FADE') {
      this._transition = null;
      this._swapTo(t.targetKey, profile, t.decision);
      this._fade = { elapsed: 0, duration: t.plan.duration, dip: t.plan.dip };
      this._fadeIntro = { elapsed: 0, duration: t.plan.introSeconds };
      return;
    }
    if (t.type === 'BLACK') {
      t.framesLeft--;
      if (t.framesLeft <= 0) {
        this._transition = null;
        this._swapTo(t.targetKey, profile, t.decision);
      }
      return;
    }
    // PUSH
    t.elapsed += deltaTime;
    const progress = Math.min(1, t.elapsed / t.duration);
    this._camera.position.copy(t.startPos).addScaledVector(t.dir, PUSH_DISTANCE * progress);
    if (progress >= 1) {
      this._transition = null;
      this._swapTo(t.targetKey, profile, t.decision);
    }
  }

  // Phase 3 (radiopi mark taxonomy) - dispatches ONE mark to its
  // proportioned response, instead of the old "every mark means swap now"
  // behavior. mark: {atMs, type, score} from track-analysis.js's
  // selectMarks. Never arms on top of an already-armed/transitioning
  // state - update()'s own else-cascade only calls this when neither is
  // true.
  // APRÈS UN COUNTDOWN, LE PLUS HAUT (15/10/2026). Le drop que Countdown a
  // compté reçoit TOUJOURS le visuel le plus dansant que ce morceau peut jouer
  // (porte d'éligibilité et tier respectés) — pas seulement le plus haut du
  // vivier : depuis diversite.js le vivier est tiré au sort et ne contient
  // plus forcément le sommet du catalogue. La règle « jamais deux fois le même
  // dans un titre » cède ici : c'est LE moment du morceau. Appelé au mark du
  // drop et, s'il n'arrive pas, quand Countdown dépasse son temps.
  // Rend null si rien ne passe (le choix ordinaire prend alors le relais).
  _decisionApresCountdown(profile, trackDataInput, directorMode) {
    const lib = this._libEligible(profile).filter(function (v) { return v.id !== COUNTDOWN_ID && v.danceability != null; });
    if (!lib.length) return null;
    const haut = lib.reduce(function (m, v) { return Math.max(m, v.danceability); }, -Infinity);
    const sommet = lib.filter(function (v) { return v.danceability === haut; });
    const d = selectVisualizations(trackDataInput, profile.progress, sommet, {
      history: this._history, mode: directorMode, qualityTier: this._currentQualityTier(profile)
    });
    if (!d || d.mode !== 'orchestrated') return null;
    // eslint-disable-next-line no-console
    console.log('[orchestration] après le countdown : le plus haut, ' + d.primary + ' (' + haut + ')');
    return d;
  }

  _handleMark(mark, profile, directorMode, trackDataInput) {
    const bpm = profile.trackFeatures && profile.trackFeatures.bpm;
    if (mark.type === 'countdown') {
      const nowS = profile.estimatedPosition != null ? profile.estimatedPosition : profile.position;
      this._pointCountdown(mark, profile, (nowS || 0) * 1000, trackDataInput, directorMode);
      return;
    }

    // UN MARK, C'EST UN CHANGEMENT. Depuis le 25/09/2026, chaque mark retenu
    // par selectMarks change la composition : la sélection (percentile des
    // drops, seuils des montées et descentes, 8 s d'écart) a déjà fait le
    // tri, et la filtrer une seconde fois ici rendait l'écran illisible —
    // la ligne du panneau technique montrait des traits que l'image ne
    // suivait pas, et on ne pouvait plus juger les réglages de radiopi.
    // La composition à l'écran est donc EXCLUE du tirage pour tous les
    // types (le drop fort le faisait déjà) : l'hystérésis ne peut plus
    // retenir l'incumbent. Seule la NATURE de la transition varie par type.
    //
    // La montée faible (score < 0,6) garde en plus sa poussée d'intensité
    // sur 2 temps, qui accompagne désormais la coupe au lieu de la remplacer.
    if (mark.type === 'rise' && mark.score < MARK_MEDIUM_SCORE) {
      const duration = bpm ? (60 / bpm) * MARK_PUSH_BEATS : MARK_PUSH_FALLBACK_DURATION_S;
      this._pushIntensityUntil = this._time + duration;
      this._pushJustTriggered = true;
    }

    // L'énergie de la phrase qui commence remplace celle du segment courant
    // dans le score : au point, le segment RMS décrit encore la phrase qui
    // vient de finir.
    if (mark.energy != null) trackDataInput = Object.assign({}, trackDataInput, { energy: mark.energy });
    const opts = {
      history: this._history,
      mode: directorMode,
      hysteresisFactor: this._currentHysteresisFactor(),
      excludeId: this._history.length > 0 ? this._history[0].id : this._currentExcludeId(),
      excludeIds: Array.from(this._jouees),
      danceability: danceIndex(profile),
        danceabilitySeed: danceSeed(profile),
      qualityTier: this._currentQualityTier(profile),
    };
    Object.assign(opts, this._intensiteChoix(profile, mark.atMs));
    const armOptions = {};

    if (mark.type === 'drop' && mark.score >= MARK_DROP_STRONG_SCORE) {
      // DROP fort - a real, known drop must be seen: instant FLASH,
      // constrained to high-energy families so the cut doesn't land on
      // something already calm.
      opts.minEnergyLevel = MARK_STRONG_ENERGY_MIN;
      armOptions.forceType = 'FLASH';
      armOptions.forceImmediate = true;
    } else if (mark.type === 'fall') {
      // Descente/entrée en breakdown - a chute should read as a
      // withdrawal, not just another swap: BLACK hold, constrained to
      // calm families. Aligned to the nearest BEAT, same reasoning as
      // drop moyen below - a fall is also a precise, known instant, and
      // the normal phrase-lock wait (up to a full 16-beat phrase) was
      // landing the visible BLACK several seconds after the mark it was
      // supposed to line up with (diagnosed live: up to ~5s late against
      // the predicted mark list, on marks that don't get FLASH's
      // immediate/CUT's beat-aligned treatment).
      opts.maxEnergyLevel = MARK_CALM_ENERGY_MAX;
      armOptions.forceType = 'BLACK';
      armOptions.alignToBeat = true;
    } else if (mark.type === 'mix_in' || mark.type === 'mix_out') {
      // Same reasoning - the ARM itself aligns to the nearest beat rather
      // than waiting out a full phrase; PUSH's own 2-beat camera-push
      // animation after that is a deliberate, bounded transition length,
      // not an accidental wait.
      armOptions.forceType = 'PUSH';
      armOptions.alignToBeat = true;
    } else {
      // Drop moyen / montée (forte ou faible) - a precise, known instant,
      // but cutting between two beats still reads as sloppy: aligned to
      // the nearest BEAT, not the phrase.
      armOptions.forceType = 'CUT';
      armOptions.alignToBeat = true;
    }

    // LA BANDE DE LA PHRASE prime sur les bornes par type ci-dessus : le
    // niveau mesuré de la phrase dit mieux que le type du mark ce que
    // l'image doit être.
    const bande = mark.level && MARK_BANDS[mark.level];
    if (bande) {
      opts.minEnergyLevel = bande.min != null ? bande.min : undefined;
      opts.maxEnergyLevel = bande.max != null ? bande.max : undefined;
    }

    const apresCountdown = !this._forcedId && this._currentKey === COUNTDOWN_ID
      && this._countdownFor != null && Math.abs(mark.atMs - this._countdownFor) <= 1500;
    let markDecision = apresCountdown ? this._decisionApresCountdown(profile, trackDataInput, directorMode) : null;
    if (!markDecision) {
      markDecision = this._forcedId
        ? this._buildForcedDecision(directorMode, profile)
        : selectVisualizations(trackDataInput, profile.progress, null, opts);
    }
    const targetKey = this._decisionToKey(markDecision);
    if (targetKey !== this._currentKey) {
      this._armSwap(targetKey, markDecision, profile, armOptions);
    }
  }

  // CHANTIER 7 - a tier change (see scene-manager.js's own governor) is a
  // technical necessity, not a creative choice, so it bypasses armSwap/
  // the phrase-downbeat wait/all 4 transition types entirely: dispose and
  // rebuild the CURRENT composition, at the new tier, right now. Not
  // gated by pause (a paused screen the viewer is still looking at
  // deserves the perf fix too), but deferred while a BLACK/PUSH
  // transition is already in flight - interrupting one of those would be
  // its own visible glitch.
  _tickQualityTier(profile) {
    if (this._transition) return;
    if (!QUALITY_TIER_AWARE_MODES.has(this._mode)) return;
    const tier = this._currentQualityTier(profile);
    if (tier !== this._lastAppliedQualityTier) {
      this._swapTo(this._currentKey, profile, null);
    }
  }

  update(deltaTime, profile) {
    // For stepComposition(), which is driven by a key press rather than by
    // this loop and needs the profile the loop last saw.
    this._lastProfile = profile;
    // Un autre morceau : ce qui a été joué ne compte plus.
    const piste = profile ? danceSeed(profile) : null;
    if (piste !== this._jouees_piste) { this._jouees_piste = piste; this._jouees.clear(); }
    if (this._verrou && this._currentKey !== null) this._tenirVerrou();
    // LE FILET DES REFUS. L'orchestration ne les connaît pas — elle choisit
    // dans tout le vivier — donc on rattrape ici : si elle vient de poser une
    // composition refusée, on en prend une autre. Une fois par swap, pas à
    // chaque image : dès que _history a changé, le test ci-dessous est faux.
    this._rafraichirExclusions(profile);
    if (this._exclus.size > 0 && !this._transition) {
      const courant = this._history.length > 0 ? this._history[0].id : null;
      if (courant && this._exclus.has(courant)) {
        const reste = selectDanceabilityPool(this._libEligible(profile), danceIndex(profile), undefined, danceSeed(profile))
          .filter((v) => !this._exclus.has(v.id));
        if (reste.length > 0) {
          if (this._forcedId && !this._verrou && this._exclus.has(this._forcedId)) this._forcedId = null;
          this._appliquerChoix(reste[0], profile);
        }
      }
    }
    const paused = profile.playbackState !== 'PLAYING';
    if (!paused) this._time += deltaTime;
    this._tickQualityTier(profile);

    // Raise the recheck flag whenever the danceability IDENTIFICATION
    // changes - the llm estimate landing on a fresh track, or the signal
    // measurement replacing it a minute in. Consumed by the cascade below
    // (see the out-of-pool cut there); comparing a signature rather than the
    // resolved number means a re-poll that carries the same payload is free.
    const dPayload = profile.danceability;
    const dSig = dPayload
      ? String(dPayload.source) + '|' + String(dPayload.llmValue) + '|' + String(dPayload.value)
      : null;
    if (dSig !== this._lastDanceSig) {
      this._lastDanceSig = dSig;
      if (dSig) this._danceRecheckDue = true;
    }

    const durationForEnvelope = profile.duration > 0 ? profile.duration : null;
    // Sonos's own duration/elapsed time (already used for profile.progress
    // everywhere else) is used for the temporal envelope rather than
    // whatever duration Deezer's matched track reports - it's already
    // reliable and available for every playing track, whereas Deezer's
    // duration depends on having found a matching track at all, and can
    // belong to a slightly different edit/remaster with a different
    // runtime than what's actually playing.
    // radiopi /analyze's segment-level energy (see track-analysis.js),
    // when available, overrides trackFeatures.energy with a value that
    // actually tracks the CURRENT moment in the track rather than one
    // static number for the whole thing - "les visualisations doivent
    // être choisies en fonction de l'intensité sonore" against the
    // visualizer library's own already-defined energyLevel. null (no
    // analysis, or position outside any segment) leaves trackFeatures.
    // energy exactly as before.
    // profile.position is the RAW Sonos value, frozen between its own
    // ~3s polls - profile.estimatedPosition (scene-manager.js's
    // PositionSmoother, written every frame) is what anything reacting to
    // the CURRENT instant should read instead; using the raw one here
    // made both this lookup and the forced-swap detection below only
    // actually notice a change once every 3s, a real desync source.
    const nowSeconds = profile.estimatedPosition != null ? profile.estimatedPosition : profile.position;
    // L'énergie continue du segment en cours (avg_db du morceau), quand la
    // timeline existe ; sinon celle des catalogues, dans trackFeatures.
    const analysisEnergy = profile.analysisTimeline ? profile.analysisTimeline.lookupEnergy(nowSeconds * 1000) : null;
    const dropInfo = dropsAhead(profile.analysisTimeline, nowSeconds * 1000);
    // character.dynamics/percussiveness (see track-analysis.js's
    // computeCharacter/director.js) - static per track, feeds
    // orchestrator.js's own "prefers" scoring axis (resonance.js is the
    // first visualizer to declare one). null fields are simply omitted
    // rather than merged in as null, so they read as "absent" to
    // scoreVisualization exactly like a missing trackFeatures field would.
    const character = profile.director ? profile.director.character : null;
    // Assembled from EVERYTHING that is known, with trackFeatures as one
    // optional contributor rather than the gate. It used to read
    // `profile.trackFeatures ? Object.assign(...) : null`, and that single
    // ternary is why NeonPulse shows up on classical music.
    //
    // trackFeatures is the Deezer/TheAudioDB match, and those two miss
    // constantly on classical - the titles are long, the composer and the
    // performer are not the same person, and the edit rarely matches. When
    // they miss, the field stays null for the whole track and EVERY other
    // signal was thrown away with it: radiopi's dynamics, percussiveness and
    // syncopation, whether an analysis exists at all, the cover's brightness,
    // the duration. All of it computed just above, all of it discarded.
    //
    // selectVisualizations then received null, returned { mode: 'fallback' },
    // and NeonPulse - which has no PROFILE and is excluded from the registry
    // precisely because it is not a rotation candidate - took the frame.
    // _decisionToKey holds the incumbent when that happens, but it cannot
    // hold anything once the current key IS 'fallback': from there every
    // recheck returns 'fallback' again and it stays for the rest of the track.
    //
    // The orchestrator never needed the gate. hasSufficientData is literally
    // `!!trackData`, and scoreVisualization already omits any axis whose value
    // is missing rather than inventing a neutral for it - its own comment
    // spells out that a trackData with no real fields at all should still
    // produce a valid decision. Object.assign ignores a null source, so
    // passing an object with a null bpm in it costs nothing and lets the
    // prefers axes - which is where dynamics and percussiveness live, the two
    // that actually separate a nocturne from a club - do the work.
    const trackDataInput = (profile.title || profile.artist || profile.album)
      ? Object.assign({}, profile.trackFeatures, { duration: durationForEnvelope },
        analysisEnergy != null ? { energy: analysisEnergy } : null,
        // UNE SEULE DANSABILITÉ : l'indice du service (le modèle d'abord),
        // sur l'échelle 0-100 que la durée des compositions attend. Celle de
        // TheAudioDB reste dans trackFeatures pour l'affichage, rien d'autre.
        { danceability: danceIndex(profile) * 100 },
        // Whether the precomputed timeline exists at all. orchestrator.js
        // excludes any PROFILE with requiresAnalysis outright when this is
        // false - see its analysisAvailable().
        { hasAnalysis: !!profile.analysisTimeline },
        character && character.dynamics != null ? { dynamics: character.dynamics } : null,
        character && character.percussiveness != null ? { percussiveness: character.percussiveness } : null,
        // sumi.js's own "density" prefers axis - see
        // orchestrator.js's own comment on why this is
        // character.percussiveness again rather than a second computation.
        character && character.percussiveness != null ? { density: character.percussiveness } : null,
        character && character.syncopation != null ? { syncopation: character.syncopation } : null,
        // clave.js's own "gridStrength" prefers axis - no continuous signal
        // exists for this either (see orchestrator.js's own comment), so it
        // rides the SAME boolean as hasAnalysis above, just as 1/0 instead
        // of true/false so rangeScore (built for a numeric range) can use
        // it the same way as every other prefers axis.
        { gridStrength: profile.analysisTimeline ? 1 : 0 },
        // LA PORTE D'ÉLIGIBILITÉ (orchestrator.js, requirementFailure) lit ces
        // deux-là. Ils sont recalculés À CHAQUE APPEL, sur la position
        // courante : c'est ce qui fait qu'un visualiseur qui exige un drop
        // devant lui cesse d'être éligible dès que le dernier est passé, sans
        // rien de plus à câbler.
        { dropsRemaining: dropInfo.count },
        dropInfo.nextMsUntil != null ? { msUntilNextDrop: dropInfo.nextMsUntil } : null,
        // caustics.js's own "brightness" prefers axis. There is no audio
        // brightness in this payload; artworkPalette.brightness is a real
        // measurement (mean luma of the cover, see artwork-palette.js) and
        // it is the one that matters for a luminous visualizer. Omitted
        // rather than defaulted when no cover has been analysed yet, same
        // "absent means absent" rule as every field above.
        profile.artworkPalette && profile.artworkPalette.brightness != null
          ? { brightness: profile.artworkPalette.brightness } : null)
      // Nothing playing at all - no title, no artist, no album. This is the
      // one case NeonPulse was written for and the only one it still serves:
      // the cold-start picture, when there is genuinely nothing to orchestrate
      // on rather than merely nothing Deezer recognised.
      : null;
    const directorMode = profile.director ? profile.director.mode : null;
    const decision = this._forcedId
      ? this._buildForcedDecision(directorMode, profile)
      : selectVisualizations(trackDataInput, profile.progress, null, {
        history: this._history,
        mode: directorMode,
        hysteresisFactor: this._currentHysteresisFactor(),
        excludeId: this._currentExcludeId(),
        excludeIds: Array.from(this._jouees),
        danceability: danceIndex(profile),
        danceabilitySeed: danceSeed(profile),
      qualityTier: this._currentQualityTier(profile),
        // L'intensité de la phase EN COURS : le premier visuel d'un titre, et
        // toute décision hors point de mix, suivent eux aussi l'énergie.
        intensity: this._intensiteChoix(profile, ((profile.estimatedPosition != null ? profile.estimatedPosition : profile.position) || 0) * 1000).intensity
      });
    this._lastDecision = decision;
    // Mémorisé pour _libEligible : les méthodes appelées de l'extérieur (la
    // console VDJ, les flèches de /radio) n'ont pas ce calcul sous la main.
    this._lastTrackData = trackDataInput;

    // --- LA PORTE D'ÉLIGIBILITÉ, CÔTÉ ROTATION ------------------------------
    // La vérifier à la sélection ne suffit pas : une composition déjà à
    // l'écran quand le morceau change se retrouverait à tourner sur un titre
    // qui ne remplit plus ses conditions - un compte à rebours vers un drop
    // devenu inconnu. On la revérifie donc CHAQUE IMAGE contre le titulaire,
    // et on l'évince sans attendre la fin de sa rotation.
    const evictionRaison = this._verifierEligibilite(trackDataInput);

    // Les refus, journalisés UNE FOIS par jeu de raisons. Par image, ce serait
    // soixante lignes par seconde ; jamais, et un visualiseur qui n'apparaît
    // pas est indiscernable d'un visualiseur cassé.
    if (decision.refusals && decision.refusals.length) {
      const sig = decision.refusals.map(function (r) { return r.id + '=' + r.raison; }).join('|');
      if (sig !== this._dernierRefus) {
        this._dernierRefus = sig;
        for (const r of decision.refusals) {
          // eslint-disable-next-line no-console
          console.log('[orchestration] ' + r.id + ' non proposé — ' + r.raison);
        }
      }
    } else if (this._dernierRefus) {
      this._dernierRefus = null;
    }

    // CHANTIER 6 (revision) - interruptions, checked every frame
    // regardless of the normal duration-based recheck timer.
    const enteredDrop = directorMode === 'drop' && this._lastSeenDirectorMode !== 'drop';
    this._lastSeenDirectorMode = directorMode;
    const bpmNow = profile.trackFeatures && profile.trackFeatures.bpm;
    const compositionBeatsElapsed = (bpmNow && this._activeCompositionStartedAt != null)
      ? (this._time - this._activeCompositionStartedAt) / (60 / bpmNow)
      : 0;
    // "Une composition tourne depuis plus d'une phrase" - needs a real bpm
    // to measure beats against; without one the phrase-lock concept
    // doesn't apply at all (armSwap's own no-bpm rule already applies
    // immediately in that case).
    const dropInterrupt = !paused && enteredDrop && !!bpmNow && compositionBeatsElapsed > DROP_INTERRUPT_MIN_BEATS;
    const trackChangeInterrupt = !paused && this._forceRecheck;
    this._forceRecheck = false;

    // radiopi /analyze marks (see track-analysis.js's selectMarks and
    // profile.analysisTimeline, built once in sonos-visual-profile.js).
    // Unlike dropInterrupt above (gated on >1 phrase elapsed, since it's
    // reacting to the SYNTHETIC progress-based envelope), these marks are
    // sparse, real, deliberate moments in the actual track, so nothing
    // here gates on minimum elapsed time - every one of them is worth
    // reacting to on its own, via _handleMark's own typed dispatch
    // (Phase 3 - a mark no longer always means "swap now").
    const analysisTimelineJustArrived = profile.analysisTimeline !== this._lastSeenTrackAnalysis;
    this._lastSeenTrackAnalysis = profile.analysisTimeline;
    if (analysisTimelineJustArrived) {
      this._marks = profile.analysisTimeline ? profile.analysisTimeline.marks : [];
      // Analysis can resolve mid-track (it's fetched asynchronously,
      // sometimes taking up to ~100s) - seed the pointer past whatever
      // marks playback has already gone by, so a mark from the first
      // minute doesn't fire a response the instant the analysis lands
      // three minutes in.
      const alreadyAtMs = nowSeconds * 1000;
      let seedIndex = 0;
      while (seedIndex < this._marks.length && this._marks[seedIndex].atMs <= alreadyAtMs) seedIndex++;
      this._nextMarkIndex = seedIndex;
    }
    // UN MARK N'EST CONSOMMÉ QUE S'IL VA ÊTRE TRAITÉ.
    //
    // La version précédente avançait le pointeur ici, puis ne traitait le
    // mark que dans la dernière branche du `if` ci-dessous — celle qui
    // suppose qu'aucun échange n'est armé ni en cours. Un drop tombant
    // pendant une transition, ou pendant qu'un échange attendait son temps
    // fort, était donc AVALÉ : pointeur avancé, aucune réaction. D'où un
    // point de mixage sur deux qui passait sans rien changer.
    //
    // Une transition est un changement d'image déjà en route : on n'en
    // déclenche pas un autre par-dessus, on garde le mark pour l'instant où
    // elle se termine. Un échange seulement ARMÉ, lui, n'a encore rien fait :
    // le drop le remplace, c'est exactement ce qu'on attend de lui.
    let markToHandle = null;
    if (!paused && !this._transition && this._currentKey !== null
        && this._nextMarkIndex < this._marks.length) {
      const nowMs = nowSeconds * 1000;
      if (nowMs >= this._marks[this._nextMarkIndex].atMs) {
        // Consume every mark already passed, not just the one that
        // triggered this - a paused/backgrounded tab or a seek can jump
        // past several at once, and only the most recent one gets a
        // response (matching the pre-existing single-swap-per-frame
        // behavior this replaces).
        while (this._nextMarkIndex < this._marks.length && this._marks[this._nextMarkIndex].atMs <= nowMs) {
          markToHandle = this._marks[this._nextMarkIndex];
          this._nextMarkIndex++;
        }
      }
      // Countdown holds until its drop: any earlier mark is let pass.
      if (markToHandle && this._countdownHolds(nowMs) && markToHandle.atMs < this._countdownHoldUntilMs - 300) markToHandle = null;
      // A drop on a visual whose gesture it is: the visual plays it, and holds.
      // Countdown's own point still cuts - it was launched for that drop.
      if (markToHandle && markToHandle.type === 'drop' && DROP_GESTURE_IDS.has(this._currentKey)) {
        // eslint-disable-next-line no-console
        console.log('[orchestration] drop laissé à ' + this._currentKey + ' (son geste), tenu ' + DROP_GESTURE_HOLD_S + ' s');
        this._dropGestureHoldUntil = this._time + DROP_GESTURE_HOLD_S;
        this._nextFillerCheckAt = Math.max(this._nextFillerCheckAt || 0, this._dropGestureHoldUntil);
        markToHandle = null;
      }
      // ...and while it plays, ordinary marks wait (a countdown point does not).
      if (markToHandle && markToHandle.type !== 'countdown' && this._time < (this._dropGestureHoldUntil || -1)
          && DROP_GESTURE_IDS.has(this._currentKey)) markToHandle = null;
      // AU MOINS 10 S À L'ÉCRAN. La liste des marks est déjà espacée
      // (track-analysis.js, espacerMarks), mais le visuel en place a pu
      // arriver autrement - un filler, un changement de vivier, un choix à
      // la main. Un point ordinaire qui tomberait avant ses 10 s passe sans
      // rien changer ; seuls Countdown et les drops forts, prioritaires,
      // coupent quand même.
      if (markToHandle && markToHandle.type !== 'countdown'
          && !(markToHandle.type === 'drop' && markToHandle.score >= MARK_DROP_STRONG_SCORE)
          && this._activeCompositionStartedAt != null
          && this._time - this._activeCompositionStartedAt < MIN_VISUEL_MS / 1000) markToHandle = null;
    }

    // trackFeatures resolves asynchronously, typically a second or two
    // after a track starts (see main.js's fetchTrackFeatures call) - well
    // after this visualizer's very first update() already had to commit
    // to a decision (almost always 'fallback', since the data isn't back
    // yet). Reacting the instant it arrives (rather than waiting for the
    // next periodically-scheduled check, up to FALLBACK_RECHECK_S away)
    // is what makes the real orchestrated pick actually kick in promptly
    // instead of sitting in fallback for up to 12s after every track
    // change.
    const featuresJustArrived = profile.trackFeatures !== this._lastSeenTrackFeatures;
    this._lastSeenTrackFeatures = profile.trackFeatures;

    if (this._currentKey === null) {
      // The very first composition of the session - nothing to transition
      // FROM, so it just appears. No transition dressing makes sense here.
      const key = this._decisionToKey(decision);
      this._swapTo(key, profile, decision);
      this._scheduleNext(decision);
    } else if (paused) {
      // Everything freezes on pause - the countdown to the next re-check,
      // any armed-but-not-fired swap, and any in-flight BLACK/PUSH
      // transition all simply stop advancing.
    } else if (this._transition) {
      this._tickTransition(deltaTime, profile);
    } else if (evictionRaison) {
      // ÉVICTION. Immédiate, sans transition : ce qui est à l'écran n'a plus le
      // droit d'y être. `decision` a déjà écarté le titulaire, sauf dans un cas
      // - un repli (trackFeatures pas encore résolu) rend la clé COURANTE pour
      // garder le titulaire en place, ce qui ici reviendrait à ne rien faire.
      // Dans ce cas on va franchement au repli.
      const cible = this._decisionToKey(decision);
      const vers = cible === this._currentKey ? 'fallback' : cible;
      // eslint-disable-next-line no-console
      console.log('[orchestration] éviction immédiate de ' + evictionRaison + ' → ' + vers);
      this._armed = null;
      this._swapTo(vers, profile, vers === 'fallback' ? { mode: 'fallback' } : decision);
      this._scheduleNext(decision);
    } else if (markToHandle) {
      // LE MARK PASSE AVANT L'ÉCHANGE ARMÉ. Un point de mixage est un instant
      // connu et précis ; un échange armé n'est qu'une intention qui attend
      // son temps fort. _handleMark réarme par-dessus, et le drop fort arme
      // en immédiat — la coupe tombe donc bien sur le point.
      this._handleMark(markToHandle, profile, directorMode, trackDataInput);
      if (this._armed && this._armed.immediate) this._fireArmed(profile);
    } else if (this._armed) {
      // Pre-roll: the last PREROLL_BEATS before the downbeat this swap is
      // waiting for - director.intensity gets a boost so the OUTGOING
      // composition visibly winds up into the cut. Only meaningful for a
      // non-immediate, PHRASE-aligned arm; an immediate one fires on the
      // very next tick below anyway, and a beat-aligned arm (radiopi's
      // "drop moyen/montée forte" response) is already at most 1 beat
      // away by construction - a phrase-scale pre-roll window doesn't fit.
      if (!this._armed.immediate && !this._armed.alignToBeat && profile.phrasePhase != null && profile.director) {
        const beatsUntilDownbeat = (1 - profile.phrasePhase) * BEATS_PER_PHRASE;
        if (beatsUntilDownbeat <= PREROLL_BEATS) {
          profile.director.intensity = Math.min(1, profile.director.intensity + PREROLL_INTENSITY_BOOST);
        }
      }
      const ready = this._armed.immediate
        || (this._armed.alignToBeat
          ? (profile.beatPhase == null || (this._lastBeatPhase != null && profile.beatPhase < this._lastBeatPhase))
          : (profile.phrasePhase == null || (this._lastPhrasePhase != null && profile.phrasePhase < this._lastPhrasePhase)));
      this._lastPhrasePhase = profile.phrasePhase;
      this._lastBeatPhase = profile.beatPhase;
      if (ready) this._fireArmed(profile);
    } else {
      // When the track is known by radiopi /analyze, swaps happen ONLY in
      // response to its own marks (via _handleMark below) or on a genuine
      // track change - never on the normal duration-based timer, the
      // synthetic-envelope dropInterrupt, or an overrun recheck. All three
      // of those fire on their own independent, effectively random
      // cadence, and were drowning the analysis-driven marks out entirely
      // (diagnosed live: 22 swaps over a 353s track, none within even a
      // few seconds of any of the 10 predicted marks) - not a subtle
      // desync, the two mechanisms were just fighting for the same
      // composition with the periodic one winning every time. Restricting
      // to analysis marks only, when they exist, also makes testing this
      // deterministic - "ça permettra de tester plus simplement".
      // "Des que la danceabilite est identifiee, si la visualisation en cours
      // est hors perimetre, elle doit changer." Runs BEFORE the mark/filler
      // logic: an identification (the llm estimate landing, or the
      // measurement replacing it) that moves the index re-derives the pool,
      // and an incumbent no longer in it is cut out on the next beat rather
      // than living out its scheduled duration in the wrong register.
      if (this._tenterCountdown(profile, nowSeconds * 1000, trackDataInput, directorMode)) {
        this._updateActive(deltaTime, profile);
        return;
      }
      if (this._danceRecheckDue) {
        this._danceRecheckDue = false;
        if (!this._forcedId && this._currentKey && this._currentKey !== 'fallback') {
          const pool = selectDanceabilityPool(this._libEligible(profile), danceIndex(profile), undefined, danceSeed(profile));
          const currentKey = this._currentKey;
          const inPool = pool.some(function (v) { return v.id === currentKey; });
          if (!inPool) {
            const decision = selectVisualizations(trackDataInput, profile.progress, null, {
              history: this._history,
              mode: directorMode,
              hysteresisFactor: this._currentHysteresisFactor(),
              excludeId: this._currentExcludeId(),
              excludeIds: Array.from(this._jouees),
              danceability: danceIndex(profile),
              danceabilitySeed: danceSeed(profile),
      qualityTier: this._currentQualityTier(profile),
              intensity: this._intensiteChoix(profile, ((profile.estimatedPosition != null ? profile.estimatedPosition : profile.position) || 0) * 1000).intensity
            });
            const targetKey = this._decisionToKey(decision);
            if (decision.mode !== 'fallback' && targetKey !== this._currentKey) {
              this._armSwap(targetKey, decision, profile, { forceType: 'CUT', alignToBeat: true });
              // Leave through the same door as the bottom of update(): the
              // incumbent still animates this frame, and returning here keeps
              // the mark/filler logic below from arming on top of the swap
              // this frame just armed.
              this._updateActive(deltaTime, profile);
              return;
            }
          }
        }
      }

      const analysisOnlyMode = !!profile.analysisTimeline;
      // Filler transition - real marks can be sparse (gaps of 30-45s were
      // common on a real track), and analysisOnlyMode otherwise swaps
      // ONLY at marks, leaving those gaps visually static. When the next
      // KNOWN mark (director.nextEvent - a pure lookup into the same
      // timeline, see director.js) is further out than FILLER_MIN_S, or
      // there isn't one left, a plain transition fills the gap instead, on
      // a danceability-driven cadence (see DANCEABILITY_DWELL_MAX_S) -
      // hysteresis/family fully relaxed (same excludeId mechanism
      // chantier 6's own overrun handling already uses) so it's
      // guaranteed to actually produce a different visual, not just
      // attempt to. Never fires if a real mark would land in that same
      // near-term window - that mark's own response already covers it.
      // Hard ceiling underneath the soft (danceability-driven, mark-
      // avoiding) check above: the soft check's own jitter could still, in
      // principle, land right when a mark happens to look imminent and
      // never retry (msUntil only keeps shrinking as the mark approaches) -
      // measured live before this used a flat window, this let a couple of
      // real gaps run to 43-44s instead of the intended ~30s ceiling. Once
      // elapsed time since the last swap actually reaches
      // DANCEABILITY_DWELL_MAX_S, fire regardless, unless the next mark is
      // close enough (a couple seconds) that it will cover the moment
      // itself.
      const nextEvent = profile.director ? profile.director.nextEvent : null;
      const elapsedSinceLastSwap = this._activeCompositionStartedAt != null ? this._time - this._activeCompositionStartedAt : 0;
      const softCheckDue = this._time >= this._nextFillerCheckAt
        && (!nextEvent || nextEvent.msUntil > FILLER_MIN_S * 1000);
      const hardCeilingDue = elapsedSinceLastSwap >= DANCEABILITY_DWELL_MAX_S
        && (!nextEvent || nextEvent.msUntil > FILLER_MARK_IMMINENT_MS);
      // Countdown never plays past its drop: half a second after it (the drop
      // missed or moved), a filler takes over at once.
      const countdownOverrun = this._currentKey === COUNTDOWN_ID && this._time - this._countdownLaunchedAt > (this._countdownPlayS || 0) + 0.5;
      const gestureHolds = DROP_GESTURE_IDS.has(this._currentKey) && this._time < (this._dropGestureHoldUntil || -1);
      const fillerDue = analysisOnlyMode && !markToHandle && (countdownOverrun || ((softCheckDue || hardCeilingDue) && !this._countdownHolds(nowSeconds * 1000) && !gestureHolds));
      if (markToHandle) {
        this._handleMark(markToHandle, profile, directorMode, trackDataInput);
      } else if (fillerDue) {
        this._nextFillerCheckAt = this._time + computeDanceabilityDwellSeconds(
          bpmNow, danceIndex(profile), FILLER_MIN_S, DANCEABILITY_DWELL_MAX_S
        ).scheduledSeconds;
        const choixFiller = this._intensiteChoix(profile, nowSeconds * 1000);
        const apresCountdown = countdownOverrun && !this._forcedId
          ? this._decisionApresCountdown(profile, trackDataInput, directorMode) : null;
        const fillerDecision = apresCountdown || (this._forcedId
          ? this._buildForcedDecision(directorMode, profile)
          : selectVisualizations(trackDataInput, profile.progress, null, {
            history: this._history,
            mode: directorMode,
            hysteresisFactor: 1.0,
            excludeId: this._history.length > 0 ? this._history[0].id : undefined,
            excludeIds: Array.from(this._jouees),
            // Same pool as every other decision: a filler swap is still this
            // track's swap, and it must not reach outside what danceability
            // allowed in.
            danceability: danceIndex(profile),
            intensity: choixFiller.intensity,
            plancherDansabilite: choixFiller.plancherDansabilite,
        danceabilitySeed: danceSeed(profile),
      qualityTier: this._currentQualityTier(profile)
          }));
        const targetKey = this._decisionToKey(fillerDecision);
        if (targetKey !== this._currentKey) {
          // alignToBeat, not the normal phrase-lock wait: a full-phrase
          // wait (up to MAX_WAIT_FOR_DOWNBEAT_S=6s beyond this point) was
          // pushing the actual observed cadence past the requested 20-30s
          // window - measured live, one gap landed at 35.7s despite firing
          // the arm at the 30s mark. "toutes les 20 à 30 secondes" is
          // about what's actually SEEN, not just when the decision was
          // made.
          this._armSwap(targetKey, fillerDecision, profile, { alignToBeat: true });
        }
      } else {
        const dataJustArrivedInFallback = featuresJustArrived && this._mode === 'fallback';
        // Once the active composition has reached its OWN desired
        // duration (chantier 6, revision), re-check every single frame
        // instead of waiting for _nextCheckAt - AC1's own tolerance (<2
        // beats average deviation) leaves no room for a multi-second
        // polling gap once a composition is already overdue. Skipped
        // entirely in analysisOnlyMode - there is no "own desired
        // duration" driving anything there.
        const dueForCheck = trackChangeInterrupt || dataJustArrivedInFallback
          || (!analysisOnlyMode && (this._time >= this._nextCheckAt || dropInterrupt || this._overrunSeconds() != null));
        if (dueForCheck) {
          // No radiopi sequencing at all for this track (analysisOnlyMode
          // false is exactly that case here) - orchestration priority
          // rule, see DANCEABILITY_DWELL_MAX_S's own comment: dwell time
          // is driven by danceability instead of computeCompositionDuration's
          // mode/bpm pacing, with much more headroom (up to 60s) for a
          // calm, non-danceable track. Overwriting decision's own duration
          // fields (rather than computing a parallel value) keeps every
          // downstream consumer - _armSwap/_swapTo's _activeCompositionDesiredSeconds,
          // _overrunSeconds, the composition log - reading the same number.
          if (decision.mode === 'orchestrated') {
            const dwell = computeDanceabilityDwellSeconds(
              bpmNow, danceIndex(profile), NO_ANALYSIS_DWELL_MIN_S, DANCEABILITY_DWELL_MAX_S
            );
            decision.desiredDurationSeconds = dwell.desiredSeconds;
            decision.scheduledDurationSeconds = dwell.scheduledSeconds;
          }
          const targetKey = this._decisionToKey(decision);
          if (targetKey !== this._currentKey) {
            this._armSwap(targetKey, decision, profile, {});
          }
          this._scheduleNext(decision);
        }
      }
    }

    // Phase 3 - "montée faible" push, applied here (after _handleMark may
    // have set it, before _updateActive runs) so the active visualizer
    // sees this frame's boosted director state - same ordering the
    // pre-roll intensity boost above already relies on.
    if (profile.director) {
      if (this._time < this._pushIntensityUntil) {
        profile.director.intensity = Math.min(1, profile.director.intensity + MARK_PUSH_INTENSITY_BOOST);
        profile.director.pushIntensity = MARK_PUSH_INTENSITY_BOOST;
        profile.director.accentPhrase = 1;
      }
      profile.director.internalCue = this._pushJustTriggered;
      this._pushJustTriggered = false;

      // Phase 4 - anticipation ahead of a KNOWN strong drop/fall, from
      // director.nextEvent (a pure lookup into the same marks timeline -
      // see director.js). Distinct from PREROLL_INTENSITY_BOOST above,
      // which only ever covers the last couple beats before ANY armed
      // swap - this is a longer, deliberate windup toward a drop the
      // timeline already knows is coming, or an early wind-down toward a
      // fall.
      const nextEvent = profile.director.nextEvent;
      if (nextEvent && bpmNow) {
        const beatsUntil = (nextEvent.msUntil / 1000) / (60 / bpmNow);
        if (nextEvent.type === 'drop' && nextEvent.score >= MARK_DROP_STRONG_SCORE && beatsUntil <= MARK_DROP_PREROLL_BEATS) {
          const t = clamp01(1 - beatsUntil / MARK_DROP_PREROLL_BEATS);
          profile.director.preRollIntensity = 1 + (MARK_DROP_PREROLL_PEAK - 1) * t;
        } else if (nextEvent.type === 'fall' && beatsUntil <= MARK_FALL_PREROLL_BEATS) {
          const t = clamp01(1 - beatsUntil / MARK_FALL_PREROLL_BEATS);
          profile.director.preRollIntensity = 1 - (1 - MARK_FALL_PREROLL_TROUGH) * t;
        }
      }
    }

    // The crossfade in flight (see _fadePlan): the captured frame's weight,
    // eased out, and the incoming composition's intensity rising from half.
    // Frozen on pause, like every other transition.
    if (profile.director && (this._fade || this._fadeIntro)) {
      const running = profile.playbackState === 'PLAYING';
      if (this._fade) {
        if (running) this._fade.elapsed += deltaTime;
        const u = clamp01(this._fade.elapsed / this._fade.duration);
        profile.director.fadeMix = 1 - u * u * (3 - 2 * u);
        profile.director.fadeDip = this._fade.dip;
        if (u >= 1) { this._fade = null; profile.director.fadeMix = 0; }
      }
      if (this._fadeIntro) {
        if (running) this._fadeIntro.elapsed += deltaTime;
        const u = clamp01(this._fadeIntro.elapsed / Math.max(0.1, this._fadeIntro.duration));
        profile.director.intensity *= FADE_INTRO_FROM + (1 - FADE_INTRO_FROM) * u;
        if (u >= 1) this._fadeIntro = null;
      }
    }

    // A BLACK hold or the setup frame of a fresh _armed both leave _mode
    // null for an instant - _updateActive already no-ops when there is
    // nothing active (see its own dispatch, which matches _mode against
    // named cases only).
    this._updateActive(deltaTime, profile);
  }

  // A manual step through the orchestrator's OWN pool - the /radio page's
  // Left/Right (see main-radio.js). direction: +1/-1. The candidates are
  // exactly selectDanceabilityPool's seven for the current track, in its
  // order, so the arrows never reach a visual the orchestrator would not have
  // picked itself; the step lands on the neighbour of the composition on
  // screen and is applied as an immediate CUT. The pick is then treated as a
  // real decision: it enters _history and gets a full duration of its own, so
  // orchestration resumes from it rather than immediately overriding it.
  // Returns the id chosen, or null when nothing could be stepped (no profile
  // yet, ?force= in effect, a transition already in flight, empty pool).
  stepComposition(direction) {
    const profile = this._lastProfile;
    if (!profile || this._forcedId || this._transition) return null;
    const pool = selectDanceabilityPool(this._libEligible(profile), danceIndex(profile), undefined, danceSeed(profile));
    if (pool.length === 0) return null;
    // The composition on screen, straight from _history (its head is what
    // _swapTo recorded) - NOT _currentExcludeId(), which only names the
    // incumbent once it has overrun its duration and is otherwise undefined.
    const currentId = this._history.length > 0 ? this._history[0].id : null;
    const at = pool.findIndex(function (v) { return v.id === currentId; });
    const n = pool.length;
    const next = at === -1 ? (direction > 0 ? 0 : n - 1) : (((at + direction) % n) + n) % n;
    return this._appliquerChoix(pool[next], profile);
  }

  // LE VIVIER, pour qui veut l'afficher : la console VDJ montre une vignette
  // par composition que l'orchestrateur s'autorise pour ce morceau, et entoure
  // celle qui joue. Exactement selectDanceabilityPool, dans son ordre.
  // Le réglage vient de changer : le vivier n'est plus le même. Si ce qui joue
  // n'en fait plus partie, on passe à une composition qui en fait partie —
  // sinon « Calme » laisserait tourner un visuel de party jusqu'à la fin de
  // son cycle, et le réglage paraîtrait sans effet.
  reconsidererVivier() {
    const profile = this._lastProfile;
    if (!profile || this._transition || this._verrou) return false;
    this._rafraichirExclusions(profile);
    const pool = selectDanceabilityPool(this._libEligible(profile), danceIndex(profile), undefined, danceSeed(profile))
      .filter((v) => !this._exclus.has(v.id));
    if (pool.length === 0) return false;
    const courant = this._history.length > 0 ? this._history[0].id : null;
    if (courant && pool.some((v) => v.id === courant)) return false;
    // Un épinglage hors du nouveau vivier saute : le réglage prime.
    if (this._forcedId && !pool.some((v) => v.id === this._forcedId)) this._forcedId = null;
    this._appliquerChoix(pool[0], profile);
    return true;
  }

  // Exclure une composition du vivier pour le morceau en cours. Le refus est
  // ignoré s'il ne resterait plus rien : un vivier vide n'aurait plus rien à
  // proposer, et la console afficherait une grille sans cases.
  exclurePourTitre(id) {
    const profile = this._lastProfile;
    if (!profile || this._verrou) return false;
    this._rafraichirExclusions(profile);
    const pool = selectDanceabilityPool(this._libEligible(profile), danceIndex(profile), undefined, danceSeed(profile));
    const restant = pool.filter((v) => v.id !== id && !this._exclus.has(v.id));
    if (restant.length === 0) return false;
    this._exclus.add(id);
    // Si c'est celle qui joue, on ne l'attend pas : on passe tout de suite à
    // une autre, sinon le refus n'aurait d'effet qu'à la fin de son cycle.
    const courant = this._history.length > 0 ? this._history[0].id : null;
    if (courant === id && !this._transition) {
      if (this._forcedId === id) this._forcedId = null;
      this._appliquerChoix(restant[0], profile);
    }
    return true;
  }

  // Les refus ne valent que pour le titre en cours : au suivant, tout le
  // catalogue revient. C'est ce qui rend le geste sans conséquence.
  _rafraichirExclusions(profile) {
    const id = profile ? profile.trackId : null;
    if (this._exclusPour !== id) { this._exclus.clear(); this._exclusPour = id; }
  }

  poolIds() {
    const profile = this._lastProfile;
    if (!profile) return { ids: [], actif: null };
    this._rafraichirExclusions(profile);
    const pool = selectDanceabilityPool(this._libEligible(profile), danceIndex(profile), undefined, danceSeed(profile))
      .filter((v) => !this._exclus.has(v.id));
    return {
      ids: pool.map(function (v) { return v.id; }),
      actif: this._history.length > 0 ? this._history[0].id : null,
      epingle: this._forcedId || null,
      verrou: this._verrou || null
    };
  }

  // FORCER, par-dessus tout. Réservé à l'administrateur (la console tient
  // la porte) pour juger un visuel — y compris un visuel désactivé ou hors
  // vivier — sur de vrais morceaux. Tant que le verrou tient : les marks,
  // les remplissages, le changement de titre, le réglage du vivier et les
  // clics de la grille VDJ ne changent rien à l'image. `null` rend la main.
  forcerComposition(id) {
    if (id == null) {
      const avait = this._verrou;
      this._verrou = null;
      if (avait) this._forcedId = null;
      return null;
    }
    const viz = getCandidate(id);
    // never silently (R23): a force the registry cannot honour is said with the reason
    if (!viz) { console.warn('[adaptive-party] forcer "' + id + '" refusé : identifiant absent du registre (visualizer-registry.js)'); return null; }
    this._verrou = id;
    this._forcedId = id;
    this._tenirVerrou();
    return id;
  }

  // Poser (ou reposer) la composition verrouillée dès que l'image est
  // libre : à l'appel, puis à chaque image tant que ce n'est pas elle qui
  // est à l'écran — après un changement de titre, par exemple.
  _tenirVerrou() {
    if (!this._verrou || this._transition || this._armed) return;
    if (this._currentKey === this._verrou) return;
    const profile = this._lastProfile;
    const viz = getCandidate(this._verrou);
    if (!profile || !viz) return;
    this._forcedId = null;           // _appliquerChoix passe par _armSwap, pas par pickComposition
    this._appliquerChoix(viz, profile);
    this._forcedId = this._verrou;
  }

  // ÉPINGLER, c'est-à-dire tenir. pickComposition pose un choix que
  // l'orchestration reprend ensuite à son compte : la composition change de
  // nouveau au bout de sa durée. Ce n'est pas ce qu'on veut d'une console VDJ,
  // où cliquer une vignette doit la garder à l'écran jusqu'au clic suivant.
  //
  // Le mécanisme existait déjà pour ?force=<id> : _forcedId court-circuite le
  // choix et redécide toujours la même chose. On le pose à la main ici, et
  // null rend la main à l'orchestration.
  epinglerComposition(id) {
    if (this._verrou) return null;   // le verrou d'administration tient
    if (id == null) { this._forcedId = null; return null; }
    // pickComposition refuse quand un épinglage est en cours — il faut donc
    // lever l'ancien avant de poser le nouveau, sinon on reste bloqué sur la
    // première vignette cliquée.
    const precedent = this._forcedId;
    this._forcedId = null;
    const pris = this.pickComposition(id);
    this._forcedId = pris ? id : precedent;
    return pris;
  }

  estEpinglee() { return this._forcedId; }

  // Le même geste que stepComposition, mais vers une composition NOMMÉE —
  // celle sur laquelle on vient de cliquer. Refusée si elle n'est pas dans le
  // vivier : le principe tient à ça, on n'atteint jamais un visuel que
  // l'orchestrateur n'aurait pas pris lui-même.
  pickComposition(id) {
    const profile = this._lastProfile;
    if (!profile || this._forcedId || this._transition || this._verrou) return null;
    const pool = selectDanceabilityPool(this._libEligible(profile), danceIndex(profile), undefined, danceSeed(profile));
    let viz = pool.find(function (v) { return v.id === id; });
    // HORS VIVIER, mais offerte à la main : voir OFFERTES_A_LA_MAIN dans
    // visualizer-registry.js. La console la montre en permanence, comme
    // « Écran noir » ; il faut donc pouvoir la jouer quand on clique dessus.
    const aLaMain = !viz && OFFERTES_A_LA_MAIN.indexOf(id) >= 0;
    if (aLaMain) viz = getCandidate(id);
    if (!viz) return null;
    const pris = this._appliquerChoix(viz, profile);
    // ET ELLE NE DOIT PAS ÊTRE ÉVINCÉE DANS LA FOULÉE. La porte d'éligibilité
    // tourne à chaque image contre le titulaire ; sans cette marque, une
    // composition choisie à la main hors de sa porte disparaîtrait à l'image
    // suivante et le clic paraîtrait sans effet. Un choix explicite de la
    // console VDJ n'est pas une sélection automatique : c'est quelqu'un qui
    // décide, et la porte existe pour brider l'orchestration, pas la personne.
    if (pris && aLaMain) this._choisiAMain = id;
    return pris;
  }

  // Le corps commun aux deux : coupe immédiate, puis la décision est traitée
  // comme une vraie — elle entre dans _history et reçoit une durée complète,
  // donc l'orchestration REPART DE LÀ au lieu de la recouvrir aussitôt.
  _appliquerChoix(viz, profile) {
    // Un choix à la main (Video DJ, flèches) est une visualisation jouée
    // comme une autre : elle ne repassera pas dans ce morceau.
    this._jouees.add(viz.id);
    const features = profile.trackFeatures;
    const duration = computeCompositionDuration(
      profile.director ? profile.director.mode : null,
      features && features.bpm,
      danceIndex(profile) * 100,
      features && features.energy
    );
    const decision = {
      mode: 'orchestrated',
      layers: [viz.id],
      primary: viz.id,
      changed: true,
      scored: [{ id: viz.id, viz: viz, score: 0 }],
      desiredDurationSeconds: duration.desiredSeconds,
      scheduledDurationSeconds: duration.scheduledSeconds
    };
    this._armSwap(this._decisionToKey(decision), decision, profile, { forceImmediate: true, forceType: 'CUT' });
    this._scheduleNext(decision);
    return viz.id;
  }

  getLightRig() {
    if (this._mode === 'fallback') return this._fallback ? this._fallback.getLightRig() : null;
    if (this._mode === 'spotwall') return this._spotwall ? this._spotwall.getLightRig() : null;
    if (this._mode === 'portal') return this._portal ? this._portal.getLightRig() : null;
    if (this._mode === 'neonparticles') return this._neonparticles ? this._neonparticles.getLightRig() : null;
    if (this._mode === 'daftpyramid') return this._daftpyramid ? this._daftpyramid.getLightRig() : null;
    if (this._mode === 'mainstage') return this._mainstage ? this._mainstage.getLightRig() : null;
    if (this._mode === 'pulsecore') return this._pulsecore ? this._pulsecore.getLightRig() : null;
    if (this._mode === 'halftone') return null; // no rig: ink on paper
    if (this._mode === 'loom') return null;     // no rig: cloth on paper
    if (this._mode === 'vinylgroove') return null;  // no rig: analytic lights only
    if (this._mode === 'typeslam') return null;     // no rig: one quad, one shader
    if (this._mode === 'kaleidodrift') return null; // no rig: one quad, one shader
    if (this._mode === 'caustics') return null; // no rig: one quad, one Points cloud
    if (this._mode === 'aurora') return null;   // no rig: emission and stars only
    if (this._mode === 'reed') return null;     // no rig: a field at dusk
    if (this._mode === 'frost') return null;    // no rig: ice on glass
    if (this._mode === 'gallery') return null;   // no rig: one quad, one photograph
    if (this._mode === 'prism') return null;     // no rig: the beam is the only light
    if (this._mode === 'splitflap') return null; // no rig: flat quads, baked lighting
    if (this._mode === 'shoji') return null;     // no rig: occlusion, nothing emits
    if (this._mode === 'sand') return null;      // no rig: analytic light only
    if (this._mode === 'chromeflux') return null; // no rig: matcap, not lit
    if (this._mode === 'constellation') return null; // no rig: a night sky
    if (this._mode === 'phosphorscope') return null; // no rig: a scope trace, not a stage
    if (this._mode === 'drostedive') return null; // no rig: one quad, one shader
    if (this._mode === 'tunnel') return this._tunnel ? this._tunnel.getLightRig() : null;
    if (this._mode === 'lasergrid') return null;  // no rig: black deck, drawn light
    if (this._mode === 'lasercathedral') return this._lasercathedral ? this._lasercathedral.getLightRig() : null;
    if (this._mode === 'kineticrig') return this._kineticrig ? this._kineticrig.getLightRig() : null;
    if (this._mode === 'particles') return this._rig;
    return null;
  }

  // The post-processing overrides of the composition CURRENTLY on screen, for
  // scene-manager's _syncPostProfile. Composition instances are stored as
  // this._<mode> throughout this file (this._gallery for mode 'gallery', and
  // so on), so this reads the live one by name rather than needing a branch
  // per composition - a new visualizer with a POST_PROFILE is picked up here
  // without touching this method.
  get postProcessing() {
    const inner = this['_' + this._mode];
    return inner && inner.postProcessing ? inner.postProcessing : null;
  }

  // Same forwarding for the overlay-hiding contract (see scene-manager's
  // _syncPostProfile) - a composition that hides the DOM overlay keeps
  // working when reached through the rotation, not only from the switcher.
  get hideOverlay() {
    const inner = this['_' + this._mode];
    return !!(inner && inner.hideOverlay);
  }

  // Same forwarding as hideOverlay above, for the narrower "hide the cover
  // image, keep the text" contract (shatter.js) - without it the flag works
  // from the debug switcher and silently does nothing in the rotation.
  get hideOverlayArtwork() {
    const inner = this['_' + this._mode];
    return !!(inner && inner.hideOverlayArtwork);
  }

  // Exposed for the discrete data bar (see main.js) - the orchestrator's
  // most recent decision.
  getLastDecision() {
    return this._lastDecision;
  }

  dispose() {
    this._disposeActive();
  }
}
